// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 23.3 23.3%27%3E%3Cpath fill=%27%23DD4901%27 d=%27M2.468,18.934c-3.945-6.559-2.946-11.646,1.48-15.935c2.779-2.692,5.046-2.207,5.05-1.587c0.068,5.693-1.315,10.989-2.651,16.416C5.577,21.34,4.801,22.346,2.468,18.934zM12.678,8.46c-1.176-2.493-4.838-8.884,0.136-8.438c9.13-0.013,13.601,13.388,8.224,16.806C20.042,17.618,14.552,12.342,12.678,8.46z%27/%3E%3Cpath fill=%27%23DD4901%27 d=%27M7.553,21.31c-0.324-0.784-0.349-1.759,0.109-3.124c1.411-4.204,6.672-5.216,9.51-1.832C21.784,21.567,10.281,25.967,7.553,21.31z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8zm4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5z%27/%3E%3Cpath d=%27M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M9.828 5.172a.5.5 0 0 0-.707 0L5.025 9.268V6.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H8.5a.5.5 0 0 0 0-1H5.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 5.656a.5.5 0 0 0 .707 0l4.096-4.096V9.5a.5.5 0 0 0 1 0V5.525a.5.5 0 0 0-.5-.5H15.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707z%27 transform=%27translate%28-4 -1%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z%27/%3E%3Cpath d=%27M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z%27/%3E%3Cpath d=%27M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z%27/%3E%3Cpath d=%27M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414l-3.879-3.879zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0v1.829Zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707L14 2.707ZM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707L7.293 4Zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1h1.829Zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1h1.829ZM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707L13.293 10ZM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0v1.829Zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0L8.354 9.06Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13ZM1.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5H5V1H1.5ZM10 15V1H6v14h4Zm1 0h3.5a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5H11v14Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z%27/%3E%3Cpath d=%27M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z%27/%3E%3Cpath fill-rule=%27evenodd%27 d=%27M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z%27/%3E%3Cpath d=%27m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z%27/%3E%3Cpath d=%27M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z%27/%3E%3Cpath fill-rule=%27evenodd%27 d=%27M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z%27/%3E%3Cpath d=%27M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z%27/%3E%3Cpath d=%27M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 4a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-1 0V4.5A.5.5 0 0 1 8 4M3.732 5.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707M2 10a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 10m9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5m.754-4.246a.39.39 0 0 0-.527-.02L7.547 9.31a.91.91 0 1 0 1.302 1.258l3.434-4.297a.39.39 0 0 0-.029-.518z%27/%3E%3Cpath fill-rule=%27evenodd%27 d=%27M0 10a8 8 0 1 1 15.547 2.661c-.442 1.253-1.845 1.602-2.932 1.25C11.309 13.488 9.475 13 8 13c-1.474 0-3.31.488-4.615.911-1.087.352-2.49.003-2.932-1.25A8 8 0 0 1 0 10m8-7a7 7 0 0 0-6.603 9.329c.203.575.923.876 1.68.63C4.397 12.533 6.358 12 8 12s3.604.532 4.923.96c.757.245 1.477-.056 1.68-.631A7 7 0 0 0 8 3%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z%27/%3E%3Cpath d=%27M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M9.669.864 8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68zm1.196 1.193.684 1.365 1.086 1.072L12.387 6l.248 1.506-1.086 1.072-.684 1.365-1.51.229L8 10.874l-1.355-.702-1.51-.229-.684-1.365-1.086-1.072L3.614 6l-.25-1.506 1.087-1.072.684-1.365 1.51-.229L8 1.126l1.356.702z%27/%3E%3Cpath d=%27M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27m.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0z%27/%3E%3Cpath d=%27M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5%27/%3E%3Cpath d=%27M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2%27/%3E%3Cpath d=%27M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.5.5 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89zM3.777 3h8.447L8 1zM2 6v7h1V6zm3 0v7h1V6zm3 0v7h1V6zm3 0v7h1V6zm3 0v7h1V6zm-.5 8h-11l-.25 1h11.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zM0 11.5A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4.5.5A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0%27/%3E%3Cpath d=%27M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2%27/%3E%3Cpath d=%27M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M14 10a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zM2 9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2z%27/%3E%3Cpath d=%27M5 11.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M14 3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z%27/%3E%3Cpath d=%27M5 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z%27/%3E%3Cpath fill-rule=%27evenodd%27 d=%27M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z%27/%3E%3Cpath fill-rule=%27evenodd%27 d=%27M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z%27/%3E%3Cpath d=%27M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16%27/%3E%3Cpath d=%27M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z%27/%3E%3Cpath d=%27M6.5 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-9 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-9 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 6%27%3E%3Cpath fill=%27%23005094%27 d=%27M0 0h10L5 6z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.75.75 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath fill-rule=%27evenodd%27 d=%27M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Hostsharing corporate design theme, palette from
 * https://www.hostsharing.net: blue #005094 (primary), orange #dd4901
 * (logo and accents only), light #f8f9fa page background, white
 * content surfaces, #dee2e6 borders.
 */

:root {
  --hs-blue: #005094;
  --hs-blue-dark: #004076;
  --hs-blue-pale: #d9e4f2;
  --hs-orange: #dd4901;
  --hs-danger: #940050;
  --hs-text: #212529;
  --hs-text-muted: #6c757d;
  --hs-bg-subtle: #f8f9fa;
  --hs-border: #dee2e6;
  --hs-font:
    system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans',
    'Liberation Sans', Arial, sans-serif;
  /* www.hostsharing.net draws its blocks square (\`rounded-0\`) and
     leaves the rounding to the controls — a surface is set apart by
     its colour, a button by its shape */
  --hs-radius-surface: 0;
  --hs-radius-control: 4px;
  /* www.hostsharing.net puts the whole page into one centered column,
     its Bootstrap \`.container-lg\`. That container is not one width but
     a ladder, and taking only the middle rung of it left this app
     narrower than the site on every wide monitor — so the rungs are
     mirrored below. Under the first one the column fills the window,
     as it does there. A table wider than the space left next to the
     sidebar scrolls inside its own box, and the width toggle lifts
     the cap altogether for whoever wants the whole window. */
  --hs-page-width: none;
}

@media (min-width: 992px) {
  :root {
    --hs-page-width: 960px;
  }
}

@media (min-width: 1200px) {
  :root {
    --hs-page-width: 1140px;
  }
}

@media (min-width: 1400px) {
  :root {
    --hs-page-width: 1320px;
  }
}

/* ---------- base ---------- */

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: var(--hs-bg-subtle);
  color: var(--hs-text);
  font-family: var(--hs-font);
  font-size: 16px;
  line-height: 1.5;
}

/* top bar plus content fill the viewport height */
body,
#root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Everything the app shows lives in one column: topbar, shell and
   footer share the same width and the same centre, so a wide window
   frames the app instead of pushing it against its left edge. The
   width toggle in the topbar lifts the cap (see body.wide-layout). */
#root {
  flex: 1;
  width: 100%;
  max-width: var(--hs-page-width);
  margin: 0 auto;
}

/* www.hostsharing.net writes its section headings \`display-6 fw-normal\`
   and leaves everything under them at the 500 Bootstrap gives headings
   anyway: size and blue already set a heading apart, and the bold of
   the browser default only makes it shout. Table headers are not
   headings in this sense and keep the weight they had. */
h1,
h2,
h3,
h4 {
  color: var(--hs-blue);
  font-weight: 400;
  line-height: 1.25;
}

/* below the page heading a heading labels a part of the page rather
   than opening one, and carries the slight extra weight for it */
h3,
h4 {
  font-weight: 500;
}

h1 {
  font-size: 1.6rem;
}

h2 {
  font-size: 1.3rem;
}

a {
  color: var(--hs-blue);
  text-decoration: none;
}

a:hover {
  color: var(--hs-orange);
  text-decoration: underline;
}

pre,
code {
  font-size: 0.875em;
  background: var(--hs-bg-subtle);
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-surface);
}

code {
  padding: 0.1em 0.35em;
  color: var(--hs-blue-dark);
}

pre {
  padding: 0.75rem 1rem;
  overflow-x: auto;
}

/* stray <br/> siblings of the top navigation */
#root > br {
  display: none;
}

/* plain pages (landing, login, user): centered white column — the
   update hint is a sibling of the page, not a page */
#root > div:not(.app-shell):not(.update-notice) {
  flex: 1;
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
  padding: 0.5rem 1.5rem;
  background: #fff;
}

/* ---------- top bar ---------- */

#root > nav {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  background: #fff;
  color: var(--hs-text-muted);
  font-size: 0.9rem;
  border-bottom: 1px solid var(--hs-border);
}

/* brand: Hostsharing logo icon (SVG from hostsharing.net) plus
   wordmark, via CSS to keep the markup untouched */
#root > nav::before {
  content: 'Hostsharing HSAdmin NG';
  margin-right: auto;
  padding-left: 2rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--hs-blue);
  letter-spacing: 0.02em;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat left center / 1.5rem 1.5rem;
}

#root > nav a {
  color: var(--hs-blue);
  font-weight: 500;
  padding: 0.15rem 0.25rem;
}

#root > nav a:hover {
  color: var(--hs-orange);
  text-decoration: none;
}

/* every topbar link carries its icon in front of the label. On phones
   the label gives way (font-size: 0 in the media query) and only the
   icon remains — so the icon has to exist in both states. */
#root > nav a.topbar-link::before {
  content: '';
  display: inline-block;
  width: 1.1em;
  height: 1.1em;
  margin-right: 0.4em;
  vertical-align: -0.2em;
  background-color: currentColor;
  -webkit-mask: var(--btn-icon) no-repeat center / contain;
  mask: var(--btn-icon) no-repeat center / contain;
}

/* bi-house-door */
.topbar-dashboard::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* bi-briefcase */
.topbar-administration::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

/* bi-person — the same icon the sidebar user entry carries */
.topbar-user::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

/* ---------- dashboard shell ---------- */

.app-shell {
  display: flex;
  flex: 1;
}

.app-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

/* White blocks on the light page background, the way the sections on
   www.hostsharing.net are stacked: the content area itself is the grey
   gutter, the page inside it the white surface. */
.app-content > main {
  flex: 1;
  padding: 1rem;
  background: var(--hs-bg-subtle);
}

.app-content > main > * {
  padding: 1.25rem 1.5rem;
  background: #fff;
}

/* except the dashboard, where the cards are the white blocks and the
   grey has to show through between them */
.app-content > main > .overview-grid {
  padding: 0;
  background: none;
}

.app-content > header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.75rem 1.5rem;
  border-bottom: 1px solid var(--hs-border);
  background: #fff;
}

.app-content > header h1 {
  margin: 0;
  font-size: 1.35rem;
}

/* ---------- sidebar ---------- */

.app-sidebar {
  flex-shrink: 0;
  /* collapsed this is the width of the icon rail below the chevron:
     room for a 20px icon plus its padding and the active marker */
  width: 56px;
  background: #fff;
  border-right: 1px solid var(--hs-border);
  padding: 0.75rem 0.5rem;
}

.app-sidebar.is-open {
  width: 250px;
}

.app-sidebar nav br {
  display: none;
}

/* partner selector in the sidebar head, set apart from the menu
   around it by a bit of vertical air */
.partner-selector {
  display: flex;
  align-items: baseline;
  gap: 0.25rem;
  width: 100%;
  margin: 0.75rem 0 1rem;
  padding: 0.4rem 0.5rem;
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-control);
  background: #fff;
  font: 600 0.9rem var(--hs-font);
  color: var(--hs-blue-dark);
}

p.partner-selector {
  border-color: transparent;
}

/* number and name of the current partner: one line, cut off with an
   ellipsis rather than wrapped — the sidebar head must keep its
   height, and the tooltip carries the full text (the option list
   below spells it out and may wrap) */
.partner-selector-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* filterable dropdown: toggle button + popup with filter input and
   option list; the popup overlays the sidebar content below */
.partner-selector-wrapper {
  position: relative;
}

.partner-selector-toggle {
  text-align: left;
  cursor: pointer;
}

/* the arrow keeps its width whatever the label does */
.partner-selector-toggle::after {
  content: '▾';
  flex: none;
  color: var(--hs-blue);
}

.partner-selector-popup {
  position: absolute;
  z-index: 10;
  left: 0;
  right: 0;
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-control);
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.partner-selector-filter {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 0.4rem 0.5rem;
  border: 0;
  border-bottom: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-control) var(--hs-radius-control) 0 0;
  font: 0.9rem var(--hs-font);
}

.partner-selector-options {
  margin: 0;
  padding: 0.25rem 0;
  list-style: none;
  max-height: 40vh;
  overflow-y: auto;
}

/* here the name is written out in full and wraps if it has to — the
   list is what one reads to pick a partner */
.partner-selector-option {
  padding: 0.3rem 0.5rem;
  font: 600 0.9rem var(--hs-font);
  color: var(--hs-blue-dark);
  cursor: pointer;
  overflow-wrap: anywhere;
}

.partner-selector-option.is-active {
  background: var(--hs-blue-pale);
}

/* "all partners" stands apart from the concrete partners below it */
.partner-selector-option.all-partners {
  margin-bottom: 0.35rem;
  padding-bottom: 0.55rem;
  border-bottom: 1px solid var(--hs-border);
}

.partner-selector-option[aria-selected='true'] {
  color: var(--hs-blue);
}

/* what the Magic Search found this partner by — the one line above it
   shows number and name and nothing else, so a match in a mail address
   or a phone number would otherwise stand there unexplained */
.partner-selector-hint {
  display: block;
  font: italic 0.8rem var(--hs-font);
  color: var(--hs-text-muted);
  overflow-wrap: anywhere;
}

.partner-selector-empty {
  padding: 0.3rem 0.5rem;
  font: italic 0.9rem var(--hs-font);
  color: var(--hs-text-muted);
}

/* the same choice out of the collapsed rail: a dropdown hanging off a
   56px column would be narrower than any partner name, so it opens as
   a dialog with the room the names need */
.partner-dialog {
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-surface);
  padding: 1rem 1.5rem;
  width: min(26rem, 92vw);
}

.partner-dialog::backdrop {
  background: rgb(0 0 0 / 30%);
}

.partner-dialog h2 {
  margin-top: 0;
}

.partner-dialog .partner-selector-filter {
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-control);
}

.partner-dialog .partner-selector-options {
  max-height: 60vh;
}

/* key indicator next to the page title while project roles are
   assumed; links to the project area, the tooltip names the entered
   projects */
.assumed-role-indicator {
  color: var(--hs-orange);
  line-height: 1;
}

.assumed-role-indicator:hover {
  color: var(--hs-orange);
}

/* bi-key */
.assumed-role-indicator::before {
  content: '';
  display: inline-block;
  width: 1.25em;
  height: 1.25em;
  vertical-align: -0.25em;
  background-color: currentColor;
  -webkit-mask: var(--btn-icon) no-repeat center / contain;
  mask: var(--btn-icon) no-repeat center / contain;
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

/* width toggle, right before the language buttons: icon only, in the
   same muted topbar tone. bi-arrows-angle-expand while the content is
   held at its readable width, bi-arrows-angle-contract while it uses
   the whole window — the icon shows what the click will do. */
.width-toggle {
  padding: 0.1rem 0.35rem;
  border: 1px solid transparent;
  color: var(--hs-text-muted);
  line-height: 1;
}

.width-toggle::before {
  content: '';
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  background-color: currentColor;
  -webkit-mask: var(--btn-icon) no-repeat center / contain;
  mask: var(--btn-icon) no-repeat center / contain;
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.width-toggle.is-wide {
  border-color: var(--hs-border);
  color: var(--hs-blue-dark);
}

.width-toggle.is-wide::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

/* the whole window width instead of the readable one; the padding of
   the content area stays, a table flush against the window edge would
   look cramped */
body.wide-layout #root,
body.wide-layout table,
body.wide-layout .crud-table,
body.wide-layout .crud-table-region,
body.wide-layout #root > div:not(.app-shell):not(.update-notice) {
  max-width: none;
}

/* language toggle at the right end of the topbar */
.language-switcher {
  display: inline-flex;
  gap: 0.25rem;
}

.language-switcher button {
  padding: 0.1rem 0.45rem;
  font-size: 0.8rem;
  border: 1px solid transparent;
  color: var(--hs-text-muted);
}

.language-switcher button[aria-pressed='true'] {
  border-color: var(--hs-border);
  color: var(--hs-blue-dark);
  font-weight: 600;
}

/* the phone-only cycle button (see the media query below) */
.language-switcher .language-cycle {
  display: none;
  border-color: var(--hs-border);
  color: var(--hs-blue-dark);
  font-weight: 600;
}

/* menu group headings (Verwaltung / Hosting) */
.app-sidebar .nav-group {
  margin: 0.75rem 0.5rem 0.25rem;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--hs-text-muted);
}

/* The heading is also the fold toggle of its area: it keeps looking
   like the heading — only the small triangle says it folds — so the
   flat-menu-button look every sidebar button gets is taken back here.
   The padding is negated by the margin: the text stays where the
   plain heading stands, the touch target grows around it. */
.app-sidebar .nav-group-toggle {
  width: auto;
  padding: 0.2rem 0.4rem;
  margin: -0.2rem -0.4rem;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
}

/* the fold marker follows the heading text, as such menus usually
   carry it: a chevron (bi-chevron-down) pointing down while the area
   is open, right while it is folded away */
.app-sidebar .nav-group-toggle::after {
  content: '';
  display: inline-block;
  width: 0.7em;
  height: 0.7em;
  margin-left: 0.4em;
  background-color: currentColor;
  -webkit-mask: var(--fold-icon) no-repeat center / contain;
  mask: var(--fold-icon) no-repeat center / contain;
  --fold-icon: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  transform: rotate(-90deg);
}

.app-sidebar .nav-group-toggle[aria-expanded='true']::after {
  transform: none;
}

.app-sidebar .nav-group-toggle:hover {
  background: none;
  color: var(--hs-blue-dark);
}

.app-sidebar a {
  display: block;
  padding: 0.4rem 0.75rem;
  margin: 0.1rem 0;
  border-radius: var(--hs-radius-control);
  border-left: 3px solid transparent;
}

.app-sidebar a:hover {
  background: var(--hs-blue-pale);
  color: var(--hs-blue-dark);
  text-decoration: none;
}

.app-sidebar a.active {
  border-left-color: var(--hs-orange);
  background: var(--hs-blue-pale);
  color: var(--hs-blue-dark);
  font-weight: 600;
}

/* flat buttons (toggle, accordions, logout) */
.app-sidebar button {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.4rem 0.75rem;
  margin: 0.1rem 0;
  background: none;
  border: none;
  border-radius: var(--hs-radius-control);
  color: var(--hs-blue);
  font: 500 0.95rem var(--hs-font);
  cursor: pointer;
}

.app-sidebar button:hover {
  background: var(--hs-blue-pale);
  color: var(--hs-blue-dark);
}

/* the partner selector keeps more vertical air than the flat menu
   buttons around it (same margins as its <p> variants above) and stays
   the flex row that clips its label — the rule above turns every
   sidebar button into a block */
.app-sidebar button.partner-selector {
  display: flex;
  margin: 0.75rem 0 1rem;
}

/* the logout action indents like the nav links around it (the same
   3px slot their active-marker border occupies), slightly set off
   vertically from the entries above */
.app-sidebar .nav-logout {
  margin: 0.75rem 0 0.25rem;
}

.app-sidebar .nav-logout button {
  border-left: 3px solid transparent;
}

/* collapse/expand chevron («/», label via title/aria-label),
   sitting at the sidebar's inner edge as usual for such menus */
.app-sidebar > button {
  padding: 0.4rem 0.5rem;
  font-size: 1.1rem;
  line-height: 1;
  text-align: right;
  color: var(--hs-text-muted);
}

/* the collapsed sidebar keeps a rail of icon-only links below the
   chevron, so a narrowed window or a tablet does not lose the
   navigation altogether. The labels live in title/aria-label. */
.app-sidebar .nav-rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.5rem;
}

.app-sidebar .nav-rail a,
.app-sidebar .nav-rail button {
  width: auto;
  padding: 0.4rem;
  /* the active marker takes a 3px border on the left; a matching
     transparent one on the right keeps the icon centred in the rail */
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  color: var(--hs-blue);
  line-height: 0;
}

/* the group separator; the headings themselves are too wide here */
.app-sidebar .nav-rail hr {
  width: 60%;
  margin: 0.4rem 0;
  border: none;
  border-top: 1px solid var(--hs-border);
}

/* ---------- buttons ---------- */

button {
  font-family: var(--hs-font);
  font-size: 0.9rem;
  padding: 0.4rem 1rem;
  border-radius: var(--hs-radius-control);
  border: 1px solid var(--hs-blue);
  background: #fff;
  color: var(--hs-blue);
  cursor: pointer;
  transition:
    background-color 0.15s,
    color 0.15s;
}

button:hover:not(:disabled) {
  background: var(--hs-blue);
  color: #fff;
}

button:disabled {
  border-color: var(--hs-border);
  color: var(--hs-text-muted);
  cursor: not-allowed;
}

/* Primary actions. There is no filled button anywhere on
   www.hostsharing.net — even its calls to action are drawn as an
   outline — so the primary action is not marked by a blue block but
   by a heavier border and a firmer label. The hover it shares with
   every other button fills it blue, which is where the colour comes
   in. */
button[type='submit'],
.contact-submit button,
.contact-create button,
.person-submit button,
.person-create button,
.subscription-submit button {
  border-width: 2px;
  /* taken back out of the padding: the thicker border would otherwise
     make the button taller than the ones standing next to it */
  padding: calc(0.4rem - 1px) calc(1rem - 1px);
  font-weight: 500;
}

/* ---------- button icons ---------- */

/* Bootstrap Icons as SVG masks; currentColor keeps them in the
   button's text color, also on hover */
.btn-reload::before,
.btn-create::before,
.btn-filter::before,
.btn-filter-mode::before,
.btn-filter-clear::before,
.btn-show-all::before,
.btn-download::before,
.btn-copy::before,
.btn-magnify::before,
.btn-delete::before,
.btn-edit::before,
.btn-goto::before,
.resources-hint::before,
.contact-create > button::before,
.contact-submit > button::before,
.person-submit > button::before,
.person-create > button::before,
.subscription-submit > button::before,
.app-sidebar nav p.nav-logout button::before,
.app-sidebar .nav-rail button::before,
.app-sidebar a.nav-icon::before,
.bookmark-area::before,
.bookmark-toggle::before,
.btn-page-back::before,
.btn-page-on::before,
.btn-calendar::before,
.btn-month-back::before,
.btn-month-on::before,
.btn-cancel::before,
.btn-close::before,
.btn-reset::before,
.confirm-dialog-confirm button::before,
button[type='submit'][form]::before,
form button[type='submit']::before {
  content: '';
  display: inline-block;
  width: 1em;
  height: 1em;
  margin-right: 0.45em;
  vertical-align: -0.125em;
  background-color: currentColor;
  -webkit-mask: var(--btn-icon) no-repeat center / contain;
  mask: var(--btn-icon) no-repeat center / contain;
}

/* bi-arrow-clockwise — icon-only reload in the table header */
/* icon buttons in the tables — the header tools (filter, reload, add,
   filter-row eraser) and the data-row actions (edit, delete, download,
   copy-uuid). Deliberately discreet: small square buttons in muted
   grey that only pick up an accent colour on hover, so they never
   compete with the content next to them. */
.btn-reload,
.btn-create,
.btn-filter,
.btn-filter-mode,
.btn-filter-clear,
.btn-show-all,
.btn-close,
.btn-edit,
.btn-goto,
.btn-delete,
.btn-download,
.btn-copy {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.4rem;
  height: 1.4rem;
  padding: 0;
  font-size: 0.8rem;
  line-height: 1;
  border-color: var(--hs-border);
  color: var(--hs-text-muted);
}

/* flex-centered: the icon carries no trailing gap of its own */
.btn-reload::before,
.btn-create::before,
.btn-filter::before,
.btn-filter-mode::before,
.btn-filter-clear::before,
.btn-show-all::before,
.btn-close::before,
.btn-edit::before,
.btn-goto::before,
.btn-delete::before,
.btn-download::before,
.btn-copy::before {
  margin-right: 0;
}

.btn-reload:hover:not(:disabled),
.btn-create:hover:not(:disabled),
.btn-filter:hover:not(:disabled),
.btn-filter-mode:hover:not(:disabled),
.btn-filter-clear:hover:not(:disabled),
.btn-show-all:hover:not(:disabled),
.btn-close:hover:not(:disabled),
.btn-edit:hover:not(:disabled),
.btn-goto:hover:not(:disabled),
.btn-download:hover:not(:disabled),
.btn-copy:hover:not(:disabled) {
  background: #fff;
  border-color: var(--hs-blue);
  color: var(--hs-blue);
}

/* An action the reader is not allowed to take stays in place — what a
   table can do is part of its picture — but pales, so the eye passes
   over it; its tooltip says why (see \`writeDenied\` in CrudTable). The
   muted grey alone would not show it, that is the resting colour of
   every icon button here. */
.btn-create:disabled,
.btn-edit:disabled,
.btn-delete:disabled {
  opacity: 0.45;
}

/* deleting stays destructive — but only on hover, so the row icon is
   as quiet as its neighbours until it is aimed at */
.btn-delete:hover:not(:disabled) {
  background: #fff;
  border-color: var(--hs-danger);
  color: var(--hs-danger);
}

/* An icon button that carries its label. The btn-* class beside it
   says which icon; this one takes back the small square shape of the
   table tools, because outside a data row there is room to name what
   the button does — and a named button is what the detail views use.
   Every button in the app carries an icon in front of its label; only
   the tabs and the language switch do not, being no actions. */
.btn-labelled {
  float: none;
  width: auto;
  height: auto;
  margin: 0;
  padding: 0.4rem 1rem;
  font-size: 0.9rem;
  /* back to the browser default the plain buttons use — inheriting the
     1.5 of the body would leave this one taller than the button it
     stands next to */
  line-height: normal;
  border-color: var(--hs-blue);
  color: var(--hs-blue);
}

/* The icon regains the gap the icon-only rules take from it. Each of
   those sets \`margin-right: 0\` next to its own \`--btn-icon\` further
   down, so a plain \`.btn-labelled::before\` would lose on source order
   alone; qualifying it with the element keeps it winning wherever the
   next icon rule is added. */
button.btn-labelled::before {
  margin-right: 0.45em;
}

.btn-labelled:hover:not(:disabled) {
  background: var(--hs-blue);
  color: #fff;
}

/* a named delete says so before it is aimed at: unlike the quiet row
   icon it wears the warning colour at rest, as the contact and person
   delete buttons do */
.btn-delete.btn-labelled {
  border-color: var(--hs-danger);
  color: var(--hs-danger);
}

.btn-delete.btn-labelled:hover:not(:disabled) {
  background: var(--hs-danger);
  color: #fff;
}

/* bi-x-lg — dismisses without saving: cancel, close */
.btn-cancel::before,
.btn-close::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

/* The upper cross keeps to the right edge of the heading line, the
   corner a window is closed in: \`margin-left: auto\` pushes it there
   past the flexible title. */
.page-head .btn-close {
  margin-left: auto;
}

/* The lower one is a named button and stands where a row of buttons
   begins — at the left edge, as the actions under a form do. The
   corner it leaves free is the one the back-to-top button floats in
   once the page has been scrolled. */
.page-close {
  display: flex;
  justify-content: flex-start;
  margin: 1.5rem 0 0;
}

/* bi-arrow-counterclockwise — puts something back as it was */
.btn-reset::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.btn-reload {
  float: right;
  margin-left: 0.35rem;
}

/* add-a-row button in the table header, next to reload */
.btn-create {
  float: right;
  margin-left: 0.35rem;
}

/* bi-plus-lg */
.btn-create::before {
  margin-right: 0;
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.btn-reload::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  margin-right: 0;
}

/* bi-search — toggles the filter/search row in the table header */
.btn-filter {
  margin-left: 0.35rem;
}

.btn-filter::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  margin-right: 0;
}

.btn-filter.active {
  border-color: var(--hs-blue);
  color: var(--hs-blue);
}

/* bi-eye — widens the grants list to everything visible (REQ_006);
   pressed it stands out like the open search, since both change
   what the table shows rather than doing something once */
.btn-show-all::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  margin-right: 0;
}

.btn-show-all.active {
  border-color: var(--hs-blue);
  color: var(--hs-blue);
}

/* bi-eraser — clears all criteria in the open filter row */

.btn-filter-clear::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  margin-right: 0;
}

/* The face-switch of the search row (see CrudTable): each shows where
   it leads, not where one stands. bi-magic — the wand of the Magic
   Search — where the row filters per column; bi-layout-three-columns
   for the way back. */
.btn-filter-mode.magic::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.btn-filter-mode.columns::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

/* bi-download — icon-only download in table rows (label via title) */
.btn-download::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  margin-right: 0;
}

/* icon-only delete in table rows (label via title/aria-label) */
/* bi-box-arrow-up-right — jumps to the record's own detail page */
.btn-goto::before {
  margin-right: 0;
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

/* bi-info-circle — the resource values of a booking, told in the
   tooltip: the navigation table of the projects page keeps no details
   below it, a click navigates away. The box of the framed icon
   buttons, only without their frame, so the action cell lines up. */
.resources-hint {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.4rem;
  height: 1.4rem;
  color: var(--hs-text-muted);
  cursor: help;
  font-size: 0.8rem;
}

.resources-hint::before {
  margin-right: 0;
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}

/* Icons that belong to the value right in front of them — the uuid
   copy button and the jump to a referenced record, in the details as
   in a data cell. They are part of the text flow, so they get no
   frame and sit small, close and slightly raised; only the buttons
   that stand on their own (the table's action column, the page head)
   keep their frame. */
.master-data .btn-goto,
.master-data .btn-copy,
td .btn-goto,
.claims-table .btn-copy {
  width: 1.1rem;
  height: 1.1rem;
  margin-left: 0.3rem;
  padding: 0;
  border: 0;
  background: none;
  font-size: 0.65rem;
  vertical-align: 0.3em;
}

.master-data .btn-goto:hover:not(:disabled),
.master-data .btn-copy:hover:not(:disabled),
td .btn-goto:hover:not(:disabled),
.claims-table .btn-copy:hover:not(:disabled) {
  background: none;
  color: var(--hs-blue);
}

/* bi-pencil — edit action in a table row */
.btn-edit::before {
  margin-right: 0;
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.btn-delete::before {
  margin-right: 0;
}

/* icon-only copy to clipboard (label via title/aria-label) */
.btn-copy {
  margin-left: 0.6rem;
}

/* bi-clipboard */
.btn-copy::before {
  margin-right: 0;
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

/* the uuid copy sits flush in table action cells and detail lists
   (the default left margin fits the inline usage on the user page);
   in a table cell the optional delete follows with a small gap */
.crud-table .btn-copy {
  margin-left: 0;
}

/* the buttons carry margins for their use outside a table (the empty
   state floats them, the copy button sits inline on the user page);
   inside the shared flex row the gap alone sets the spacing */
.crud-table .table-tools button,
.detail-tools button {
  margin: 0;
  /* the strip is measured by its buttons (see CrudTable), so no button
     may be squeezed below the size it asks for */
  flex: none;
}

/* bi-check-lg after a successful copy */
.btn-copy.copied::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

/* icon-only magnifier, opens a detail popup (label via title/aria-label) */
.btn-magnify {
  padding: 0.15rem 0.45rem;
  line-height: 1;
}

/* bi-search */
.btn-magnify::before {
  margin-right: 0;
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

/* bi-trash — every ConfirmDialog in the app confirms a deletion, so
   its confirming button carries the same mark as the one that opened
   it (see the "Deleting" section of doc/architecture.md) */
.btn-delete::before,
.confirm-dialog-confirm button::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

/* bi-plus-circle */
.contact-create > button::before,
.person-create > button::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

/* bi-check-lg */
.contact-submit > button::before,
.person-submit > button::before,
.subscription-submit > button::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

/* in the rail the icon is the whole link: bigger than inline, and
   without the gap that would otherwise hold a label. This has to come
   after the shared icon rule above — same specificity, so source order
   decides. */
.app-sidebar .nav-rail a::before,
.app-sidebar .nav-rail button::before {
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0;
}

/* bi-person in front of the sidebar user entry — the same icon the
   topbar user link shrinks to on phones (see the media query below) */
.app-sidebar a.nav-user::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

/* bi-gear in front of the sidebar configuration entry */
.app-sidebar a.nav-config::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

/* bi-speedometer2 — the overview / dashboard landing page */
.app-sidebar a.nav-overview::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

/* bi-building — the partner data */
.app-sidebar a.nav-partner::before,
.bookmark-area.area-partner::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}

/* bi-award — the membership */
.app-sidebar a.nav-membership::before,
.bookmark-area.area-membership::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

/* bi-receipt — the debitors */
.app-sidebar a.nav-debitors::before,
.bookmark-area.area-debitor::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}

/* bi-person-lines-fill — the contacts */
.app-sidebar a.nav-contacts::before,
.bookmark-area.area-contact::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}

/* bi-people — the persons */
.app-sidebar a.nav-persons::before,
.bookmark-area.area-person::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}

/* bi-bank — the bank accounts */
/* bi-journal-text */
.app-sidebar a.nav-bankdirectory::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

.app-sidebar a.nav-bankaccounts::before,
.bookmark-area.area-bankAccount::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}

/* bi-envelope — the mailing lists */
.app-sidebar a.nav-mailinglists::before,
.bookmark-area.area-subscription::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

/* bi-key — the access-rights grants */
.app-sidebar a.nav-grants::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

/* bi-diagram-3 — the hosting projects */
.app-sidebar a.nav-projects::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

/* bi-journal-check — the bookings */
.app-sidebar a.nav-bookings::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}

/* bi-hdd-stack — the hosting assets */
.app-sidebar a.nav-hosting-assets::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}

/* bi-box-arrow-right (logout), in the menu as in the collapsed rail */
.app-sidebar nav p.nav-logout button::before,
.app-sidebar .nav-rail button::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

/* bi-funnel — the partner choice in the collapsed rail: it is not an
   area but the filter every area below it is seen through. More
   specific than the logout rule above, which would otherwise paint
   every button in the rail with its own glyph */
.app-sidebar .nav-rail button.nav-partner-select::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}

/* bi-check-lg — the save button of a form it stands outside of, tied
   to it by the \`form\` attribute. Those buttons sit in the action row
   below the form rather than inside it, which is why the rule for a
   form's own submit does not reach them: they were the ones left
   without a symbol in front of their word. */
button[type='submit'][form]::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

/* bi-box-arrow-in-right (sign-in) */
form button[type='submit']::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}

/* ---------- user page: JWT claims table ---------- */

.claims-table {
  max-width: 40rem;
}

.claims-table th[scope='row'] {
  color: var(--hs-text-muted);
  font-weight: 500;
  font-size: 0.85rem;
  width: 12rem;
}

/* form submit/cancel row */
.form-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem 0;
}

/* let wrapped buttons (e.g. .subscription-submit) align like direct children */
.form-actions > div {
  display: contents;
}

/* The view the mark hangs in: whatever holds the row of actions holds
   the corner it is pinned to (see .bookmark-toggle). Written as a
   question about the row rather than as a list of pages, because the
   pages are a dozen and each of them wraps its actions differently. */
:is(section, div):has(> .form-actions > .bookmark-toggle) {
  position: relative;
}

/* Where the details are tabbed, the mark hangs at the right end of
   the row of tabs. Inside the open tab it sat on whatever began in
   that corner — the toolbar of a table, on half the tabs there is one
   — and it claimed a tab it does not belong to: the record is the
   same whichever tab is open. Room is kept for it at the end of the
   row so it covers no label; as a symbol it needs little. */
.tab-bar:has(> .bookmark-toggle) {
  position: relative;
  padding-right: 2.75rem;
}

/* bi-bookmark — the outline: a mark not set is a mark still empty */
.bookmark-toggle::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_41___});

  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0;
}

/* bi-bookmark-fill — set, and filled with the house blue */
.bookmark-toggle:has(input:checked)::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}

/*
 * The bookmark on the record on display. It is neither one of the
 * values above it nor one of the actions beside it — it changes
 * nothing about the record, only where the reader will find it again
 * — so it wears a shape of its own instead of looking like a form
 * field or a button.
 *
 * That shape is the thing itself: a bookmark, empty and grey while
 * the record is not marked, filled with the house blue once it is.
 * A symbol every reader knows needs no word beside it — the word is
 * in the tooltip, and in the name the checkbox is read out with.
 *
 * It hangs in the upper right corner of the view it belongs to, out
 * of the flow. It used to stand at the end of the row of actions, and
 * on a narrow screen it was the item too many there: a row that
 * cannot fit makes the whole page scroll sideways, and the only thing
 * that may scroll sideways here is a table. Out of the flow it cannot
 * widen anything, whatever the labels beside it are called.
 */
.bookmark-toggle {
  position: absolute;
  top: 0;
  right: 0;
  /* over whatever begins in that corner — the tab bar of a detail
     view, the first box of a form */
  z-index: 1;
  display: inline-flex;
  align-items: center;
  /* the symbol is small; the padding is what a thumb hits */
  margin: 0;
  padding: 0.5rem;
  color: var(--hs-text-muted);
  line-height: 1;
  cursor: pointer;
}

/* the box itself is gone from view; it still takes the click through
   its label, the keyboard through Tab and the space bar, and the
   screen reader through its name */
.bookmark-toggle input {
  position: absolute;
  width: 1px;
  height: 1px;
  max-width: none;
  margin: 0;
  opacity: 0;
  pointer-events: none;
}

.bookmark-toggle:hover {
  color: var(--hs-blue);
}

/* what a hidden box owes the keyboard: a ring where the eye is */
.bookmark-toggle:has(input:focus-visible) {
  border-radius: var(--hs-radius-control);
  outline: 2px solid var(--hs-blue);
  outline-offset: 1px;
}

/* set: visible as such from across the page, not only in the box */
.bookmark-toggle:has(input:checked) {
  color: var(--hs-blue);
}

/* person/contact reference widget: the searchable select plus, when
   "create new" is chosen, the inline fields of that record indented
   below it. Label left of the field, like the forms. */
/* same grid as .master-data, so the field lines up with the values
   shown above it in the same detail block */
.entity-picker-field {
  display: grid;
  /* fixed, not max-content: the contact label is long enough to widen
     the column and would push the field out of line with the values
     shown above it */
  grid-template-columns: 10rem minmax(0, 1fr);
  align-items: start;
  gap: 0.35rem 1.5rem;
  max-width: 34rem;
  margin: 0.4rem 0;
  padding-left: 0.75rem;
  /* the "please check" notice hangs off the field's right edge */
  position: relative;
}

/* a proposed value's word of caution, right beside the field —
   bi-question-circle in the CI's warm accent, its words in the tooltip
   ("please check this proposal"): a symbol beside every proposed field
   says the same thing once, where the spelled-out words would say it
   three times in a row. Absolute, so its leaving does not shift the
   form under the mouse */
/* bi-exclamation-triangle — a bank account the bank directory disagrees with */
.bank-account-issue {
  --issue-icon: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  display: inline-block;
  width: 1em;
  height: 1em;
  margin-left: 0.4em;
  vertical-align: -0.125em;
  background-color: var(--hs-orange);
  -webkit-mask: var(--issue-icon) no-repeat center / contain;
  mask: var(--issue-icon) no-repeat center / contain;
}

.picker-notice {
  --notice-icon: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  position: absolute;
  left: 100%;
  top: 0.5rem;
  display: inline-block;
  width: 1.05rem;
  height: 1.05rem;
  margin-left: 0.75rem;
  background-color: var(--hs-orange);
  -webkit-mask: var(--notice-icon) no-repeat center / contain;
  mask: var(--notice-icon) no-repeat center / contain;
}

/* a plain form field carrying the same notice: a wrapper around the
   label anchors the note beside the field the way the picker fields
   do — outside the label, whose text is the field's name and nothing
   more. The width is the fields' own, so \`left: 100%\` is the same
   edge the picker notices hang off. */
.field-with-notice {
  position: relative;
  max-width: 34rem;
}

.field-with-notice > .picker-notice {
  /* on the first line of the label in the wrapper, margin included */
  top: 0.55rem;
}

/* pulled left by its own border and padding, like every bordered field
   in the forms: the chosen name starts on the column line where the
   plain values stand, not a border's width further in */
.entity-picker-field > .search-select {
  margin-left: calc(-0.6rem - 1px);
}

/* the plain fields sharing this layout — the relation form's type
   select, the mailing list's list select — are pulled left the same
   way, so their boxes stand in one line with the pickers below them;
   the width grows by what the margin takes, keeping the right edge */
.entity-picker-field > select,
.entity-picker-field > input {
  width: calc(100% + 0.6rem + 1px);
  margin-left: calc(-0.6rem - 1px);
}

/* reads like the labels of the detail list it sits in */
.entity-picker-label {
  font-size: 0.85rem;
  color: var(--hs-text-muted);
  padding-top: 0.45rem;
}

.entity-picker > fieldset {
  margin-left: 12.25rem;
  max-width: 23.5rem;
}

/* ---------- searchable select ---------- */

/* Same idea as the partner selector in the sidebar, but as a form
   field: a native <select> can neither show the second line each
   contact needs (its e-mail addresses) nor filter by substring. */
/* the field and its tool side by side: the dropdown takes the width,
   the pencil beside it only what it needs. The popup hangs out of the
   flow (position: absolute below) and is therefore as wide as both. */
.search-select {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 0.35rem;
}

/* level with the first line of the choice, not with the middle of a
   two-line entry */
.search-select-edit {
  margin-top: 0.15rem;
}

/* positioned for the sake of its arrow below: that one belongs to the
   right edge of the field, not to the right edge of the control — and
   the control reaches past the field wherever a pencil stands beside
   it */
.search-select-toggle {
  position: relative;
  display: block;
  width: 100%;
  padding: 0.4rem 1.8rem 0.4rem 0.6rem;
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-control);
  background: #fff;
  color: var(--hs-text);
  font: inherit;
  font-size: 0.95rem;
  line-height: 1.3;
  text-align: left;
}

/* the generic button hover fills with blue — not for a form field */
.search-select-toggle:hover:not(:disabled) {
  background: #fff;
  color: var(--hs-text);
  border-color: var(--hs-blue);
}

/* a choice that is none: the field keeps its shape, so the column
   stays even, but it is subdued and carries no arrow — there is
   nothing to unfold (the anchor in the partner form) */
.search-select-toggle:disabled {
  background: var(--hs-bg-subtle);
  color: var(--hs-text-muted);
  cursor: default;
}

.search-select-toggle::after {
  content: '▾';
  position: absolute;
  right: 0.6rem;
  top: 0.4rem;
  color: var(--hs-blue);
}

.search-select-toggle:disabled::after {
  content: none;
}

.search-select-placeholder {
  color: var(--hs-text-muted);
}

/* caption/name on top, the e-mail addresses (or person type) below */
.search-select-label {
  display: block;
}

.search-select-hint {
  display: block;
  font-size: 0.8rem;
  color: var(--hs-text-muted);
  overflow-wrap: anywhere;
}

/* the hint line standing in for itself: what the Magic Search found
   this entry by, where neither of its two lines shows it. Italic like
   every other remark the lists make about themselves */
.search-select-hint.is-match {
  font-style: italic;
}

/* as wide as the field, not as the control: an out-of-flow child that
   names a grid column hangs below that column, so the list keeps its
   left and right edge even where a pencil stands beside the field */
.search-select-popup {
  position: absolute;
  grid-column: 1 / 2;
  z-index: 10;
  left: 0;
  right: 0;
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-control);
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.search-select-filter {
  display: block;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0.4rem 0.6rem;
  border: 0;
  border-bottom: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-control) var(--hs-radius-control) 0 0;
  font: inherit;
  font-size: 0.9rem;
}

.search-select-options {
  margin: 0;
  padding: 0.25rem 0;
  list-style: none;
  max-height: 40vh;
  overflow-y: auto;
}

.search-select-option {
  padding: 0.35rem 0.6rem;
  cursor: pointer;
}

.search-select-option.is-active {
  background: var(--hs-blue-pale);
}

.search-select-option[aria-selected='true'] .search-select-label {
  font-weight: 600;
  color: var(--hs-blue);
}

.search-select-empty {
  padding: 0.35rem 0.6rem;
  font-style: italic;
  color: var(--hs-text-muted);
}

/* writing a new record is an action, not one of the choices — the rule
   towards the list says which side of the line it stands on. It frames
   the matches, so the top one is ruled off below and the bottom one
   above; alone (nothing matched) it keeps the rule to the message */
.search-select-create {
  color: var(--hs-blue);
}

.search-select-create:first-child {
  border-bottom: 1px solid var(--hs-border);
}

.search-select-create:last-child:not(:first-child) {
  border-top: 1px solid var(--hs-border);
}

@media (max-width: 768px) {
  .entity-picker-field {
    grid-template-columns: 1fr;
    gap: 0.15rem;
  }

  .entity-picker-label {
    padding-top: 0;
  }

  .entity-picker > fieldset {
    margin-left: 0;
    max-width: none;
  }

  /* no room beside the field — the notice falls in below it */
  .picker-notice {
    position: static;
    margin-left: 0;
  }
}

/* ---------- date field with its calendar ---------- */

/* bi-calendar3 — the knob that opens the calendar */
.btn-calendar::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

/* bi-chevron-left / bi-chevron-right — one month back and on */
.btn-month-back::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}

.btn-month-on::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}

/*
 * A day is typed into the field and picked from the calendar behind
 * it. The knob sits inside the field, where the native date input puts
 * its own — a button beside it would make the field look like two
 * things, and the column it stands in is 10rem wide at most.
 */
.date-field {
  position: relative;
  display: block;
}

/* room for the knob, so a typed day never runs under it */
.date-field > input {
  padding-right: 2rem;
}

.btn-calendar {
  position: absolute;
  top: 50%;
  right: 0.15rem;
  transform: translateY(-50%);
  padding: 0.25rem;
  border: 0;
  background: none;
  color: var(--hs-text-muted);
  line-height: 1;
  cursor: pointer;
}

.btn-calendar:hover,
.btn-calendar[aria-expanded='true'] {
  color: var(--hs-blue);
  background: none;
}

.btn-calendar::before {
  width: 1.1rem;
  height: 1.1rem;
  margin-right: 0;
}

/* The calendar hangs under the field, over whatever the form has
   below it. It is as wide as seven days need and no wider: on a
   smartphone the field spans the screen, and a calendar stretched to
   it would be a grid of empty cells. */
.day-picker {
  position: absolute;
  z-index: 10;
  top: calc(100% + 0.25rem);
  left: 0;
  width: 17rem;
  max-width: 100%;
  padding: 0.5rem;
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-control);
  background: #fff;
  box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
}

/* month, year and the two steps in one line: the year is a field
   because a birthday is fifty years of clicking away otherwise */
.day-picker-head {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-bottom: 0.4rem;
}

.day-picker-head select {
  flex: 1;
  min-width: 0;
  color: var(--hs-text);
  font-size: 0.9rem;
}

/* four digits and a little air, and the month keeps the rest of the
   line */
.day-picker-year {
  flex: none;
  width: 4.5rem;
  color: var(--hs-text);
  font-size: 0.9rem;
  text-align: center;
}

.day-picker-head button {
  flex: none;
  padding: 0.25rem 0.4rem;
  border: 0;
  background: none;
  color: var(--hs-text-muted);
  line-height: 1;
  cursor: pointer;
}

.day-picker-head button:hover {
  color: var(--hs-blue);
  background: none;
}

.day-picker-head button::before {
  width: 0.9rem;
  height: 0.9rem;
  margin-right: 0;
}

.day-picker-grid {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.day-picker-grid th {
  padding: 0.15rem 0;
  border: 0;
  background: none;
  color: var(--hs-text-muted);
  font-size: 0.75rem;
  font-weight: 400;
  text-align: center;
}

.day-picker-grid td {
  padding: 0;
  border: 0;
  text-align: center;
}

.day-picker-grid button {
  width: 100%;
  padding: 0.3rem 0;
  border: 0;
  border-radius: var(--hs-radius-control);
  background: none;
  color: var(--hs-text);
  font-size: 0.85rem;
  cursor: pointer;
}

.day-picker-grid button:hover {
  background: var(--hs-blue-pale);
  color: var(--hs-blue-dark);
}

/* today is a hint, the picked day is the answer — hence the ring for
   the one and the filled field for the other */
.day-picker-grid button.is-today {
  box-shadow: inset 0 0 0 1px var(--hs-border);
  font-weight: 600;
}

.day-picker-grid button.is-selected {
  background: var(--hs-blue);
  color: #fff;
}

/* fallback while a lazily loaded page chunk is being fetched */
.page-loading {
  padding: 1rem;
  color: var(--hs-text-muted);
}

/* section heading with the token action buttons to its right */
.page-head {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.page-head h1,
.page-head h2 {
  margin: 0;
}

.token-actions {
  display: flex;
  gap: 0.5rem;
}

/* ---------- friendly API error box ---------- */

.error-notice {
  max-width: 40rem;
  margin: 1rem 0;
  padding: 0.75rem 1rem;
  border: 1px solid color-mix(in srgb, var(--hs-danger) 30%, #fff);
  border-left: 4px solid var(--hs-danger);
  border-radius: var(--hs-radius-surface);
  background: color-mix(in srgb, var(--hs-danger) 5%, #fff);
}

.error-notice-message {
  margin: 0;
  font-weight: 500;
  color: var(--hs-text);
}

.error-notice-retry {
  margin-top: 0.6rem;
}

/* inline error above the form actions: a compact danger box matching
   the page-level .error-notice, never a raw technical string */
.form-error {
  max-width: 32rem;
  margin: 0.75rem 0;
  padding: 0.5rem 0.75rem;
  border: 1px solid color-mix(in srgb, var(--hs-danger) 30%, #fff);
  border-left: 4px solid var(--hs-danger);
  border-radius: var(--hs-radius-surface);
  background: color-mix(in srgb, var(--hs-danger) 5%, #fff);
  color: var(--hs-text);
  font-weight: 500;
}

/* ---------- configuration page ---------- */

.config-page section {
  max-width: 40rem;
  margin-bottom: 1.5rem;
}

.config-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

/* undo the block/full-width styling generic form inputs get */
.config-option input[type='checkbox'] {
  display: inline-block;
  width: auto;
  max-width: none;
  margin: 0;
}

/* a setting that is a choice rather than a switch: the label reads
   like the ones beside it, the dropdown takes only the width its
   longest option needs */
.config-choice {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.config-choice select {
  width: auto;
  max-width: 22rem;
  margin: 0;
}

.config-hint {
  margin: 0.35rem 0 0.75rem;
  font-size: 0.85rem;
  color: var(--hs-text-muted);
}

.config-done {
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: var(--hs-blue-dark);
}

/* plain-text JWT popup */
.token-dialog {
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-surface);
  padding: 1rem 1.5rem;
  max-width: min(40rem, 90vw);
}

.token-dialog::backdrop {
  background: rgb(0 0 0 / 30%);
}

/* confirmation before an irreversible action; the confirming button
   carries the destructive styling, cancel stays the quiet default */
.confirm-dialog {
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-surface);
  padding: 1rem 1.5rem;
  max-width: min(30rem, 90vw);
}

.confirm-dialog::backdrop {
  background: rgb(0 0 0 / 30%);
}

.confirm-dialog h2 {
  margin-top: 0;
}

.confirm-dialog-confirm button:not(:disabled) {
  border-color: var(--hs-danger);
  background: #fff;
  color: var(--hs-danger);
}

.confirm-dialog-confirm button:hover:not(:disabled) {
  background: var(--hs-danger);
  color: #fff;
}

/* popup for a failed API call (ErrorDialog): the friendly translated
   headline up front, the technical cause behind a collapsible element */
.error-dialog {
  border: 1px solid var(--hs-border);
  border-left: 4px solid var(--hs-danger);
  border-radius: var(--hs-radius-surface);
  padding: 1rem 1.5rem;
  max-width: min(30rem, 90vw);
}

.error-dialog::backdrop {
  background: rgb(0 0 0 / 30%);
}

.error-dialog h2 {
  margin-top: 0;
  color: var(--hs-danger);
}

.error-dialog-message {
  margin: 0;
  font-weight: 500;
  color: var(--hs-text);
}

.error-dialog-details {
  margin-top: 0.6rem;
  font-size: 0.85rem;
  color: var(--hs-text-muted);
}

.error-dialog-details summary {
  cursor: pointer;
}

.error-dialog-details p {
  margin: 0.3rem 0 0;
  font-family: monospace;
  overflow-wrap: anywhere;
}

/* the dialog a picker writes a new person or contact in: wider than a
   confirmation, because it carries a whole form, and scrollable — a
   contact with its addresses and phone numbers grows past a short
   screen, and a dialog that cannot be scrolled hides its own save
   button */
.picker-dialog {
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-surface);
  padding: 1rem 1.5rem;
  width: min(42rem, 92vw);
  max-height: 85vh;
  overflow-y: auto;
}

.picker-dialog::backdrop {
  background: rgb(0 0 0 / 30%);
}

.picker-dialog h2 {
  margin-top: 0;
}

/* the news of a freshly loaded build: the width of a confirmation, but
   it carries the dashboard card's list — so the same rules that hold
   that card together apply inside it (see .overview-list) */
.whats-new-dialog {
  /* the strip of backdrop that stays visible above the dialog: enough
     to see that the page is still there behind it, and never more of
     the screen than a phone can spare */
  --whats-new-gap: min(6dvh, 3rem);

  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-surface);
  padding: 1rem 1.5rem;
  width: min(34rem, 92vw);
  /* Hangs from the top edge rather than being centred between the
     edges: a phone centres it in a viewport that is taller than what
     it shows — the browser's own bars are counted in — and the
     heading ended up above the visible area. Hanging from the top,
     the dialog begins where the reading begins.
     The height is measured in dvh for the same reason: vh counts the
     bars in, dvh does not. The 85vh is for whoever has no dvh. */
  margin-block: var(--whats-new-gap) auto;
  max-height: 85vh;
  max-height: calc(100dvh - 2 * var(--whats-new-gap));
  overflow-y: auto;
}

.whats-new-dialog::backdrop {
  background: rgb(0 0 0 / 30%);
}

.whats-new-dialog h2 {
  margin-top: 0;
}

/* the heading takes the focus when the dialog opens, so that neither
   the link at its foot takes it nor the phone scrolls down to that
   link (see WhatsNewDialog.tsx). A heading is nothing to operate,
   though, and a ring around it would only ask what it is for. */
.whats-new-dialog h2:focus {
  outline: none;
}

.whats-new-dialog-lead {
  color: var(--hs-text-muted);
}

.token-dialog pre {
  background: var(--hs-bg-subtle);
  padding: 0.75rem 1rem;
  border-radius: var(--hs-radius-surface);
  overflow-x: auto;
  font-size: 0.8rem;
}

/* ---------- master data definition list ---------- */

/* a fixed label column, not max-content: a detail view often stacks
   several of these lists (e.g. the subscription above its contact
   data), and per-list sizing would indent their values differently.
   Grows only if a label ever exceeds it, so nothing wraps. */
.master-data {
  display: grid;
  grid-template-columns: minmax(10rem, max-content) minmax(0, 1fr);
  gap: 0.35rem 1.5rem;
  margin: 0.5rem 0;
  /* the same indent the table cells above have, so the labels line up
     with the content of the first data column */
  padding-left: 0.75rem;
}

/* the uuid itself, in front of its copy button — whoever does not
   want to see it turns the whole uuid display off in the settings */
.detail-uuid {
  font-family: monospace;
  font-size: 0.85rem;
  overflow-wrap: anywhere;
}

.master-data dt {
  color: var(--hs-text-muted);
  font-size: 0.85rem;
  /* labels align with the top of their value, never centered */
  align-self: start;
}

.master-data dd {
  margin: 0;
}

/* ---------- access-rights grants page ---------- */

/* the plain-language reading of the selected grant heads its details */
.rights-sentence {
  margin: 0.75rem 0 0.25rem;
  padding-left: 0.75rem;
  font-weight: 600;
}

/* the grant form joins the label-left convention of the other forms
   (see the #…-form rules further down); the radio and checkbox labels
   stay out — a choice reads left-to-right, not label/value columns */
#grant-form fieldset > label:not(.rights-assumed) {
  display: grid;
  grid-template-columns: 10rem minmax(0, 1fr);
  align-items: baseline;
  gap: 0.35rem 1.5rem;
  max-width: 34rem;
  margin: 0.4rem 0;
  padding-left: 0.75rem;
  color: var(--hs-text-muted);
  font-size: 0.85rem;
  font-weight: 400;
}

#grant-form fieldset > label:not(.rights-assumed) input,
#grant-form fieldset > label:not(.rights-assumed) select {
  width: calc(100% + 0.6rem + 1px);
  margin-left: calc(-0.6rem - 1px);
  color: var(--hs-text);
  font-size: 0.95rem;
}

/* the who-search results: plain rows, chosen with one click */
.rights-subject-results {
  list-style: none;
  margin: 0.25rem 0 0;
  padding-left: 0.75rem;
  max-width: 34rem;
}

.rights-subject-results button {
  width: 100%;
  text-align: left;
}

#grant-form .rights-assumed {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  width: auto;
}

#grant-form .rights-assumed input {
  width: auto;
  margin: 0;
}

/* A dashboard card is a column of an 18rem masonry, not a page: the
   10rem label column of a detail view eats most of it and leaves the
   values a few characters wide. Here the labels take only what they
   need, the gap shrinks with them, and the indent that lines a detail
   list up with the table above it has nothing to line up with. */
.overview-card .master-data {
  grid-template-columns: minmax(0, max-content) minmax(0, 1fr);
  gap: 0.35rem 0.75rem;
  padding-left: 0;
}

/* hint values (details not visible / no data) step back visually */
.master-data dd.muted,
p.muted {
  color: var(--hs-text-muted);
  font-style: italic;
}

/*
 * While the table's filters hide the selected row, its details below
 * stand as an outline: tabs, labels and headings keep their place,
 * only the values withdraw — a layout that holds still reads calmer
 * than a block that comes and goes. \`visibility\` keeps the room the
 * values took; the \`inert\` attribute on the same wrapper (set by the
 * pages, see CrudTable's onSelectionHiddenChange) keeps the outline
 * from being clicked or tabbed into. Checkboxes and buttons have no
 * blank state, so they grey out instead.
 */
.details-withheld dd,
.details-withheld td,
.details-withheld p.muted,
.details-withheld .table-pager {
  visibility: hidden;
}

.details-withheld .form-actions,
.details-withheld .table-tools,
.details-withheld input[type='checkbox'] {
  opacity: 0.4;
}

/* Where a detail block continues with data that belongs to another
   record — the contact of a partner or of a mailing list — a rule
   says so. Faint on purpose: it separates two parts of one block, so
   it must not read as the end of the block. */
.detail-divider {
  border: none;
  border-top: 1px solid var(--hs-border);
  margin: 1.25rem 0 1rem;
}

/* ---------- tabs ---------- */

.tab-bar {
  border-bottom: 2px solid var(--hs-border);
  margin-bottom: 1rem;
}

.tab-bar button {
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  margin-bottom: -2px;
  padding: 0.5rem 1rem;
  color: var(--hs-text-muted);
  font-weight: 500;
}

.tab-bar button:hover:not(:disabled) {
  background: transparent;
  color: var(--hs-blue);
}

.tab-bar button.active {
  color: var(--hs-blue);
  border-bottom-color: var(--hs-orange);
  font-weight: 600;
}

/* ---------- tables ---------- */

/* A table takes the width it is given. It used to stop at 60rem, and
   on a wide screen that left a hand's breadth of white beside every
   one of them while the columns beside it wrapped their contents —
   the one thing on a page that can put the width to use, not using
   it. What keeps it off the edge is the padding of the box it stands
   in, the same the values above it keep. */
table {
  border-collapse: collapse;
  width: 100%;
  margin: 0.5rem 0 1rem;
  font-size: 0.95rem;
}

/* 0.4rem, not the half line one would write down first: a good pixel
   and a half off each side of every row, which is three off its height
   and, over the seven rows a phone shows, most of an eighth row. Below
   this the row stops being a comfortable target for a thumb. */
th,
td {
  text-align: left;
  padding: 0.4rem 0.4rem;
  border-bottom: 1px solid var(--hs-border);
}

thead th {
  background: var(--hs-blue-pale);
  color: var(--hs-blue-dark);
  border-bottom: 2px solid var(--hs-blue);
}

tbody tr:hover {
  background: var(--hs-bg-subtle);
}

/* CrudTable wrapper: at most ~5 rows visible, then a scrollbar;
   the header stays sticky while the body scrolls */
.crud-table {
  max-height: 15.6rem;
  overflow-y: auto;
  /* wide tables scroll inside their box instead of widening the page
     (matters on small screens) */
  overflow-x: auto;
  /* The gutter stands reserved whether the scrollbar is there or not.
     A classic (non-overlay) scrollbar takes its width from the box the
     columns are shared out over, and on a table sized right at the
     edge that is an oscillator: bar appears, box narrows, columns are
     reshared, the table fits, bar disappears, box widens, … — seen as
     flickering scrollbars in browsers with classic bars. Overlay
     scrollbars ignore this property, so nothing is lost there. */
  scrollbar-gutter: stable;
  margin: 0.5rem 0 1rem;
}

/* tables with a totals row (see tfoot below) get its height on top,
   so as many data rows stay visible as in tables without one */
.crud-table.has-footer {
  max-height: 18.1rem;
}

/* A main table is not scrolled but paged: its page is as many rows as
   the box holds, and the pager below carries the reader on. What hangs
   over the lower edge is the row peeking in from the next page (see
   \`peeking\` in CrudTable) — it is meant to be cut off, not to be
   fetched with a scrollbar. Sideways it still scrolls: a wide table
   would otherwise widen the whole page. */
.crud-table.is-paged {
  overflow-y: hidden;
}

/* A box that ends in the middle of a row — which it usually does: a
   dragged splitter and the height left over for a full-height table
   land on a row boundary only by accident. Cut hard, that half row
   reads like the end of the list; faded, it says the same thing the
   scrollbar says, in the place the eye is already looking.

   The mask sits on the scrolling box, so it stays at its lower edge
   while the rows move underneath. It is set only while something is
   still below (\`is-clipped\`, see CrudTable): scrolled to the end, the
   last row is whole and has to stay readable. */
.crud-table.is-clipped {
  --fade: linear-gradient(to bottom, #000 calc(100% - 1.75rem), transparent);

  mask-image: var(--fade);
  -webkit-mask-image: var(--fade);
}

/* Every row is one line tall, whatever stands in it.

   A cell used to wrap into a second line and cut the rest off with an
   ellipsis, so that one long address could not widen its column. That
   kept the table narrow but made the rows of unequal height — and a
   table whose rows are of unequal height cannot be dragged open
   smoothly: every row uncovered changed the column widths, and every
   changed width changed the heights (see CrudTable).

   Now the widths are stated ahead of the layout, over the whole list
   (see \`askedWidths\` in CrudTable), and nothing in a cell can push
   them. What does not fit runs out at the right edge, where it fades
   into nothing rather than being cut through the middle of a letter;
   the whole value stands in the tooltip of the cell and in the
   details below. */
.crud-table tbody td:not(:last-child) {
  white-space: nowrap;
  overflow: hidden;
}

.crud-table tbody td.is-cut {
  overflow: visible;
  /* the text runs out under the next column and fades there, not at
     the cell edge — what does not fit vanishes before it reaches the
     edge, so the spacing saved by the narrower padding is real */
  --cut: linear-gradient(to right, #000 calc(100% - 1rem), transparent);

  mask-image: var(--cut);
  -webkit-mask-image: var(--cut);
}

/* a message spanning the whole table is no data cell: it may use every
   line it needs (and being the only cell of its row, it is a last
   child and keeps its wrapping anyway) */
.crud-table tbody td.filter-no-match {
  white-space: normal;
}

/* the widths come from the colgroup alone (see CrudTable): a column
   that measured itself against the rows on show would move whenever
   the page turned or the splitter opened another row */
.crud-table table {
  margin: 0;
  max-width: none;
  table-layout: fixed;
}

/* empty pseudo rows below the data (see CrudTable): row look without
   content or interaction */
.crud-table tbody tr.filler-row {
  pointer-events: none;
}

.crud-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  /* border-collapse does not keep borders sticky — draw it inset */
  border-bottom: none;
  box-shadow: inset 0 -2px 0 var(--hs-blue);
  /* single-line headers: the filter row sticks at a fixed offset
     below, a wrapped header line would break that geometry */
  white-space: nowrap;
}

/* The heading gives way before the sort symbol does: where a column is
   narrower than its own name, the name is cut off and the symbol keeps
   its place — a column one cannot sort by is worse than a heading one
   has to guess at. (The button column takes its width from
   \`--tools-col\`, measured in CrudTable.) */
.crud-table thead th .th-head {
  display: flex;
  align-items: baseline;
  min-width: 0;
}

.crud-table thead th .th-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* The grip on the border between two column heads: drag it and the
   width moves from the one column into the other, double-click sets
   the pair back to what the table reckoned (see CrudTable).

   Shown only while the pointer is over the header row — a line at
   every border, standing there all the time, would be a fence across
   the table for a thing one needs twice a year. It reaches beyond its
   own line so it can be hit without aiming, and lies over the border
   itself, half in each column. Where there is no pointer to show it
   to, it stands there always (see the hover query below). */
.crud-table thead th .col-grip {
  position: absolute;
  top: 0;
  bottom: 0;
  right: -4px;
  width: 9px;
  cursor: col-resize;
  touch-action: none;
  z-index: 2;
}

.crud-table thead th .col-grip::before {
  content: '';
  position: absolute;
  top: 15%;
  bottom: 15%;
  left: 50%;
  width: 2px;
  transform: translateX(-50%);
  background: var(--hs-blue);
  opacity: 0;
  transition: opacity 0.12s ease-in-out;
}

.crud-table thead tr:hover .col-grip::before {
  opacity: 0.35;
}

.crud-table thead th .col-grip:hover::before,
.crud-table thead th .col-grip:active::before,
.crud-table thead th .col-grip:focus-visible::before {
  opacity: 1;
}

.crud-table thead th .col-grip:focus-visible {
  outline: none;
}

/*
 * Where a finger does the dragging, nothing can be shown on hover: a
 * finger is either down or away. So on a screen that can be touched
 * the lines stand there for good — the fence we spared the mouse,
 * because the alternative is a grip nobody can find — and the band to
 * grasp them by is as wide as a fingertip needs rather than as wide as
 * a pointer needs.
 *
 * Which matters most where one would least expect it: a phone asked
 * for the desktop view has the room of a laptop, hands the page a
 * thousand css pixels and shrinks them to the width of a hand. Nine of
 * those pixels are about a millimetre.
 *
 * That the screen can be touched is decided in CrudTable and said in
 * this class, not asked here as \`hover\` or \`pointer\` — those are the
 * very answers a browser passing for a desktop rewrites, and this is
 * the screen that needs it most (see TOUCHABLE).
 */
.crud-table.is-touched thead th .col-grip {
  right: -14px;
  width: 28px;
}

.crud-table.is-touched thead th .col-grip::before {
  opacity: 0.3;
}

/* every icon button of a table lives in the trailing column: the tools
   in the header, the row actions below. One shared right-aligned flex
   row with one gap keeps them lined up in a single column — and the
   flex context neutralises the floats those buttons carry elsewhere.
   Staying on one line also matters in the header: a wrapped second
   line would break the fixed sticky offset of the filter row below
   (see .filter-row). */
.crud-table .table-tools,
.detail-tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.35rem;
  white-space: nowrap;
}

/* the detail block repeats the row's actions, floating in its top
   right corner above whatever the details render. Right-aligned to
   the same edge as the table above, so the icons line up with the
   ones in the data rows. */
.detail-section {
  position: relative;
}

.detail-tools {
  position: absolute;
  z-index: 1;
  top: 0;
  /* the table cells carry this padding, so the icons of the details
     line up with those of the rows above */
  right: 0.75rem;
}

/* the value the detail block is about, set apart from the rest */
.master-data dd.detail-headline {
  font-weight: 600;
  color: var(--hs-blue);
}

/* sort toggle behind the column name; fixed width so the column
   widths stay stable when the sort column or direction changes */
.crud-table th .th-sort {
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 0.85em;
  color: var(--hs-text-muted);
  cursor: pointer;
  display: inline-block;
  width: 1.3em;
  margin-left: 0.35em;
  text-align: center;
  /* never squeezed by a narrow column — see .th-head */
  flex: none;
}

.crud-table th .th-sort:hover:not(:disabled) {
  background: none;
  color: var(--hs-blue);
}

.crud-table th .th-sort.active {
  color: var(--hs-blue);
}

/* collapsible search row (Magic Search or per-column filters); sticks
   right below the sticky header row (top = header cell height:
   0.95rem text × 1.5 line height + 2 × 0.4rem padding). The offset
   must match that height to the pixel — set too deep, a stripe of
   whatever scrolls by shows between the header and the search row. */
.crud-table .filter-row td {
  position: sticky;
  top: 2.225rem;
  z-index: 1;
  background: var(--hs-blue-pale);
  padding: 0.2rem 0.75rem 0.45rem;
}

/* The Magic Search input is one cell across the data columns and
   fills it — past the readable-width cap the forms put on inputs. It
   ends where the button column begins: that strip belongs to the
   buttons, and nothing else may lie under them. */
.crud-table .filter-row td.magic-search input {
  max-width: none;
}

/* A column of enum values offers them as a dropdown instead of a text
   box; both sit in the same row, so both wear the same measurements.

   What has to line up with the column below is the text inside the
   box, not the box around it: left alone, the border and the box's own
   padding pushed every filter about half a character to the right of
   the values it filters, and the whole search row read as shifted. The
   box therefore starts that much further left, reaching into the
   cell's padding, which has room to spare. */
.crud-table .filter-row input,
.crud-table .filter-row select {
  --filter-inset: calc(0.4rem + 1px);

  width: calc(100% + var(--filter-inset));
  margin-left: calc(-1 * var(--filter-inset));
  font-size: 0.85rem;
  padding: 0.2rem 0.4rem;
}

/* What a dropdown shows is the whole answer, so it must not be cut:
   half of "ausgeschlossen" says nothing, where half a typed word in a
   text box still does. The column widens to the longest value while
   the search row is open and shrinks back when it closes. The arrow
   needs its room on top of that, or it sits on the longest label. */
.crud-table .filter-row select {
  min-width: max-content;
  /* the fixed height of a form select is measured for the form's
     padding; here the row's own padding has to decide, or the
     dropdown stands taller than the boxes beside it */
  height: auto;
  padding-right: 1.2rem;
  background-position: right 0.4rem center;
}

.filter-no-match {
  color: var(--hs-text-muted);
  font-size: 0.85rem;
}

/* totals pseudo row (e.g. summed share counts/amounts) */
.crud-table tfoot .totals-row td {
  position: sticky;
  bottom: 0;
  background: #fff;
  font-weight: 600;
  /* border-collapse does not keep borders sticky — draw it inset */
  border-top: none;
  box-shadow: inset 0 2px 0 var(--hs-blue);
  /* one line, like every other row: how tall this row stands is part
     of how many rows fit into the box (see \`tableChrome\` in CrudTable) */
  white-space: nowrap;
}

/* master-detail selection */
.crud-table.selectable tbody tr {
  cursor: pointer;
}

.crud-table.selectable tbody tr.selected,
.crud-table.selectable tbody tr.selected:hover {
  background: var(--hs-blue-pale);
}

/* the row under the keyboard says so — drawn inside its own edge, or
   the scrolled pane would cut the mark off at the first and last row */
.crud-table.selectable tbody tr:focus-visible {
  outline: 2px solid var(--hs-blue);
  outline-offset: -2px;
}

/* main tables (with a persisted split) own their vertical space; the
   region wraps the scroll area plus the foot strip below it. The
   scroll area's height comes from an inline style (ten-row default or
   the stored split), so the region overrides the fixed CSS max-height.

   No margin above: the page frame already keeps a hand's width there
   (main and its inner box each add half a line), and every pixel above
   the table is one the table does not get. */
.crud-table-region {
  margin: 0 0 1rem;
}

/* ---------- paging ---------- */

/*
 * The way from page to page, under the table it belongs to. It reads
 * like the table's own furniture rather than like an action of the
 * page: two discreet arrows and, between them, which rows of how many
 * are on screen.
 */
.table-pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  margin: -0.25rem 0 0.5rem;
  color: var(--hs-text-muted);
  font-size: 0.85rem;
}

/*
 * Below a main table the pager shares its line with the drag handle
 * (see CrudTable): stacked, the two cost 37px of the 488 a phone has
 * for its content — more than half a data row for four pixels of grip.
 *
 * Laid out from the right, so the pager keeps the reading and tab
 * order it has in the markup while the handle takes the rest of the
 * width. \`position: relative\` is what lets the grip sit on the middle
 * of the table rather than on the middle of the leftover space.
 */
.table-foot {
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  align-items: stretch;
  /* room above and below: on Android the table keeps a horizontal
     scrollbar at its lower edge, and without this the button and the
     grip sit right on it */
  padding: 0.4rem 0;
}

.table-foot .table-pager {
  margin: 0;
}

/* the strip runs right to left: the pager keeps the right end, these
   stand between it and the grip */
.table-foot-actions {
  display: flex;
  align-self: center;
  gap: 0.5rem;
  margin: 0 0.75rem;
}

.table-foot-actions label {
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  white-space: nowrap;
}

.table-foot-actions input[type='checkbox'] {
  width: auto;
  margin: 0;
}

/* the named action of the list, at the left end of the strip. It is
   what gives the strip its height — and thereby the grip of the handle
   the distance from the table's edge that it was missing.

   The float and the left margin are the header icon's, where it lines
   up beside reload; down here the strip does the placing, and the
   button starts on the table's own left edge. */
.table-foot .btn-create {
  float: none;
  align-self: center;
  margin: 0;
}

/* the written-out count and its short form; the stylesheet picks (see
   the media query at the end of this section) */
.table-pager-status .on-narrow {
  display: none;
}

.table-pager button {
  padding: 0.2rem 0.4rem;
  border: 0;
  background: none;
  color: var(--hs-text-muted);
  line-height: 1;
  cursor: pointer;
}

.table-pager button:hover:not(:disabled) {
  background: none;
  color: var(--hs-blue);
}

.table-pager button:disabled {
  opacity: 0.35;
  cursor: default;
}

.table-pager button::before {
  width: 0.9rem;
  height: 0.9rem;
  margin-right: 0;
}

/* how many rows a page holds: the number itself is the label, so the
   button says its state the way the language switch does */
.btn-rows {
  min-width: 1.9rem;
  padding: 0.15rem 0.35rem;
  font-size: 0.8rem;
  font-variant-numeric: tabular-nums;
}

/* bi-chevron-left / bi-chevron-right — a page back and on */
.btn-page-back::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}

.btn-page-on::before {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}

/* where the line is narrow, the written-out count would reach across
   the middle of the strip and under the grip of the handle */
@media (max-width: 600px) {
  .table-pager-status .on-wide {
    display: none;
  }

  .table-pager-status .on-narrow {
    display: inline;
  }

  /* the same strip, the same reason: the named action steps back to
     its icon, which is what it is in the table header anyway. What it
     adds stays in its tooltip and in its label for a screen reader. */
  .table-foot .btn-create .on-wide {
    display: none;
  }

  .table-foot .btn-create {
    padding: 0.3rem 0.55rem;
  }

  .table-foot button.btn-create::before {
    margin-right: 0;
  }
}

.crud-table-region .crud-table {
  margin: 0;
}

/* horizontal splitter between a main table and the details below:
   drag to resize, double-click resets to the ten-row default. It takes
   the width the pager beside it leaves, and at least the height of a
   line — a wider target is easier to hit with a thumb than the four
   pixels the grip itself is tall. */
.crud-splitter {
  flex: 1;
  min-height: 12px;
  cursor: row-resize;
  touch-action: none;
}

/* the grip sits on the middle of the table, not on the middle of what
   is left of the strip: the pager appears and vanishes with the number
   of pages, and a grip that slid sideways with it would look broken */
.crud-splitter::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 2.5rem;
  height: 4px;
  border-radius: 2px;
  background: var(--hs-border);
}

.crud-splitter:hover::before,
.crud-splitter:focus-visible::before {
  background: var(--hs-blue);
}

.crud-splitter:focus-visible {
  outline: none;
}

td button {
  padding: 0.2rem 0.7rem;
  font-size: 0.85rem;
}

/* ---------- loading skeleton ---------- */

/* shimmering placeholder bars while table rows load (TableSkeleton) */
.skeleton-bar {
  display: inline-block;
  height: 0.9rem;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    var(--hs-border) 25%,
    var(--hs-bg-subtle) 50%,
    var(--hs-border) 75%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s linear infinite;
}

/* header bars shimmer in the header's blue palette */
.skeleton-table thead .skeleton-bar {
  background: linear-gradient(
    90deg,
    var(--hs-blue-pale) 25%,
    #fff 50%,
    var(--hs-blue-pale) 75%
  );
  background-size: 200% 100%;
}

@keyframes skeleton-shimmer {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton-bar {
    animation: none;
  }
}

/* contact/person/partner forms: labelled inputs (and, for persons, a
   type select). Labels sit left of their field (compact, no wasted
   space) and align with the top of the widget, never centered.

   The column is the one \`.master-data\` and \`.entity-picker-field\` use,
   down to the gap and the indent: a form mixes plain fields with
   pickers (the debitor form has four of them), and two label columns a
   good centimetre apart make every second field look misplaced. */
#bank-account-form label,
#booking-item-cancel-form label,
#booking-item-create-form label,
#booking-item-resources-form label,
#contact-form label,
#hosting-asset-form label,
#debitor-form label,
#membership-form label,
#partner-form label,
#person-form label,
.picker-dialog label {
  display: grid;
  grid-template-columns: 10rem minmax(0, 1fr);
  /* the label sits on the line the field writes on: it is a bare text
     node in the first cell, so there is nothing to pad it into place
     with — the baseline does it, and does it for every field height */
  align-items: baseline;
  gap: 0.35rem 1.5rem;
  max-width: 34rem;
  margin: 0.4rem 0;
  padding-left: 0.75rem;
  /* and the label reads like one: the same muted, smaller word the
     detail lists (\`.master-data dt\`) and the pickers
     (\`.entity-picker-label\`) put in that column. A form box whose
     labels stand darker and larger than those of the box above it —
     the partner form had exactly that, its "Details" beside its
     "Kontakt" — looks like a different kind of thing rather than the
     next section of the same form. */
  color: var(--hs-text-muted);
  font-size: 0.85rem;
  font-weight: 400;
}

/* The value is not the label: what is typed keeps the reading size and
   the full colour of text.

   The calendar hanging under a date field is exempt: its month and its
   year are fields too, but they are the popup's own furniture and have
   to keep the widths it gives them — a rule named after the form wins
   over any of the calendar's, so the calendar has to be named here. */
#bank-account-form label input:not(.day-picker *),
#booking-item-cancel-form label input:not(.day-picker *),
#booking-item-create-form label input:not(.day-picker *),
#booking-item-create-form label select:not(.day-picker *),
#booking-item-resources-form label input:not(.day-picker *),
#booking-item-resources-form label select:not(.day-picker *),
#hosting-asset-form label input:not(.day-picker *),
#hosting-asset-form label select:not(.day-picker *),
#contact-form label input:not(.day-picker *),
#debitor-form label input:not(.day-picker *),
#membership-form label input:not(.day-picker *),
#membership-form label select:not(.day-picker *),
#partner-form label input:not(.day-picker *),
#person-form label input:not(.day-picker *),
#person-form label select:not(.day-picker *),
.picker-dialog label input:not(.day-picker *),
.picker-dialog label select:not(.day-picker *) {
  /* The box is furniture, the text is the value: the field is pulled
     left by its own border and padding, so what is typed stands on the
     column line where the plain values of the same detail block stand.
     The right edge stays put — the width grows by what the margin
     takes. */
  width: calc(100% + 0.6rem + 1px);
  margin-left: calc(-0.6rem - 1px);
  color: var(--hs-text);
  font-size: 0.95rem;
}

/* A field as wide as what goes into it: two digits, three letters, a
   country code. Stretched across the whole column they promise room
   that neither the input nor the backend has. */
#booking-item-create-form label input.short-field,
#booking-item-resources-form label input.short-field,
#hosting-asset-form label input.short-field,
#debitor-form label input.short-field {
  width: 6rem;
}

/* Said explicitly because Firefox on Linux writes number inputs
   right-aligned, GTK spin-button style: these are values in a form
   column and stand left like every other value */
#booking-item-create-form label input[type='number'],
#booking-item-resources-form label input[type='number'] {
  text-align: left;
}

/* A checkbox is a value like any other: its name stands in the label
   column, the box itself at the left edge of the value column, where
   every other widget starts writing. Only the stretching has to be
   taken back — a checkbox spread over the whole column would put the
   clickable square somewhere in the middle of nowhere. */
#booking-item-create-form label.checkbox-label input,
#booking-item-resources-form label.checkbox-label input,
#hosting-asset-form label.checkbox-label input,
#debitor-form label.checkbox-label input,
#membership-form label.checkbox-label input,
#bank-account-form label.checkbox-label input,
.bank-account-fields label.checkbox-label input {
  width: auto;
  max-width: none;
  justify-self: start;
  align-self: center;
  margin: 0;
}

.entries-editor {
  width: 100%;
  max-width: 32rem;
  margin-bottom: 0.5rem;
}

.entries-editor td input {
  width: 100%;
}

td input[type='checkbox'] {
  accent-color: var(--hs-blue);
  width: 1rem;
  height: 1rem;
}

/* ---------- forms ---------- */

fieldset {
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-surface);
  background: #fff;
  padding: 1rem 1.25rem;
  margin: 0 0 1.25rem;
  max-width: 40rem;
}

legend {
  color: var(--hs-blue);
  font-weight: 600;
  padding: 0 0.5rem;
}

label {
  display: block;
  margin: 0.5rem 0;
  font-weight: 500;
}

input,
textarea,
select {
  display: block;
  width: 100%;
  max-width: 30rem;
  margin-top: 0.25rem;
  padding: 0.45rem 0.6rem;
  font: inherit;
  font-size: 0.95rem;
  border: 1px solid var(--hs-border);
  border-radius: var(--hs-radius-control);
}

/* A native dropdown wears the same arrow as the two built ones (the
   partner selector and the searchable select): a blue triangle at the
   right edge with room around it. The browser's own arrow differs per
   platform and stood tight against the longest option, so the app
   showed three kinds of dropdown that looked like three widgets. The
   padding on the right is what keeps the text off the arrow — it is
   drawn inside the box, not beside it. */
/* the box itself matches the text inputs: white, and a height that
   lines up with an input's padding+line-height rather than the taller
   native control */
select {
  appearance: none;
  height: calc(1.5em + 0.9rem + 2px);
  padding-right: 1.6rem;
  background: #fff
    url(${___CSS_LOADER_URL_REPLACEMENT_48___})
    no-repeat right 0.6rem center;
  /* sized and placed to sit where the ▾ of the built dropdowns sits */
  background-size: 0.45rem;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
  border-color: var(--hs-blue);
  box-shadow: 0 0 0 3px var(--hs-blue-pale);
}

/* A read-only field is a fact, not an offer: without box and field
   background nothing invites typing — the value stands like it would
   in a detail list, selectable but visibly hard-wired. The border only
   turns transparent so the text keeps standing where the editable
   fields write. */
input[readonly] {
  border-color: transparent;
  background: transparent;
  cursor: default;
}

/* focus stays visible for the keyboard, but without the blue border
   that says "type here" */
input[readonly]:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px var(--hs-blue-pale);
}

/* ---------- footer ---------- */

/* no top margin: the body background would show through the gap as a
   second gray band above the footer */
footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem 1rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--hs-border);
  color: var(--hs-text-muted);
  font-size: 0.85rem;
}

/* the frontend build and the one the backend reports, side by side.
   Wraps for the same reason the links do — two commits with two
   timestamps are more than a phone is wide. */
.footer-builds {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.2rem 1rem;
}

/* the backend build and the button that asks for it again stay one
   piece, so the button never wraps away from the line it refreshes */
.build-backend {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  white-space: nowrap;
}

/* bi-arrow-clockwise, the same glyph the tables reload with — but
   quieter: borderless and in the muted text colour of the footer,
   which is no place for a button that asks to be pressed */
.btn-version-refresh {
  padding: 0;
  width: 1rem;
  height: 1rem;
  border: 0;
  background: none;
  color: inherit;
  font-size: 0.8rem;
  vertical-align: -0.1em;
}

.btn-version-refresh::before {
  content: '';
  display: inline-block;
  width: 1em;
  height: 1em;
  background-color: currentColor;
  -webkit-mask: var(--btn-icon) no-repeat center / contain;
  mask: var(--btn-icon) no-repeat center / contain;
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.btn-version-refresh:hover:not(:disabled) {
  color: var(--hs-blue);
}

/* while the answer is on its way the glyph turns, and it dims: the
   only feedback a footer has room for */
.btn-version-refresh:disabled {
  opacity: 0.5;
  animation: version-refresh-spin 1s linear infinite;
}

@keyframes version-refresh-spin {
  to {
    transform: rotate(360deg);
  }
}

/* wraps rather than pushes: three labels plus the wordmark are wider
   than a phone, and a footer that overflows scrolls the whole page
   sideways */
.footer-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem 1rem;
}

.footer-links a {
  color: var(--hs-text-muted);
}

.footer-links a:hover {
  color: var(--hs-blue);
}

/* www.hostsharing.net closes the row of footer links with its logo
   linking home — flame and wordmark, in the one flat grey it uses down
   there rather than the orange and blue of the topbar. The artwork
   draws in currentColor (see HostsharingLogo.tsx), so the colour is
   set here and the height is all the SVG needs to know. */
.footer-logo {
  display: flex;
  color: var(--hs-text-muted);
}

.footer-logo svg {
  height: 1.15rem;
  width: auto;
}

/* the logo is the link, so hovering it may not recolour text that is
   not there — it brightens into the brand orange instead */
.footer-logo:hover {
  color: var(--hs-orange);
}

/* --- the way back up ---------------------------------------------- */

/* www.hostsharing.net parks a button in the lower right corner once
   the page has been scrolled a screen or so. It is an outline like
   every other button here rather than the filled one the site uses,
   and the shadow is what lifts it off the content it floats over. */
.btn-back-to-top {
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_49___});

  position: fixed;
  right: 20px;
  /* the same gap below as beside, and both to the edge of the window
     rather than to the end of the content: the button used to step up
     for the footer, which parked it in the middle of the page — where
     whatever else the corner holds is. On the footer it covers a line
     of small print that is a scroll away from being read again. The
     inset is what a phone keeps for itself below the page, the home
     bar of an iPhone; the browser's own bar sits outside the page and
     needs nothing here. */
  bottom: calc(20px + env(safe-area-inset-bottom, 0px));
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  box-shadow: 0 2px 6px rgb(0 0 0 / 20%);
}

.btn-back-to-top::before {
  content: '';
  width: 1.1rem;
  height: 1.1rem;
  background-color: currentcolor;
  -webkit-mask: var(--btn-icon) no-repeat center / contain;
  mask: var(--btn-icon) no-repeat center / contain;
}

/* --- a newer release on the server -------------------------------- */

/* A bar below the topbar, not a modal: it must be possible to ignore
   it and keep working — reloading throws away unsaved input. */
.update-notice {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 1rem;
  margin: 0 1.5rem;
  padding: 0.6rem 0.9rem;
  border: 1px solid var(--hs-blue);
  border-radius: var(--hs-radius-surface);
  background: #eef4fb;
  font-size: 0.9rem;
}

.update-notice-actions {
  display: flex;
  gap: 0.5rem;
}

.update-notice-later {
  background: none;
  border-color: var(--hs-border);
  color: var(--hs-text-muted);
}

.update-notice-reload {
  background: var(--hs-blue);
  border-color: var(--hs-blue);
  color: #fff;
}

/* bi-box-seam — the marker that keeps a dismissed hint reachable */
.btn-update {
  margin-left: 0.4rem;
  padding: 0;
  width: 1.1rem;
  height: 1.1rem;
  border: 0;
  background: none;
  color: var(--hs-blue);
  font-size: 0.7rem;
  vertical-align: -0.15em;
}

.btn-update::before {
  content: '';
  display: inline-block;
  width: 1em;
  height: 1em;
  background-color: currentColor;
  -webkit-mask: var(--btn-icon) no-repeat center / contain;
  mask: var(--btn-icon) no-repeat center / contain;
  --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}

.btn-update:hover {
  color: var(--hs-orange);
}

/* --- overview dashboard ------------------------------------------- */

/* masonry-style via CSS multi-column: cards flow one after another
   down each column, so differing card heights leave no row gaps */
.overview-grid {
  columns: 18rem;
  column-gap: 1rem;
}

/* drag-and-drop wrapper around each card; carries the column-flow
   properties so card and handle move as one piece */
.overview-card-slot {
  position: relative;
  break-inside: avoid;
  margin-bottom: 1rem;
}

.overview-card-slot.dragging {
  opacity: 0.5;
}

/* where the card would land. A mouse has a cursor to say so, a finger
   has nothing — and the finger is on the handle, not on the target */
.overview-card-slot.drop-target {
  outline: 2px dashed var(--hs-blue);
  outline-offset: 3px;
}

.overview-card-slot .drag-handle {
  position: absolute;
  top: 0.8rem;
  right: 1rem;
  cursor: grab;
  color: var(--hs-text-muted);
  user-select: none;
  /* the handle belongs to the drag, not to the scroll: without this a
     finger starting here scrolls the page and the card stays put */
  touch-action: none;
}

/* a finger covers what it drags, so the target has to be reachable
   without precision — the handle is the one thing that may not move
   under it, and a bigger hit area is what makes that comfortable */
.overview-card-slot .drag-handle::after {
  content: '';
  position: absolute;
  inset: -0.6rem;
}

.overview-card-slot .drag-handle:hover {
  color: var(--hs-blue);
}

/* no frame: the white against the grey around it is the border */
.overview-card {
  background: #fff;
  border-radius: var(--hs-radius-surface);
  padding: 1rem 1.25rem;
}

/* www.hostsharing.net lifts a single section out of the stack of white
   blocks by setting it in the primary blue with white on top of it
   (\`bg-primary text-white\`) — that is how its teasers are drawn. Here
   it marks the card that says what changed: on a dashboard of numbers
   it is the one thing worth reading before them. It works because it
   stays the only blue block on the page. */
.overview-card-accent {
  background: var(--hs-blue);
  color: #fff;
}

.overview-card-accent h2 {
  color: #fff;
}

/* the dates keep a step behind the entries they belong to, the way
   they do on white — a plain white would flatten the two together */
.overview-card-accent .overview-muted {
  color: color-mix(in srgb, #fff 72%, var(--hs-blue));
}

/* A card is a teaser, not a viewport: the entries that do not fit are
   left off rather than put behind a scrollbar, which on a dashboard
   card nobody goes looking for. The card shows the newest few and ends
   in the link to the page that carries them all, the way the site
   closes its teasers with "Mehr erfahren" — named here after what
   waits behind it: the older news. */
/* a news entry shows three lines and no more until asked — the card
   and the greeting dialog share this through WhatsNewList */
.overview-clamped {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
}

/* an entry with something to unfold is its own switch: the "…" at the
   cut is drawn by the browser and answers no click, and that is where
   a reader aims */
.is-clamp-toggle {
  cursor: pointer;
}

/* the offer to unfold, reading like a link rather than a button: it
   belongs to the text it stands under, not to the card's chrome */
.overview-clamp-toggle {
  padding: 0;
  border: none;
  background: none;
  color: var(--hs-blue);
  font-size: 0.85rem;
  cursor: pointer;
}

.overview-clamp-toggle:hover {
  text-decoration: underline;
}

.overview-more {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.75rem 0 0;
  font-size: 0.9rem;
  /* the way out of the teaser sits where reading ends, not where it
     begins. On the card the link stands there alone; in the dialog the
     close button shares the line and takes the left end of it, so that
     the two ways out of the window read as one row rather than as two
     offers below one another. */
  justify-content: flex-end;
}

.overview-more > button {
  margin-right: auto;
}

/* a finger leaves focus behind where a mouse does not: after the tap
   the link keeps the ring the keyboard needs, and on a phone it reads
   as a box drawn around the text for no reason. The ring is worth
   keeping for whoever arrives by Tab, so it is asked for by name. */
.overview-more a:focus {
  outline: none;
}

.overview-more a:focus-visible {
  outline: 2px solid currentcolor;
  outline-offset: 2px;
}

.overview-more a {
  -webkit-tap-highlight-color: transparent;
}

/* the link sits on the blue of the accent card, where the blue it
   wears on white would be unreadable */
.overview-card-accent .overview-more a {
  color: #fff;
}

/* the grey handle would disappear into the blue */
.overview-card-slot:has(.overview-card-accent) .drag-handle {
  color: color-mix(in srgb, #fff 72%, var(--hs-blue));
}

.overview-card-slot:has(.overview-card-accent) .drag-handle:hover {
  color: #fff;
}

/* the title of a card names it rather than opening a page, so it takes
   the weight of a \`card-title\` on the site instead of the lighter one
   the section headings carry */
.overview-card h2 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.75rem;
  font-size: 1.1rem;
  font-weight: 500;
}

.overview-card h3 {
  margin: 0.75rem 0 0.25rem;
  font-size: 0.95rem;
}

/* What the card is about, opening its body over the full width: a
   partner name has no room left beside a label column here, and it is
   the one value that must not be squeezed. Not a heading — the card
   already carries one, and this is data. */
.overview-card .overview-headline {
  margin: 0 0 0.6rem;
  font-weight: 600;
}

/* marks cards rendered from hardwired example data */
.example-badge {
  background: var(--hs-blue-pale);
  color: var(--hs-blue-dark);
  border-radius: 999px;
  padding: 0.1rem 0.6rem;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  cursor: help;
}

.invoices-notice {
  margin: 0 0 0.5rem;
}

.overview-booking-items {
  margin: 0 0 0.5rem;
  color: var(--hs-text-muted);
  font-size: 0.85rem;
}

.overview-hint {
  margin: 0.75rem 0 0;
  color: var(--hs-text-muted);
  font-size: 0.85rem;
}

.resource-row {
  display: grid;
  grid-template-columns: 4rem 1fr auto;
  align-items: center;
  gap: 0.5rem;
  margin: 0.25rem 0;
  font-size: 0.85rem;
}

.resource-bar {
  display: block;
  height: 0.5rem;
  border-radius: 999px;
  background: var(--hs-bg-subtle);
  border: 1px solid var(--hs-border);
  overflow: hidden;
}

.resource-bar-fill {
  display: block;
  height: 100%;
  background: var(--hs-blue);
}

.resource-value {
  color: var(--hs-text-muted);
  white-space: nowrap;
}

.overview-links {
  list-style: none;
  margin: 0;
  padding: 0;
}

.overview-links li {
  margin: 0.35rem 0;
}

/* a bookmark row: which area it leads into, the record, and what one
   can do to the row — pushed to the right edge so the rows read as a
   list of links and not as a list of buttons */
.bookmark-row {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

/* The area is marked with the icon the sidebar marks its entry with,
   rather than written out: the word said the same thing in every row
   and took the room the record needs. The glyph comes from the very
   rule the menu uses (see the nav-* icons above), so the two cannot
   drift apart — only smaller here, and without the entry around it. */
.bookmark-area {
  flex: none;
  color: var(--hs-text-muted);
  font-size: 0.8rem;
  /* the row spaces its parts; the gap the icons keep to their label in
     the menu would come on top of it */
  line-height: 1;
}

.bookmark-area::before {
  margin-right: 0;
}

/* the name takes what the row has left, so a long one wraps inside its
   own box instead of pushing the mark behind it around */
.bookmark-name {
  flex: 1;
  min-width: 0;
}

/* What one can do to the row, at its right edge and in one group: the
   uuid to the clipboard and the row off the list. Both are the plain
   icon buttons of the tables and the detail views — the copy raised
   and frameless beside the name made the list restless, and it is no
   less an action than its neighbour. The group holds its place whether
   or not the uuids are switched on. */
.bookmark-actions {
  flex: none;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: auto;
  /* beside the first line of the name, not in the middle of a name
     that wrapped over four of them */
  align-self: flex-start;
}

/* www.hostsharing.net puts a chevron behind every link that leads on
   (\`bi-chevron-right\` after "Mehr erfahren"), which is what tells a
   link out of a card apart from a word merely printed in blue. It goes
   on the card titles and the link lists, both of which leave the
   dashboard for a page of their own — not on the sidebar or the
   footer, where every entry is a link anyway and a row of chevrons
   would only be noise. The mark is masked rather than painted so it
   takes the colour of its link, the orange on hover included. */
.overview-card h2 a::after,
.overview-links a::after,
.overview-more a::after {
  --chevron: url(${___CSS_LOADER_URL_REPLACEMENT_51___});

  content: '';
  display: inline-block;
  width: 0.65em;
  height: 0.65em;
  margin-left: 0.35em;
  vertical-align: -0.02em;
  background-color: currentcolor;
  -webkit-mask: var(--chevron) center / contain no-repeat;
  mask: var(--chevron) center / contain no-repeat;
}

.overview-list {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 0.9rem;
}

.overview-list li {
  margin: 0.4rem 0;
}

.overview-muted {
  color: var(--hs-text-muted);
  font-size: 0.85rem;
}

.notice-meta {
  display: block;
}

/* the page behind the card, one group per day: the heading belongs to
   the entries below it, so the air goes between the groups */
.whats-new-day + .whats-new-day {
  margin-top: 1.5rem;
}

.whats-new-day h2 {
  margin: 0 0 0.4rem;
  font-size: 1.05rem;
}

/* the notice priority colors its kind label (Wartung/Termin/Info) */
.notice-kind {
  font-weight: 600;
}

.notice-high .notice-kind {
  color: var(--hs-danger);
}

.notice-medium .notice-kind {
  color: var(--hs-orange);
}

.domain-row {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.status-dot {
  display: inline-block;
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  align-self: center;
}

.status-ok {
  background: var(--hs-blue);
}

.status-expiring {
  background: var(--hs-orange);
}

/* --- small screens (phones) ---------------------------------------- */

@media (max-width: 768px) {
  /* anchor for the sidebar overlay below */
  .app-shell {
    position: relative;
  }

  /* the opened sidebar overlays the content instead of squeezing it;
     collapsed it stays the narrow in-flow rail */
  .app-sidebar.is-open {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 20;
    overflow-y: auto;
    box-shadow: 4px 0 12px rgba(0, 0, 0, 0.15);
  }

  /* collapsed there is no rail at all — just a hamburger button
     floating left of the page title */
  .app-sidebar:not(.is-open) {
    position: absolute;
    top: 0.3rem;
    left: 0.25rem;
    width: auto;
    padding: 0;
    border-right: none;
    background: none;
  }

  /* and therefore no room for the icon rail either: a column of icons
     below that button would float over the content it covers */
  .app-sidebar .nav-rail {
    display: none;
  }

  /* bi-list replaces the » glyph (hidden via font-size).

     Collapsed, this button floats over the page instead of sitting in
     the menu, so it stays a bare icon in both states. Two reasons, and
     both bit us: on a touch device :hover sticks after a tap, so a
     filled background lingered long after the menu had folded away —
     and since the generic \`button:hover\` fills with the very blue the
     icon was painted in (equal specificity, but it comes later in this
     file, so it wins over \`.app-sidebar button:hover\`), the icon
     vanished into its own background: a blue rounded square. */
  .app-sidebar:not(.is-open) > button,
  .app-sidebar:not(.is-open) > button:hover {
    font-size: 0;
    padding: 0.5rem;
    background: none;
    color: var(--hs-blue);
  }

  .app-sidebar:not(.is-open) > button:hover {
    color: var(--hs-blue-dark);
  }

  .app-sidebar:not(.is-open) > button::before {
    content: '';
    display: block;
    width: 1.4rem;
    height: 1.4rem;
    /* like every other masked icon: follow the button's own colour
       rather than hardwiring one that a background may match */
    background-color: currentColor;
    -webkit-mask: var(--btn-icon) no-repeat center / contain;
    mask: var(--btn-icon) no-repeat center / contain;
    --btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  }

  /* topbar: logo icon only, wrap instead of overflowing */
  #root > nav {
    flex-wrap: wrap;
    padding: 0.5rem 0.75rem;
  }

  #root > nav::before {
    content: 'HSAdmin';
  }

  /* the topbar links shrink to icons (labels hidden via font-size,
     so they keep their accessible names); separators disappear */
  .topbar-sep {
    display: none;
  }

  /* the width toggle has nothing to offer here: a phone screen is
     narrower than the readable width anyway, so both of its settings
     look the same — while the button itself took the room that made
     the topbar wrap into a second line */
  .width-toggle {
    display: none;
  }

  #root > nav a.topbar-link {
    font-size: 0;
    padding: 0.25rem;
  }

  /* the label is gone, so the icon becomes the whole link: bigger,
     and without the gap that used to hold the label */
  #root > nav a.topbar-link::before {
    display: block;
    width: 1.3rem;
    height: 1.3rem;
    margin-right: 0;
  }

  /* The named buttons of a page give up their word the same way: on a
     screen this narrow the symbol is what there is room for, and a row
     of three spelt-out actions is what pushed the page wider than the
     window. The label stays in the markup, so it is still what the
     button is read out as — only its size goes.
     Dialogs keep their words: a question that has to be answered may
     not be answered by two symbols. */
  .app-content .form-actions button:not(dialog *) {
    font-size: 0;
    padding: 0.45rem 0.55rem;
  }

  /* The icon carries the button now, so it is sized in its own right
     rather than in an em of a font that is no longer there — an em
     would be nothing at all. The content area is named in front so
     that this outweighs the rules which give a single kind of button
     its icon size (\`button[type='submit'][form]\`, two attributes and
     an element, counts for more than a class and two elements). */
  .app-content .form-actions button:not(dialog *)::before {
    width: 1.05rem;
    height: 1.05rem;
    margin-right: 0;
  }

  /* one cycle button instead of a button per language — every tap
     advances to the next language */
  .language-switcher .language-choice {
    display: none;
  }

  .language-switcher .language-cycle {
    display: inline-block;
  }

  /* On a smartphone the window is the frame, so the border around the
     content goes — both halves of it. The grey gutter keeps only the
     strip above and below, enough that the white block does not grow
     into the topbar and the footer; the block itself gives up the
     inset it holds its content in. What is left of a screen that
     narrow is needed by the tables, and every part that has to keep
     its distance carries one of its own (a notice its frame, a card
     its padding, a table its cells). */
  .app-content > main {
    padding: 0.5rem 0;
  }

  /* The block keeps one narrow inset, the same on every page: without
     it the content sits on the glass and reads as cramped, and a table
     that begins at the very edge looks unfinished rather than wide.
     Twelve pixels are enough to see it is a page and little enough to
     leave the width to the content. */
  .app-content > main > * {
    padding: 0.5rem 0.75rem;
  }

  /* the left padding makes room for the floating menu button */
  .app-content > header {
    padding: 0.5rem 0.75rem 0.5rem 3rem;
  }

  #root > div:not(.app-shell):not(.update-notice) {
    padding: 0.5rem 0.75rem;
  }

  .update-notice {
    margin: 0 0.75rem;
  }

  footer {
    padding: 0.75rem;
  }

  /* stack labels above their values/inputs instead of beside them */
  .master-data {
    grid-template-columns: 1fr;
    gap: 0 0;
  }

  .master-data dd {
    margin-bottom: 0.35rem;
  }

  #bank-account-form label,
  #booking-item-cancel-form label,
  #booking-item-create-form label,
  #booking-item-resources-form label,
  #contact-form label,
  #hosting-asset-form label,
  #debitor-form label,
  #membership-form label,
  #partner-form label,
  #person-form label,
  .picker-dialog label {
    grid-template-columns: 1fr;
    gap: 0.15rem;
  }

  /* a day is picked with a thumb here: the cells are as tall as they
     are wide, which is what the finger needs and what the calendar has
     room for */
  .day-picker-grid button {
    padding: 0.55rem 0;
  }
}

.startup-error {
  max-width: 36rem;
  margin: 4rem auto;
  padding: 1.5rem;
  border: 1px solid color-mix(in srgb, var(--hs-danger) 30%, #fff);
  border-left: 4px solid var(--hs-danger);
  border-radius: var(--hs-radius-surface);
  background: color-mix(in srgb, var(--hs-danger) 5%, #fff);
}

.startup-error-cause {
  margin: 1rem 0 0;
  padding: 0.5rem 0.75rem;
  border-radius: var(--hs-radius-surface);
  background: color-mix(in srgb, var(--hs-text) 6%, #fff);
  font-size: 0.85rem;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.bank-account-issue:first-child {
  margin: 0 0.4em 0 0;
}

/* the status and the button that changes it, apart enough to read as two */
.vat-id-verification {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1.25rem;
}

.bank-directory-runs {
  margin: 0.25rem 0 1rem;
  padding-left: 1.25rem;
}

/* a checkbox whose text is too long for the label column: box and
   text share the value column, the label column stays empty */
.bank-account-fields label.checkbox-text-after > span:last-child {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

/* the bank of the IBAN typed, under the field in the value column:
   the label's indent, label column and gap */
.bank-account-fields .bank-of-iban {
  max-width: 34rem;
  margin: -0.2rem 0 0.4rem calc(0.75rem + 10rem + 1.5rem);
  color: var(--hs-text-muted);
  font-size: 0.85rem;
}

.bank-account-fields .bank-of-iban:empty {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/theme.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB;;wCAEsC;EACtC;;wCAEsC;EACtC,sBAAsB;EACtB,wBAAwB;EACxB;;;;;;;6DAO2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,+BAA+B;;AAE/B;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;;EAEE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;qEAGqE;AACrE;EACE,OAAO;EACP,WAAW;EACX,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;;;;yDAIyD;AACzD;;;;EAIE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;iEACiE;AACjE;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;AACf;;AAEA;qDACqD;AACrD;EACE,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;mDACmD;AACnD;EACE,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB;yCACuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;;4DAE4D;AAC5D;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,wDAAwD;EACxD,gDAAgD;AAClD;;AAEA,kBAAkB;AAClB;EACE,mDAAqb;AACvb;;AAEA,iBAAiB;AACjB;EACE,mDAA4gB;AAC9gB;;AAEA,6DAA6D;AAC7D;EACE,mDAAiX;AACnX;;AAEA,0CAA0C;;AAE1C;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;;kDAEkD;AAClD;EACE,OAAO;EACP,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;0CAC0C;AAC1C;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA,kCAAkC;;AAElC;EACE,cAAc;EACd;kEACgE;EAChE,WAAW;EACX,gBAAgB;EAChB,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;uCACuC;AACvC;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kCAAkC;EAClC,uCAAuC;EACvC,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;sCAGsC;AACtC;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;8DAC8D;AAC9D;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,uCAAuC;EACvC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,oEAAoE;EACpE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;6CAC6C;AAC7C;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oEAAoE;AACpE;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;8DAE8D;AAC9D;EACE,cAAc;EACd,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;0CAE0C;AAC1C;EACE,kCAAkC;EAClC,uCAAuC;EACvC,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;aAEa;AACb;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,8BAA8B;EAC9B,wDAAwD;EACxD,gDAAgD;EAChD,mDAAymB;AAC3mB;;AAEA;;;8DAG8D;AAC9D;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,8BAA8B;EAC9B,wDAAwD;EACxD,gDAAgD;EAChD,mDAA+a;AACjb;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,mDAA0c;AAC5c;;AAEA;;iBAEiB;AACjB;;;;;EAKE,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;;;4DAI4D;AAC5D;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;2CAE2C;AAC3C;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,yDAAyD;EACzD,iDAAiD;EACjD,oDAA2Q;EAC3Q,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,qBAAqB;EACrB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;;gCAGgC;AAChC;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;sCAEsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;gEACgE;AAChE;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;;gEAEgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf;sEACoE;EACpE,kCAAkC;EAClC,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;AACxC;;AAEA,kCAAkC;;AAElC;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf;;eAEa;AACf;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;;;QAKQ;AACR;;;;;;EAME,iBAAiB;EACjB;+DAC6D;EAC7D,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA,uCAAuC;;AAEvC;uCACuC;AACvC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkCE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,8BAA8B;EAC9B,wDAAwD;EACxD,gDAAgD;AAClD;;AAEA,8DAA8D;AAC9D;;;;2CAI2C;AAC3C;;;;;;;;;;;;EAYE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,+DAA+D;AAC/D;;;;;;;;;;;;EAYE,eAAe;AACjB;;AAEA;;;;;;;;;;;EAWE,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;;;4BAI4B;AAC5B;;;EAGE,aAAa;AACf;;AAEA;oDACoD;AACpD;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;;;;+DAK+D;AAC/D;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB;;qBAEmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;;;6BAI6B;AAC7B;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;sBAEsB;AACtB;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA,sDAAsD;AACtD;;EAEE,mDAAgT;AAClT;;AAEA;;6BAE6B;AAC7B;EACE,iBAAiB;AACnB;;AAEA;;;qCAGqC;AACrC;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,mDAAsU;AACxU;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,yDAAyD;AACzD;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,oDAAyP;AAC3P;;AAEA;EACE,oDAAsU;EACtU,eAAe;AACjB;;AAEA,kEAAkE;AAClE;EACE,oBAAoB;AACtB;;AAEA;EACE,oDAAyT;EACzT,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;0DAE0D;AAC1D;EACE,oDAAyf;EACzf,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,2DAA2D;;AAE3D;EACE,oDAA6e;EAC7e,eAAe;AACjB;;AAEA;;;sBAGsB;AACtB;EACE,oDAAmxB;AACrxB;;AAEA;EACE,oDAAgW;AAClW;;AAEA,qEAAqE;AACrE;EACE,oDAAwZ;EACxZ,eAAe;AACjB;;AAEA,gEAAgE;AAChE,kEAAkE;AAClE;EACE,eAAe;EACf,oDAAuf;AACzf;;AAEA;;;oEAGoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oDAAoc;AACtc;;AAEA;;;;;sBAKsB;AACtB;;;;EAIE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;;EAIE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,oDAAkhB;AACphB;;AAEA;EACE,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,oDAA4d;AAC9d;;AAEA;;iEAEiE;AACjE;EACE,cAAc;AAChB;;AAEA;;8DAE8D;AAC9D;;EAEE,SAAS;EACT;iDAC+C;EAC/C,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,oDAAqU;AACvU;;AAEA,2EAA2E;AAC3E;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,oDAAyT;AAC3T;;AAEA;;2DAE2D;AAC3D;;EAEE,oDAA6iB;AAC/iB;;AAEA,mBAAmB;AACnB;;EAEE,oDAA0T;AAC5T;;AAEA,gBAAgB;AAChB;;;EAGE,oDAAqU;AACvU;;AAEA;;;aAGa;AACb;;EAEE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;sEACsE;AACtE;EACE,mDAAiX;AACnX;;AAEA,wDAAwD;AACxD;EACE,oDAA2+C;AAC7+C;;AAEA,4DAA4D;AAC5D;EACE,oDAA20B;AAC70B;;AAEA,mCAAmC;AACnC;;EAEE,oDAA+9B;AACj+B;;AAEA,8BAA8B;AAC9B;;EAEE,oDAA4lB;AAC9lB;;AAEA,8BAA8B;AAC9B;;EAEE,oDAAqqD;AACvqD;;AAEA,wCAAwC;AACxC;;EAEE,oDAAsX;AACxX;;AAEA,4BAA4B;AAC5B;;EAEE,oDAAwqB;AAC1qB;;AAEA,gCAAgC;AAChC,oBAAoB;AACpB;EACE,oDAAstB;AACxtB;;AAEA;;EAEE,oDAAoa;AACta;;AAEA,oCAAoC;AACpC;;EAEE,oDAAiZ;AACnZ;;AAEA,sCAAsC;AACtC;EACE,mDAAymB;AAC3mB;;AAEA,wCAAwC;AACxC;EACE,oDAA48B;AAC98B;;AAEA,oCAAoC;AACpC;EACE,oDAA2nB;AAC7nB;;AAEA,sCAAsC;AACtC;EACE,oDAAkkB;AACpkB;;AAEA,sEAAsE;AACtE;;EAEE,oDAA+gB;AACjhB;;AAEA;;;gDAGgD;AAChD;EACE,oDAA2X;AAC7X;;AAEA;;;;6CAI6C;AAC7C;EACE,oDAAqU;AACvU;;AAEA,oCAAoC;AACpC;EACE,oDAA8gB;AAChhB;;AAEA,sDAAsD;;AAEtD;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,iBAAiB;AACnB;;AAEA;;;sEAGsE;AACtE;EACE,kBAAkB;AACpB;;AAEA;;;;;4DAK4D;AAC5D;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,oEAAoE;AACpE;EACE,oDAAsT;;EAEtT,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,oDAAkO;AACpO;;AAEA;;;;;;;;;;;;;;;;;;EAkBE;AACF;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR;oCACkC;EAClC,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,0DAA0D;EAC1D,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;;mCAEmC;AACnC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iEAAiE;AACjE;EACE,uCAAuC;EACvC,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,qBAAqB;AACvB;;AAEA;;uDAEuD;AACvD;4CAC4C;AAC5C;EACE,aAAa;EACb;;qBAEmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,+DAA+D;EAC/D,kBAAkB;AACpB;;AAEA;;;;;yBAKyB;AACzB,+EAA+E;AAC/E;EACE,sDAAimB;EACjmB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,0DAA0D;EAC1D,kDAAkD;AACpD;;AAEA;EACE,uDAAorB;EACprB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,2DAA2D;EAC3D,mDAAmD;AACrD;;AAEA;;;;sCAIsC;AACtC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mEAAmE;EACnE,YAAY;AACd;;AAEA;;wDAEwD;AACxD;EACE,gCAAgC;AAClC;;AAEA;;;qEAGqE;AACrE;;EAEE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,4CAA4C;;AAE5C;;kEAEkE;AAClE;;sEAEsE;AACtE;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;AACd;;AAEA;mBACmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;;;OAGO;AACP;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,oCAAoC;EACpC,kCAAkC;EAClC,uCAAuC;EACvC,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;;uDAEuD;AACvD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qEAAqE;AACrE;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;;uDAEuD;AACvD;EACE,kBAAkB;AACpB;;AAEA;;oEAEoE;AACpE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,uCAAuC;EACvC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,SAAS;EACT,yCAAyC;EACzC,oEAAoE;EACpE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;;oEAGoE;AACpE;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA,4DAA4D;EAC5D;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA,uDAAuD;;AAEvD,oDAAoD;AACpD;EACE,oDAAsoB;AACxoB;;AAEA,+DAA+D;AAC/D;EACE,oDAAoP;AACtP;;AAEA;EACE,oDAAqP;AACvP;;AAEA;;;;;EAKE;AACF;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;;uCAGuC;AACvC;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,OAAO;EACP,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,uCAAuC;EACvC,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;iEACiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;SACS;AACT;EACE,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,uCAAuC;EACvC,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;+CAC+C;AAC/C;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,iDAAiD;;AAEjD;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gEAAgE;EAChE,uCAAuC;EACvC,uCAAuC;EACvC,yDAAyD;AAC3D;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;+DAC+D;AAC/D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gEAAgE;EAChE,uCAAuC;EACvC,uCAAuC;EACvC,yDAAyD;EACzD,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,6CAA6C;;AAE7C;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;;yBAEyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,kCAAkC;EAClC,uCAAuC;EACvC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;oEACoE;AACpE;EACE,kCAAkC;EAClC,uCAAuC;EACvC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;wEACwE;AACxE;EACE,kCAAkC;EAClC,uCAAuC;EACvC,uCAAuC;EACvC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;;WAIW;AACX;EACE,kCAAkC;EAClC,uCAAuC;EACvC,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;;4DAE4D;AAC5D;EACE;;wCAEsC;EACtC,gCAAgC;;EAEhC,kCAAkC;EAClC,uCAAuC;EACvC,oBAAoB;EACpB,uBAAuB;EACvB;;;;;;iEAM+D;EAC/D,uCAAuC;EACvC,gBAAgB;EAChB,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;;;gEAGgE;AAChE;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sDAAsD;;AAEtD;;;6DAG6D;AAC7D;EACE,aAAa;EACb,gEAAgE;EAChE,mBAAmB;EACnB,gBAAgB;EAChB;gDAC8C;EAC9C,qBAAqB;AACvB;;AAEA;oEACoE;AACpE;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA,oDAAoD;;AAEpD,uEAAuE;AACvE;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;qEAEqE;AACrE;EACE,aAAa;EACb,2CAA2C;EAC3C,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;EAChC,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;;;;iEAIiE;AACjE;EACE,4DAA4D;EAC5D,oBAAoB;EACpB,eAAe;AACjB;;AAEA,mEAAmE;AACnE;;EAEE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE;AACF;;;;EAIE,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;8CAG8C;AAC9C;EACE,YAAY;EACZ,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,+BAA+B;;AAE/B;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,iCAAiC;;AAEjC;;;;;2CAK2C;AAC3C;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;+DAG+D;AAC/D;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;mDACmD;AACnD;EACE,mBAAmB;EACnB,gBAAgB;EAChB;iCAC+B;EAC/B,gBAAgB;EAChB;;;;;;iEAM+D;EAC/D,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;+DAC+D;AAC/D;EACE,mBAAmB;AACrB;;AAEA;;;;;0CAK0C;AAC1C;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;gDASgD;AAChD;EACE,0EAA0E;;EAE1E,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;mBAcmB;AACnB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB;;iEAE+D;EAC/D,qEAAqE;;EAErE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;yCAEyC;AACzC;EACE,mBAAmB;AACrB;;AAEA;;uDAEuD;AACvD;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;2BAC2B;AAC3B;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,iEAAiE;EACjE,mBAAmB;EACnB,yCAAyC;EACzC;6DAC2D;EAC3D,mBAAmB;AACrB;;AAEA;;;;2CAI2C;AAC3C;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;;;4DAS4D;AAC5D;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,0BAA0B;EAC1B,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;;EAiBE;AACF;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;uBAMuB;AACvB;;EAEE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;2BAG2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN;2CACyC;EACzC,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;iEACiE;AACjE;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;qEAIqE;AACrE;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;;kDAGkD;AAClD;EACE,eAAe;AACjB;;AAEA;;;;;;;;6CAQ6C;AAC7C;;EAEE,kCAAkC;;EAElC,uCAAuC;EACvC,2CAA2C;EAC3C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;;oEAIoE;AACpE;EACE,sBAAsB;EACtB;;sDAEoD;EACpD,YAAY;EACZ,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,yDAAyD;AACzD;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,iEAAiE;EACjE,gBAAgB;EAChB,wCAAwC;EACxC;yEACuE;EACvE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;uEACuE;AACvE;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;;;;;;;6CAO6C;AAC7C;EACE,gBAAgB;AAClB;;AAEA,iCAAiC;;AAEjC;;;;;EAKE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE;AACF;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;EACpB;;2BAEyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;kCACkC;AAClC;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;;;;;;gDAMgD;AAChD;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;gDACgD;AAChD;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;2DAC2D;AAC3D;EACE,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,4DAA4D;AAC5D;EACE,oDAAoP;AACtP;;AAEA;EACE,oDAAqP;AACvP;;AAEA;6DAC6D;AAC7D;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;sEAEoE;EACpE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;;;;oCAIoC;AACpC;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;sEAEsE;AACtE;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,2CAA2C;;AAE3C,sEAAsE;AACtE;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB;;;;;GAKC;EACD,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA,qDAAqD;AACrD;EACE;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;;;;;kEAOkE;AAClE;;;;;;;;;;;EAWE,aAAa;EACb,2CAA2C;EAC3C;;sEAEoE;EACpE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB;;;;;;qCAMmC;EACnC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;sEAMsE;AACtE;;;;;;;;;;;;;;;;;EAiBE;;;;aAIW;EACX,gCAAgC;EAChC,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;gDAEgD;AAChD;;;;EAIE,WAAW;AACb;;AAEA;;iDAEiD;AACjD;;EAEE,gBAAgB;AAClB;;AAEA;;;;yDAIyD;AACzD;;;;;;;EAOE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA,gCAAgC;;AAEhC;EACE,kCAAkC;EAClC,uCAAuC;EACvC,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;;;;;;yCAMyC;AACzC;;mBAEmB;AACnB;EACE,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;EACrB;;iCAE+B;EAC/B,oEAAoE;EACpE,wBAAwB;AAC1B;;AAEA;;;EAGE,aAAa;EACb,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;;;;kBAIkB;AAClB;EACE,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;0BAC0B;AAC1B;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA,iCAAiC;;AAEjC;sCACsC;AACtC;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;qEACqE;AACrE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;2DAE2D;AAC3D;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,wDAAwD;EACxD,gDAAgD;EAChD,oDAAsU;AACxU;;AAEA;EACE,qBAAqB;AACvB;;AAEA;wCACwC;AACxC;EACE,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;aAEa;AACb;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;0DAI0D;AAC1D;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;2DAC2D;AAC3D;EACE,uBAAuB;AACzB;;AAEA,uEAAuE;;AAEvE;;;oEAGoE;AACpE;EACE,oDAAiS;;EAEjS,eAAe;EACf,WAAW;EACX;;;;;;;0BAOwB;EACxB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,wDAAwD;EACxD,gDAAgD;AAClD;;AAEA,uEAAuE;;AAEvE;+DAC+D;AAC/D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,uCAAuC;EACvC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA,mEAAmE;AACnE;EACE,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,wDAAwD;EACxD,gDAAgD;EAChD,oDAAsX;AACxX;;AAEA;EACE,uBAAuB;AACzB;;AAEA,uEAAuE;;AAEvE;kEACkE;AAClE;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;oDACoD;AACpD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;qEACqE;AACrE;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB;mEACiE;EACjE,kBAAkB;AACpB;;AAEA;;mEAEmE;AACnE;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;;;;;2CAK2C;AAC3C;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;oEACoE;AACpE;EACE,mDAAmD;AACrD;;AAEA;;;;;qCAKqC;AACrC;4DAC4D;AAC5D;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;kBAEkB;AAClB;EACE,eAAe;AACjB;;AAEA;kEACkE;AAClE;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB;;;;gCAI8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;oEAGoE;AACpE;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;uCACuC;AACvC;EACE,WAAW;AACb;;AAEA,kDAAkD;AAClD;EACE,mDAAmD;AACrD;;AAEA;EACE,WAAW;AACb;;AAEA;;+BAE+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;2CAG2C;AAC3C;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,+BAA+B;EAC/B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;sEAIsE;AACtE;EACE,UAAU;EACV,2BAA2B;EAC3B,iBAAiB;EACjB;uCACqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;yDACyD;AACzD;EACE,OAAO;EACP,YAAY;AACd;;AAEA;;;;;sCAKsC;AACtC;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB;qCACmC;EACnC,sBAAsB;AACxB;;AAEA;;;;;;;gEAOgE;AAChE;;;EAGE,mDAAqP;;EAErP,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,uDAAuD;EACvD,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;6DAC6D;AAC7D;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,wEAAwE;;AAExE;EACE,yCAAyC;EACzC;IACE,kBAAkB;EACpB;;EAEA;iDAC+C;EAC/C;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,0CAA0C;EAC5C;;EAEA;sCACoC;EACpC;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;+DAC6D;EAC7D;IACE,aAAa;EACf;;EAEA;;;;;;;;;+DAS6D;EAC7D;;IAEE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,cAAc;IACd,aAAa;IACb,cAAc;IACd;+DAC2D;IAC3D,8BAA8B;IAC9B,wDAAwD;IACxD,gDAAgD;IAChD,oDAAwU;EAC1U;;EAEA,wDAAwD;EACxD;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;iEAC+D;EAC/D;IACE,aAAa;EACf;;EAEA;;;yCAGuC;EACvC;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;sDACoD;EACpD;IACE,cAAc;IACd,aAAa;IACb,cAAc;IACd,eAAe;EACjB;;EAEA;;;;;;sCAMoC;EACpC;IACE,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;;;;;kEAKgE;EAChE;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;oCACkC;EAClC;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;;;;;;uCAOqC;EACrC;IACE,iBAAiB;EACnB;;EAEA;;;;sCAIoC;EACpC;IACE,uBAAuB;EACzB;;EAEA,6DAA6D;EAC7D;IACE,mCAAmC;EACrC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,kEAAkE;EAClE;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;;;;;;;;IAWE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;;eAEa;EACb;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gEAAgE;EAChE,uCAAuC;EACvC,uCAAuC;EACvC,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,uCAAuC;EACvC,uDAAuD;EACvD,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;8DAC8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;6CAC6C;AAC7C;EACE,gBAAgB;EAChB,uDAAuD;EACvD,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/*\n * Hostsharing corporate design theme, palette from\n * https://www.hostsharing.net: blue #005094 (primary), orange #dd4901\n * (logo and accents only), light #f8f9fa page background, white\n * content surfaces, #dee2e6 borders.\n */\n\n:root {\n  --hs-blue: #005094;\n  --hs-blue-dark: #004076;\n  --hs-blue-pale: #d9e4f2;\n  --hs-orange: #dd4901;\n  --hs-danger: #940050;\n  --hs-text: #212529;\n  --hs-text-muted: #6c757d;\n  --hs-bg-subtle: #f8f9fa;\n  --hs-border: #dee2e6;\n  --hs-font:\n    system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans',\n    'Liberation Sans', Arial, sans-serif;\n  /* www.hostsharing.net draws its blocks square (`rounded-0`) and\n     leaves the rounding to the controls — a surface is set apart by\n     its colour, a button by its shape */\n  --hs-radius-surface: 0;\n  --hs-radius-control: 4px;\n  /* www.hostsharing.net puts the whole page into one centered column,\n     its Bootstrap `.container-lg`. That container is not one width but\n     a ladder, and taking only the middle rung of it left this app\n     narrower than the site on every wide monitor — so the rungs are\n     mirrored below. Under the first one the column fills the window,\n     as it does there. A table wider than the space left next to the\n     sidebar scrolls inside its own box, and the width toggle lifts\n     the cap altogether for whoever wants the whole window. */\n  --hs-page-width: none;\n}\n\n@media (min-width: 992px) {\n  :root {\n    --hs-page-width: 960px;\n  }\n}\n\n@media (min-width: 1200px) {\n  :root {\n    --hs-page-width: 1140px;\n  }\n}\n\n@media (min-width: 1400px) {\n  :root {\n    --hs-page-width: 1320px;\n  }\n}\n\n/* ---------- base ---------- */\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  background: var(--hs-bg-subtle);\n  color: var(--hs-text);\n  font-family: var(--hs-font);\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n/* top bar plus content fill the viewport height */\nbody,\n#root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Everything the app shows lives in one column: topbar, shell and\n   footer share the same width and the same centre, so a wide window\n   frames the app instead of pushing it against its left edge. The\n   width toggle in the topbar lifts the cap (see body.wide-layout). */\n#root {\n  flex: 1;\n  width: 100%;\n  max-width: var(--hs-page-width);\n  margin: 0 auto;\n}\n\n/* www.hostsharing.net writes its section headings `display-6 fw-normal`\n   and leaves everything under them at the 500 Bootstrap gives headings\n   anyway: size and blue already set a heading apart, and the bold of\n   the browser default only makes it shout. Table headers are not\n   headings in this sense and keep the weight they had. */\nh1,\nh2,\nh3,\nh4 {\n  color: var(--hs-blue);\n  font-weight: 400;\n  line-height: 1.25;\n}\n\n/* below the page heading a heading labels a part of the page rather\n   than opening one, and carries the slight extra weight for it */\nh3,\nh4 {\n  font-weight: 500;\n}\n\nh1 {\n  font-size: 1.6rem;\n}\n\nh2 {\n  font-size: 1.3rem;\n}\n\na {\n  color: var(--hs-blue);\n  text-decoration: none;\n}\n\na:hover {\n  color: var(--hs-orange);\n  text-decoration: underline;\n}\n\npre,\ncode {\n  font-size: 0.875em;\n  background: var(--hs-bg-subtle);\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-surface);\n}\n\ncode {\n  padding: 0.1em 0.35em;\n  color: var(--hs-blue-dark);\n}\n\npre {\n  padding: 0.75rem 1rem;\n  overflow-x: auto;\n}\n\n/* stray <br/> siblings of the top navigation */\n#root > br {\n  display: none;\n}\n\n/* plain pages (landing, login, user): centered white column — the\n   update hint is a sibling of the page, not a page */\n#root > div:not(.app-shell):not(.update-notice) {\n  flex: 1;\n  width: 100%;\n  max-width: 1140px;\n  margin: 0 auto;\n  padding: 0.5rem 1.5rem;\n  background: #fff;\n}\n\n/* ---------- top bar ---------- */\n\n#root > nav {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1.5rem;\n  background: #fff;\n  color: var(--hs-text-muted);\n  font-size: 0.9rem;\n  border-bottom: 1px solid var(--hs-border);\n}\n\n/* brand: Hostsharing logo icon (SVG from hostsharing.net) plus\n   wordmark, via CSS to keep the markup untouched */\n#root > nav::before {\n  content: 'Hostsharing HSAdmin NG';\n  margin-right: auto;\n  padding-left: 2rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--hs-blue);\n  letter-spacing: 0.02em;\n  background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 23.3 23.3'%3E%3Cpath fill='%23DD4901' d='M2.468,18.934c-3.945-6.559-2.946-11.646,1.48-15.935c2.779-2.692,5.046-2.207,5.05-1.587c0.068,5.693-1.315,10.989-2.651,16.416C5.577,21.34,4.801,22.346,2.468,18.934zM12.678,8.46c-1.176-2.493-4.838-8.884,0.136-8.438c9.13-0.013,13.601,13.388,8.224,16.806C20.042,17.618,14.552,12.342,12.678,8.46z'/%3E%3Cpath fill='%23DD4901' d='M7.553,21.31c-0.324-0.784-0.349-1.759,0.109-3.124c1.411-4.204,6.672-5.216,9.51-1.832C21.784,21.567,10.281,25.967,7.553,21.31z'/%3E%3C/svg%3E\")\n    no-repeat left center / 1.5rem 1.5rem;\n}\n\n#root > nav a {\n  color: var(--hs-blue);\n  font-weight: 500;\n  padding: 0.15rem 0.25rem;\n}\n\n#root > nav a:hover {\n  color: var(--hs-orange);\n  text-decoration: none;\n}\n\n/* every topbar link carries its icon in front of the label. On phones\n   the label gives way (font-size: 0 in the media query) and only the\n   icon remains — so the icon has to exist in both states. */\n#root > nav a.topbar-link::before {\n  content: '';\n  display: inline-block;\n  width: 1.1em;\n  height: 1.1em;\n  margin-right: 0.4em;\n  vertical-align: -0.2em;\n  background-color: currentColor;\n  -webkit-mask: var(--btn-icon) no-repeat center / contain;\n  mask: var(--btn-icon) no-repeat center / contain;\n}\n\n/* bi-house-door */\n.topbar-dashboard::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z'/%3E%3C/svg%3E\");\n}\n\n/* bi-briefcase */\n.topbar-administration::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z'/%3E%3C/svg%3E\");\n}\n\n/* bi-person — the same icon the sidebar user entry carries */\n.topbar-user::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z'/%3E%3C/svg%3E\");\n}\n\n/* ---------- dashboard shell ---------- */\n\n.app-shell {\n  display: flex;\n  flex: 1;\n}\n\n.app-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* White blocks on the light page background, the way the sections on\n   www.hostsharing.net are stacked: the content area itself is the grey\n   gutter, the page inside it the white surface. */\n.app-content > main {\n  flex: 1;\n  padding: 1rem;\n  background: var(--hs-bg-subtle);\n}\n\n.app-content > main > * {\n  padding: 1.25rem 1.5rem;\n  background: #fff;\n}\n\n/* except the dashboard, where the cards are the white blocks and the\n   grey has to show through between them */\n.app-content > main > .overview-grid {\n  padding: 0;\n  background: none;\n}\n\n.app-content > header {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.75rem 1.5rem;\n  border-bottom: 1px solid var(--hs-border);\n  background: #fff;\n}\n\n.app-content > header h1 {\n  margin: 0;\n  font-size: 1.35rem;\n}\n\n/* ---------- sidebar ---------- */\n\n.app-sidebar {\n  flex-shrink: 0;\n  /* collapsed this is the width of the icon rail below the chevron:\n     room for a 20px icon plus its padding and the active marker */\n  width: 56px;\n  background: #fff;\n  border-right: 1px solid var(--hs-border);\n  padding: 0.75rem 0.5rem;\n}\n\n.app-sidebar.is-open {\n  width: 250px;\n}\n\n.app-sidebar nav br {\n  display: none;\n}\n\n/* partner selector in the sidebar head, set apart from the menu\n   around it by a bit of vertical air */\n.partner-selector {\n  display: flex;\n  align-items: baseline;\n  gap: 0.25rem;\n  width: 100%;\n  margin: 0.75rem 0 1rem;\n  padding: 0.4rem 0.5rem;\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-control);\n  background: #fff;\n  font: 600 0.9rem var(--hs-font);\n  color: var(--hs-blue-dark);\n}\n\np.partner-selector {\n  border-color: transparent;\n}\n\n/* number and name of the current partner: one line, cut off with an\n   ellipsis rather than wrapped — the sidebar head must keep its\n   height, and the tooltip carries the full text (the option list\n   below spells it out and may wrap) */\n.partner-selector-label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n/* filterable dropdown: toggle button + popup with filter input and\n   option list; the popup overlays the sidebar content below */\n.partner-selector-wrapper {\n  position: relative;\n}\n\n.partner-selector-toggle {\n  text-align: left;\n  cursor: pointer;\n}\n\n/* the arrow keeps its width whatever the label does */\n.partner-selector-toggle::after {\n  content: '▾';\n  flex: none;\n  color: var(--hs-blue);\n}\n\n.partner-selector-popup {\n  position: absolute;\n  z-index: 10;\n  left: 0;\n  right: 0;\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-control);\n  background: #fff;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.partner-selector-filter {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.4rem 0.5rem;\n  border: 0;\n  border-bottom: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-control) var(--hs-radius-control) 0 0;\n  font: 0.9rem var(--hs-font);\n}\n\n.partner-selector-options {\n  margin: 0;\n  padding: 0.25rem 0;\n  list-style: none;\n  max-height: 40vh;\n  overflow-y: auto;\n}\n\n/* here the name is written out in full and wraps if it has to — the\n   list is what one reads to pick a partner */\n.partner-selector-option {\n  padding: 0.3rem 0.5rem;\n  font: 600 0.9rem var(--hs-font);\n  color: var(--hs-blue-dark);\n  cursor: pointer;\n  overflow-wrap: anywhere;\n}\n\n.partner-selector-option.is-active {\n  background: var(--hs-blue-pale);\n}\n\n/* \"all partners\" stands apart from the concrete partners below it */\n.partner-selector-option.all-partners {\n  margin-bottom: 0.35rem;\n  padding-bottom: 0.55rem;\n  border-bottom: 1px solid var(--hs-border);\n}\n\n.partner-selector-option[aria-selected='true'] {\n  color: var(--hs-blue);\n}\n\n/* what the Magic Search found this partner by — the one line above it\n   shows number and name and nothing else, so a match in a mail address\n   or a phone number would otherwise stand there unexplained */\n.partner-selector-hint {\n  display: block;\n  font: italic 0.8rem var(--hs-font);\n  color: var(--hs-text-muted);\n  overflow-wrap: anywhere;\n}\n\n.partner-selector-empty {\n  padding: 0.3rem 0.5rem;\n  font: italic 0.9rem var(--hs-font);\n  color: var(--hs-text-muted);\n}\n\n/* the same choice out of the collapsed rail: a dropdown hanging off a\n   56px column would be narrower than any partner name, so it opens as\n   a dialog with the room the names need */\n.partner-dialog {\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-surface);\n  padding: 1rem 1.5rem;\n  width: min(26rem, 92vw);\n}\n\n.partner-dialog::backdrop {\n  background: rgb(0 0 0 / 30%);\n}\n\n.partner-dialog h2 {\n  margin-top: 0;\n}\n\n.partner-dialog .partner-selector-filter {\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-control);\n}\n\n.partner-dialog .partner-selector-options {\n  max-height: 60vh;\n}\n\n/* key indicator next to the page title while project roles are\n   assumed; links to the project area, the tooltip names the entered\n   projects */\n.assumed-role-indicator {\n  color: var(--hs-orange);\n  line-height: 1;\n}\n\n.assumed-role-indicator:hover {\n  color: var(--hs-orange);\n}\n\n/* bi-key */\n.assumed-role-indicator::before {\n  content: '';\n  display: inline-block;\n  width: 1.25em;\n  height: 1.25em;\n  vertical-align: -0.25em;\n  background-color: currentColor;\n  -webkit-mask: var(--btn-icon) no-repeat center / contain;\n  mask: var(--btn-icon) no-repeat center / contain;\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8zm4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5z'/%3E%3Cpath d='M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'/%3E%3C/svg%3E\");\n}\n\n/* width toggle, right before the language buttons: icon only, in the\n   same muted topbar tone. bi-arrows-angle-expand while the content is\n   held at its readable width, bi-arrows-angle-contract while it uses\n   the whole window — the icon shows what the click will do. */\n.width-toggle {\n  padding: 0.1rem 0.35rem;\n  border: 1px solid transparent;\n  color: var(--hs-text-muted);\n  line-height: 1;\n}\n\n.width-toggle::before {\n  content: '';\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  background-color: currentColor;\n  -webkit-mask: var(--btn-icon) no-repeat center / contain;\n  mask: var(--btn-icon) no-repeat center / contain;\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707z'/%3E%3C/svg%3E\");\n}\n\n.width-toggle.is-wide {\n  border-color: var(--hs-border);\n  color: var(--hs-blue-dark);\n}\n\n.width-toggle.is-wide::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M9.828 5.172a.5.5 0 0 0-.707 0L5.025 9.268V6.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H8.5a.5.5 0 0 0 0-1H5.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 5.656a.5.5 0 0 0 .707 0l4.096-4.096V9.5a.5.5 0 0 0 1 0V5.525a.5.5 0 0 0-.5-.5H15.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707z' transform='translate(-4 -1)'/%3E%3C/svg%3E\");\n}\n\n/* the whole window width instead of the readable one; the padding of\n   the content area stays, a table flush against the window edge would\n   look cramped */\nbody.wide-layout #root,\nbody.wide-layout table,\nbody.wide-layout .crud-table,\nbody.wide-layout .crud-table-region,\nbody.wide-layout #root > div:not(.app-shell):not(.update-notice) {\n  max-width: none;\n}\n\n/* language toggle at the right end of the topbar */\n.language-switcher {\n  display: inline-flex;\n  gap: 0.25rem;\n}\n\n.language-switcher button {\n  padding: 0.1rem 0.45rem;\n  font-size: 0.8rem;\n  border: 1px solid transparent;\n  color: var(--hs-text-muted);\n}\n\n.language-switcher button[aria-pressed='true'] {\n  border-color: var(--hs-border);\n  color: var(--hs-blue-dark);\n  font-weight: 600;\n}\n\n/* the phone-only cycle button (see the media query below) */\n.language-switcher .language-cycle {\n  display: none;\n  border-color: var(--hs-border);\n  color: var(--hs-blue-dark);\n  font-weight: 600;\n}\n\n/* menu group headings (Verwaltung / Hosting) */\n.app-sidebar .nav-group {\n  margin: 0.75rem 0.5rem 0.25rem;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--hs-text-muted);\n}\n\n/* The heading is also the fold toggle of its area: it keeps looking\n   like the heading — only the small triangle says it folds — so the\n   flat-menu-button look every sidebar button gets is taken back here.\n   The padding is negated by the margin: the text stays where the\n   plain heading stands, the touch target grows around it. */\n.app-sidebar .nav-group-toggle {\n  width: auto;\n  padding: 0.2rem 0.4rem;\n  margin: -0.2rem -0.4rem;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n}\n\n/* the fold marker follows the heading text, as such menus usually\n   carry it: a chevron (bi-chevron-down) pointing down while the area\n   is open, right while it is folded away */\n.app-sidebar .nav-group-toggle::after {\n  content: '';\n  display: inline-block;\n  width: 0.7em;\n  height: 0.7em;\n  margin-left: 0.4em;\n  background-color: currentColor;\n  -webkit-mask: var(--fold-icon) no-repeat center / contain;\n  mask: var(--fold-icon) no-repeat center / contain;\n  --fold-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");\n  transform: rotate(-90deg);\n}\n\n.app-sidebar .nav-group-toggle[aria-expanded='true']::after {\n  transform: none;\n}\n\n.app-sidebar .nav-group-toggle:hover {\n  background: none;\n  color: var(--hs-blue-dark);\n}\n\n.app-sidebar a {\n  display: block;\n  padding: 0.4rem 0.75rem;\n  margin: 0.1rem 0;\n  border-radius: var(--hs-radius-control);\n  border-left: 3px solid transparent;\n}\n\n.app-sidebar a:hover {\n  background: var(--hs-blue-pale);\n  color: var(--hs-blue-dark);\n  text-decoration: none;\n}\n\n.app-sidebar a.active {\n  border-left-color: var(--hs-orange);\n  background: var(--hs-blue-pale);\n  color: var(--hs-blue-dark);\n  font-weight: 600;\n}\n\n/* flat buttons (toggle, accordions, logout) */\n.app-sidebar button {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 0.4rem 0.75rem;\n  margin: 0.1rem 0;\n  background: none;\n  border: none;\n  border-radius: var(--hs-radius-control);\n  color: var(--hs-blue);\n  font: 500 0.95rem var(--hs-font);\n  cursor: pointer;\n}\n\n.app-sidebar button:hover {\n  background: var(--hs-blue-pale);\n  color: var(--hs-blue-dark);\n}\n\n/* the partner selector keeps more vertical air than the flat menu\n   buttons around it (same margins as its <p> variants above) and stays\n   the flex row that clips its label — the rule above turns every\n   sidebar button into a block */\n.app-sidebar button.partner-selector {\n  display: flex;\n  margin: 0.75rem 0 1rem;\n}\n\n/* the logout action indents like the nav links around it (the same\n   3px slot their active-marker border occupies), slightly set off\n   vertically from the entries above */\n.app-sidebar .nav-logout {\n  margin: 0.75rem 0 0.25rem;\n}\n\n.app-sidebar .nav-logout button {\n  border-left: 3px solid transparent;\n}\n\n/* collapse/expand chevron («/», label via title/aria-label),\n   sitting at the sidebar's inner edge as usual for such menus */\n.app-sidebar > button {\n  padding: 0.4rem 0.5rem;\n  font-size: 1.1rem;\n  line-height: 1;\n  text-align: right;\n  color: var(--hs-text-muted);\n}\n\n/* the collapsed sidebar keeps a rail of icon-only links below the\n   chevron, so a narrowed window or a tablet does not lose the\n   navigation altogether. The labels live in title/aria-label. */\n.app-sidebar .nav-rail {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 0.5rem;\n}\n\n.app-sidebar .nav-rail a,\n.app-sidebar .nav-rail button {\n  width: auto;\n  padding: 0.4rem;\n  /* the active marker takes a 3px border on the left; a matching\n     transparent one on the right keeps the icon centred in the rail */\n  border-left: 3px solid transparent;\n  border-right: 3px solid transparent;\n  color: var(--hs-blue);\n  line-height: 0;\n}\n\n/* the group separator; the headings themselves are too wide here */\n.app-sidebar .nav-rail hr {\n  width: 60%;\n  margin: 0.4rem 0;\n  border: none;\n  border-top: 1px solid var(--hs-border);\n}\n\n/* ---------- buttons ---------- */\n\nbutton {\n  font-family: var(--hs-font);\n  font-size: 0.9rem;\n  padding: 0.4rem 1rem;\n  border-radius: var(--hs-radius-control);\n  border: 1px solid var(--hs-blue);\n  background: #fff;\n  color: var(--hs-blue);\n  cursor: pointer;\n  transition:\n    background-color 0.15s,\n    color 0.15s;\n}\n\nbutton:hover:not(:disabled) {\n  background: var(--hs-blue);\n  color: #fff;\n}\n\nbutton:disabled {\n  border-color: var(--hs-border);\n  color: var(--hs-text-muted);\n  cursor: not-allowed;\n}\n\n/* Primary actions. There is no filled button anywhere on\n   www.hostsharing.net — even its calls to action are drawn as an\n   outline — so the primary action is not marked by a blue block but\n   by a heavier border and a firmer label. The hover it shares with\n   every other button fills it blue, which is where the colour comes\n   in. */\nbutton[type='submit'],\n.contact-submit button,\n.contact-create button,\n.person-submit button,\n.person-create button,\n.subscription-submit button {\n  border-width: 2px;\n  /* taken back out of the padding: the thicker border would otherwise\n     make the button taller than the ones standing next to it */\n  padding: calc(0.4rem - 1px) calc(1rem - 1px);\n  font-weight: 500;\n}\n\n/* ---------- button icons ---------- */\n\n/* Bootstrap Icons as SVG masks; currentColor keeps them in the\n   button's text color, also on hover */\n.btn-reload::before,\n.btn-create::before,\n.btn-filter::before,\n.btn-filter-mode::before,\n.btn-filter-clear::before,\n.btn-show-all::before,\n.btn-download::before,\n.btn-copy::before,\n.btn-magnify::before,\n.btn-delete::before,\n.btn-edit::before,\n.btn-goto::before,\n.resources-hint::before,\n.contact-create > button::before,\n.contact-submit > button::before,\n.person-submit > button::before,\n.person-create > button::before,\n.subscription-submit > button::before,\n.app-sidebar nav p.nav-logout button::before,\n.app-sidebar .nav-rail button::before,\n.app-sidebar a.nav-icon::before,\n.bookmark-area::before,\n.bookmark-toggle::before,\n.btn-page-back::before,\n.btn-page-on::before,\n.btn-calendar::before,\n.btn-month-back::before,\n.btn-month-on::before,\n.btn-cancel::before,\n.btn-close::before,\n.btn-reset::before,\n.confirm-dialog-confirm button::before,\nbutton[type='submit'][form]::before,\nform button[type='submit']::before {\n  content: '';\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  margin-right: 0.45em;\n  vertical-align: -0.125em;\n  background-color: currentColor;\n  -webkit-mask: var(--btn-icon) no-repeat center / contain;\n  mask: var(--btn-icon) no-repeat center / contain;\n}\n\n/* bi-arrow-clockwise — icon-only reload in the table header */\n/* icon buttons in the tables — the header tools (filter, reload, add,\n   filter-row eraser) and the data-row actions (edit, delete, download,\n   copy-uuid). Deliberately discreet: small square buttons in muted\n   grey that only pick up an accent colour on hover, so they never\n   compete with the content next to them. */\n.btn-reload,\n.btn-create,\n.btn-filter,\n.btn-filter-mode,\n.btn-filter-clear,\n.btn-show-all,\n.btn-close,\n.btn-edit,\n.btn-goto,\n.btn-delete,\n.btn-download,\n.btn-copy {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.4rem;\n  height: 1.4rem;\n  padding: 0;\n  font-size: 0.8rem;\n  line-height: 1;\n  border-color: var(--hs-border);\n  color: var(--hs-text-muted);\n}\n\n/* flex-centered: the icon carries no trailing gap of its own */\n.btn-reload::before,\n.btn-create::before,\n.btn-filter::before,\n.btn-filter-mode::before,\n.btn-filter-clear::before,\n.btn-show-all::before,\n.btn-close::before,\n.btn-edit::before,\n.btn-goto::before,\n.btn-delete::before,\n.btn-download::before,\n.btn-copy::before {\n  margin-right: 0;\n}\n\n.btn-reload:hover:not(:disabled),\n.btn-create:hover:not(:disabled),\n.btn-filter:hover:not(:disabled),\n.btn-filter-mode:hover:not(:disabled),\n.btn-filter-clear:hover:not(:disabled),\n.btn-show-all:hover:not(:disabled),\n.btn-close:hover:not(:disabled),\n.btn-edit:hover:not(:disabled),\n.btn-goto:hover:not(:disabled),\n.btn-download:hover:not(:disabled),\n.btn-copy:hover:not(:disabled) {\n  background: #fff;\n  border-color: var(--hs-blue);\n  color: var(--hs-blue);\n}\n\n/* An action the reader is not allowed to take stays in place — what a\n   table can do is part of its picture — but pales, so the eye passes\n   over it; its tooltip says why (see `writeDenied` in CrudTable). The\n   muted grey alone would not show it, that is the resting colour of\n   every icon button here. */\n.btn-create:disabled,\n.btn-edit:disabled,\n.btn-delete:disabled {\n  opacity: 0.45;\n}\n\n/* deleting stays destructive — but only on hover, so the row icon is\n   as quiet as its neighbours until it is aimed at */\n.btn-delete:hover:not(:disabled) {\n  background: #fff;\n  border-color: var(--hs-danger);\n  color: var(--hs-danger);\n}\n\n/* An icon button that carries its label. The btn-* class beside it\n   says which icon; this one takes back the small square shape of the\n   table tools, because outside a data row there is room to name what\n   the button does — and a named button is what the detail views use.\n   Every button in the app carries an icon in front of its label; only\n   the tabs and the language switch do not, being no actions. */\n.btn-labelled {\n  float: none;\n  width: auto;\n  height: auto;\n  margin: 0;\n  padding: 0.4rem 1rem;\n  font-size: 0.9rem;\n  /* back to the browser default the plain buttons use — inheriting the\n     1.5 of the body would leave this one taller than the button it\n     stands next to */\n  line-height: normal;\n  border-color: var(--hs-blue);\n  color: var(--hs-blue);\n}\n\n/* The icon regains the gap the icon-only rules take from it. Each of\n   those sets `margin-right: 0` next to its own `--btn-icon` further\n   down, so a plain `.btn-labelled::before` would lose on source order\n   alone; qualifying it with the element keeps it winning wherever the\n   next icon rule is added. */\nbutton.btn-labelled::before {\n  margin-right: 0.45em;\n}\n\n.btn-labelled:hover:not(:disabled) {\n  background: var(--hs-blue);\n  color: #fff;\n}\n\n/* a named delete says so before it is aimed at: unlike the quiet row\n   icon it wears the warning colour at rest, as the contact and person\n   delete buttons do */\n.btn-delete.btn-labelled {\n  border-color: var(--hs-danger);\n  color: var(--hs-danger);\n}\n\n.btn-delete.btn-labelled:hover:not(:disabled) {\n  background: var(--hs-danger);\n  color: #fff;\n}\n\n/* bi-x-lg — dismisses without saving: cancel, close */\n.btn-cancel::before,\n.btn-close::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z'/%3E%3C/svg%3E\");\n}\n\n/* The upper cross keeps to the right edge of the heading line, the\n   corner a window is closed in: `margin-left: auto` pushes it there\n   past the flexible title. */\n.page-head .btn-close {\n  margin-left: auto;\n}\n\n/* The lower one is a named button and stands where a row of buttons\n   begins — at the left edge, as the actions under a form do. The\n   corner it leaves free is the one the back-to-top button floats in\n   once the page has been scrolled. */\n.page-close {\n  display: flex;\n  justify-content: flex-start;\n  margin: 1.5rem 0 0;\n}\n\n/* bi-arrow-counterclockwise — puts something back as it was */\n.btn-reset::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z'/%3E%3Cpath d='M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z'/%3E%3C/svg%3E\");\n}\n\n.btn-reload {\n  float: right;\n  margin-left: 0.35rem;\n}\n\n/* add-a-row button in the table header, next to reload */\n.btn-create {\n  float: right;\n  margin-left: 0.35rem;\n}\n\n/* bi-plus-lg */\n.btn-create::before {\n  margin-right: 0;\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2z'/%3E%3C/svg%3E\");\n}\n\n.btn-reload::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z'/%3E%3Cpath d='M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z'/%3E%3C/svg%3E\");\n  margin-right: 0;\n}\n\n/* bi-search — toggles the filter/search row in the table header */\n.btn-filter {\n  margin-left: 0.35rem;\n}\n\n.btn-filter::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'/%3E%3C/svg%3E\");\n  margin-right: 0;\n}\n\n.btn-filter.active {\n  border-color: var(--hs-blue);\n  color: var(--hs-blue);\n}\n\n/* bi-eye — widens the grants list to everything visible (REQ_006);\n   pressed it stands out like the open search, since both change\n   what the table shows rather than doing something once */\n.btn-show-all::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z'/%3E%3Cpath d='M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0'/%3E%3C/svg%3E\");\n  margin-right: 0;\n}\n\n.btn-show-all.active {\n  border-color: var(--hs-blue);\n  color: var(--hs-blue);\n}\n\n/* bi-eraser — clears all criteria in the open filter row */\n\n.btn-filter-clear::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414l-3.879-3.879zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z'/%3E%3C/svg%3E\");\n  margin-right: 0;\n}\n\n/* The face-switch of the search row (see CrudTable): each shows where\n   it leads, not where one stands. bi-magic — the wand of the Magic\n   Search — where the row filters per column; bi-layout-three-columns\n   for the way back. */\n.btn-filter-mode.magic::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M9.5 2.672a.5.5 0 1 0 1 0V.843a.5.5 0 0 0-1 0v1.829Zm4.5.035A.5.5 0 0 0 13.293 2L12 3.293a.5.5 0 1 0 .707.707L14 2.707ZM7.293 4A.5.5 0 1 0 8 3.293L6.707 2A.5.5 0 0 0 6 2.707L7.293 4Zm-.621 2.5a.5.5 0 1 0 0-1H4.843a.5.5 0 1 0 0 1h1.829Zm8.485 0a.5.5 0 1 0 0-1h-1.829a.5.5 0 0 0 0 1h1.829ZM13.293 10A.5.5 0 1 0 14 9.293L12.707 8a.5.5 0 1 0-.707.707L13.293 10ZM9.5 11.157a.5.5 0 0 0 1 0V9.328a.5.5 0 0 0-1 0v1.829Zm1.854-5.097a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L8.646 5.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0l1.293-1.293Zm-3 3a.5.5 0 0 0 0-.706l-.708-.708a.5.5 0 0 0-.707 0L.646 13.94a.5.5 0 0 0 0 .707l.708.708a.5.5 0 0 0 .707 0L8.354 9.06Z'/%3E%3C/svg%3E\");\n}\n\n.btn-filter-mode.columns::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13ZM1.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5H5V1H1.5ZM10 15V1H6v14h4Zm1 0h3.5a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5H11v14Z'/%3E%3C/svg%3E\");\n}\n\n/* bi-download — icon-only download in table rows (label via title) */\n.btn-download::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z'/%3E%3Cpath d='M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z'/%3E%3C/svg%3E\");\n  margin-right: 0;\n}\n\n/* icon-only delete in table rows (label via title/aria-label) */\n/* bi-box-arrow-up-right — jumps to the record's own detail page */\n.btn-goto::before {\n  margin-right: 0;\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z'/%3E%3Cpath fill-rule='evenodd' d='M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z'/%3E%3C/svg%3E\");\n}\n\n/* bi-info-circle — the resource values of a booking, told in the\n   tooltip: the navigation table of the projects page keeps no details\n   below it, a click navigates away. The box of the framed icon\n   buttons, only without their frame, so the action cell lines up. */\n.resources-hint {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.4rem;\n  height: 1.4rem;\n  color: var(--hs-text-muted);\n  cursor: help;\n  font-size: 0.8rem;\n}\n\n.resources-hint::before {\n  margin-right: 0;\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z'/%3E%3Cpath d='m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'/%3E%3C/svg%3E\");\n}\n\n/* Icons that belong to the value right in front of them — the uuid\n   copy button and the jump to a referenced record, in the details as\n   in a data cell. They are part of the text flow, so they get no\n   frame and sit small, close and slightly raised; only the buttons\n   that stand on their own (the table's action column, the page head)\n   keep their frame. */\n.master-data .btn-goto,\n.master-data .btn-copy,\ntd .btn-goto,\n.claims-table .btn-copy {\n  width: 1.1rem;\n  height: 1.1rem;\n  margin-left: 0.3rem;\n  padding: 0;\n  border: 0;\n  background: none;\n  font-size: 0.65rem;\n  vertical-align: 0.3em;\n}\n\n.master-data .btn-goto:hover:not(:disabled),\n.master-data .btn-copy:hover:not(:disabled),\ntd .btn-goto:hover:not(:disabled),\n.claims-table .btn-copy:hover:not(:disabled) {\n  background: none;\n  color: var(--hs-blue);\n}\n\n/* bi-pencil — edit action in a table row */\n.btn-edit::before {\n  margin-right: 0;\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z'/%3E%3C/svg%3E\");\n}\n\n.btn-delete::before {\n  margin-right: 0;\n}\n\n/* icon-only copy to clipboard (label via title/aria-label) */\n.btn-copy {\n  margin-left: 0.6rem;\n}\n\n/* bi-clipboard */\n.btn-copy::before {\n  margin-right: 0;\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z'/%3E%3Cpath d='M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z'/%3E%3C/svg%3E\");\n}\n\n/* the uuid copy sits flush in table action cells and detail lists\n   (the default left margin fits the inline usage on the user page);\n   in a table cell the optional delete follows with a small gap */\n.crud-table .btn-copy {\n  margin-left: 0;\n}\n\n/* the buttons carry margins for their use outside a table (the empty\n   state floats them, the copy button sits inline on the user page);\n   inside the shared flex row the gap alone sets the spacing */\n.crud-table .table-tools button,\n.detail-tools button {\n  margin: 0;\n  /* the strip is measured by its buttons (see CrudTable), so no button\n     may be squeezed below the size it asks for */\n  flex: none;\n}\n\n/* bi-check-lg after a successful copy */\n.btn-copy.copied::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022z'/%3E%3C/svg%3E\");\n}\n\n/* icon-only magnifier, opens a detail popup (label via title/aria-label) */\n.btn-magnify {\n  padding: 0.15rem 0.45rem;\n  line-height: 1;\n}\n\n/* bi-search */\n.btn-magnify::before {\n  margin-right: 0;\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'/%3E%3C/svg%3E\");\n}\n\n/* bi-trash — every ConfirmDialog in the app confirms a deletion, so\n   its confirming button carries the same mark as the one that opened\n   it (see the \"Deleting\" section of doc/architecture.md) */\n.btn-delete::before,\n.confirm-dialog-confirm button::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z'/%3E%3Cpath fill-rule='evenodd' d='M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z'/%3E%3C/svg%3E\");\n}\n\n/* bi-plus-circle */\n.contact-create > button::before,\n.person-create > button::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z'/%3E%3Cpath d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z'/%3E%3C/svg%3E\");\n}\n\n/* bi-check-lg */\n.contact-submit > button::before,\n.person-submit > button::before,\n.subscription-submit > button::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022z'/%3E%3C/svg%3E\");\n}\n\n/* in the rail the icon is the whole link: bigger than inline, and\n   without the gap that would otherwise hold a label. This has to come\n   after the shared icon rule above — same specificity, so source order\n   decides. */\n.app-sidebar .nav-rail a::before,\n.app-sidebar .nav-rail button::before {\n  display: block;\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-right: 0;\n}\n\n/* bi-person in front of the sidebar user entry — the same icon the\n   topbar user link shrinks to on phones (see the media query below) */\n.app-sidebar a.nav-user::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z'/%3E%3C/svg%3E\");\n}\n\n/* bi-gear in front of the sidebar configuration entry */\n.app-sidebar a.nav-config::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z'/%3E%3Cpath d='M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z'/%3E%3C/svg%3E\");\n}\n\n/* bi-speedometer2 — the overview / dashboard landing page */\n.app-sidebar a.nav-overview::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 4a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-1 0V4.5A.5.5 0 0 1 8 4M3.732 5.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707M2 10a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 10m9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5m.754-4.246a.39.39 0 0 0-.527-.02L7.547 9.31a.91.91 0 1 0 1.302 1.258l3.434-4.297a.39.39 0 0 0-.029-.518z'/%3E%3Cpath fill-rule='evenodd' d='M0 10a8 8 0 1 1 15.547 2.661c-.442 1.253-1.845 1.602-2.932 1.25C11.309 13.488 9.475 13 8 13c-1.474 0-3.31.488-4.615.911-1.087.352-2.49.003-2.932-1.25A8 8 0 0 1 0 10m8-7a7 7 0 0 0-6.603 9.329c.203.575.923.876 1.68.63C4.397 12.533 6.358 12 8 12s3.604.532 4.923.96c.757.245 1.477-.056 1.68-.631A7 7 0 0 0 8 3'/%3E%3C/svg%3E\");\n}\n\n/* bi-building — the partner data */\n.app-sidebar a.nav-partner::before,\n.bookmark-area.area-partner::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z'/%3E%3Cpath d='M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3z'/%3E%3C/svg%3E\");\n}\n\n/* bi-award — the membership */\n.app-sidebar a.nav-membership::before,\n.bookmark-area.area-membership::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M9.669.864 8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68zm1.196 1.193.684 1.365 1.086 1.072L12.387 6l.248 1.506-1.086 1.072-.684 1.365-1.51.229L8 10.874l-1.355-.702-1.51-.229-.684-1.365-1.086-1.072L3.614 6l-.25-1.506 1.087-1.072.684-1.365 1.51-.229L8 1.126l1.356.702z'/%3E%3Cpath d='M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1z'/%3E%3C/svg%3E\");\n}\n\n/* bi-receipt — the debitors */\n.app-sidebar a.nav-debitors::before,\n.bookmark-area.area-debitor::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27m.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0z'/%3E%3Cpath d='M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5'/%3E%3C/svg%3E\");\n}\n\n/* bi-person-lines-fill — the contacts */\n.app-sidebar a.nav-contacts::before,\n.bookmark-area.area-contact::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z'/%3E%3C/svg%3E\");\n}\n\n/* bi-people — the persons */\n.app-sidebar a.nav-persons::before,\n.bookmark-area.area-person::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4'/%3E%3C/svg%3E\");\n}\n\n/* bi-bank — the bank accounts */\n/* bi-journal-text */\n.app-sidebar a.nav-bankdirectory::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5'/%3E%3Cpath d='M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2'/%3E%3Cpath d='M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z'/%3E%3C/svg%3E\");\n}\n\n.app-sidebar a.nav-bankaccounts::before,\n.bookmark-area.area-bankAccount::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.5.5 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89zM3.777 3h8.447L8 1zM2 6v7h1V6zm3 0v7h1V6zm3 0v7h1V6zm3 0v7h1V6zm3 0v7h1V6zm-.5 8h-11l-.25 1h11.5z'/%3E%3C/svg%3E\");\n}\n\n/* bi-envelope — the mailing lists */\n.app-sidebar a.nav-mailinglists::before,\n.bookmark-area.area-subscription::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z'/%3E%3C/svg%3E\");\n}\n\n/* bi-key — the access-rights grants */\n.app-sidebar a.nav-grants::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8zm4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5z'/%3E%3Cpath d='M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'/%3E%3C/svg%3E\");\n}\n\n/* bi-diagram-3 — the hosting projects */\n.app-sidebar a.nav-projects::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zM0 11.5A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4.5.5A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z'/%3E%3C/svg%3E\");\n}\n\n/* bi-journal-check — the bookings */\n.app-sidebar a.nav-bookings::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0'/%3E%3Cpath d='M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2'/%3E%3Cpath d='M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z'/%3E%3C/svg%3E\");\n}\n\n/* bi-hdd-stack — the hosting assets */\n.app-sidebar a.nav-hosting-assets::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M14 10a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zM2 9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2z'/%3E%3Cpath d='M5 11.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M14 3a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM2 2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z'/%3E%3Cpath d='M5 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0'/%3E%3C/svg%3E\");\n}\n\n/* bi-box-arrow-right (logout), in the menu as in the collapsed rail */\n.app-sidebar nav p.nav-logout button::before,\n.app-sidebar .nav-rail button::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z'/%3E%3Cpath fill-rule='evenodd' d='M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z'/%3E%3C/svg%3E\");\n}\n\n/* bi-funnel — the partner choice in the collapsed rail: it is not an\n   area but the filter every area below it is seen through. More\n   specific than the logout rule above, which would otherwise paint\n   every button in the rail with its own glyph */\n.app-sidebar .nav-rail button.nav-partner-select::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z'/%3E%3C/svg%3E\");\n}\n\n/* bi-check-lg — the save button of a form it stands outside of, tied\n   to it by the `form` attribute. Those buttons sit in the action row\n   below the form rather than inside it, which is why the rule for a\n   form's own submit does not reach them: they were the ones left\n   without a symbol in front of their word. */\nbutton[type='submit'][form]::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022z'/%3E%3C/svg%3E\");\n}\n\n/* bi-box-arrow-in-right (sign-in) */\nform button[type='submit']::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z'/%3E%3Cpath fill-rule='evenodd' d='M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z'/%3E%3C/svg%3E\");\n}\n\n/* ---------- user page: JWT claims table ---------- */\n\n.claims-table {\n  max-width: 40rem;\n}\n\n.claims-table th[scope='row'] {\n  color: var(--hs-text-muted);\n  font-weight: 500;\n  font-size: 0.85rem;\n  width: 12rem;\n}\n\n/* form submit/cancel row */\n.form-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 1rem 0;\n}\n\n/* let wrapped buttons (e.g. .subscription-submit) align like direct children */\n.form-actions > div {\n  display: contents;\n}\n\n/* The view the mark hangs in: whatever holds the row of actions holds\n   the corner it is pinned to (see .bookmark-toggle). Written as a\n   question about the row rather than as a list of pages, because the\n   pages are a dozen and each of them wraps its actions differently. */\n:is(section, div):has(> .form-actions > .bookmark-toggle) {\n  position: relative;\n}\n\n/* Where the details are tabbed, the mark hangs at the right end of\n   the row of tabs. Inside the open tab it sat on whatever began in\n   that corner — the toolbar of a table, on half the tabs there is one\n   — and it claimed a tab it does not belong to: the record is the\n   same whichever tab is open. Room is kept for it at the end of the\n   row so it covers no label; as a symbol it needs little. */\n.tab-bar:has(> .bookmark-toggle) {\n  position: relative;\n  padding-right: 2.75rem;\n}\n\n/* bi-bookmark — the outline: a mark not set is a mark still empty */\n.bookmark-toggle::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z'/%3E%3C/svg%3E\");\n\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-right: 0;\n}\n\n/* bi-bookmark-fill — set, and filled with the house blue */\n.bookmark-toggle:has(input:checked)::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2'/%3E%3C/svg%3E\");\n}\n\n/*\n * The bookmark on the record on display. It is neither one of the\n * values above it nor one of the actions beside it — it changes\n * nothing about the record, only where the reader will find it again\n * — so it wears a shape of its own instead of looking like a form\n * field or a button.\n *\n * That shape is the thing itself: a bookmark, empty and grey while\n * the record is not marked, filled with the house blue once it is.\n * A symbol every reader knows needs no word beside it — the word is\n * in the tooltip, and in the name the checkbox is read out with.\n *\n * It hangs in the upper right corner of the view it belongs to, out\n * of the flow. It used to stand at the end of the row of actions, and\n * on a narrow screen it was the item too many there: a row that\n * cannot fit makes the whole page scroll sideways, and the only thing\n * that may scroll sideways here is a table. Out of the flow it cannot\n * widen anything, whatever the labels beside it are called.\n */\n.bookmark-toggle {\n  position: absolute;\n  top: 0;\n  right: 0;\n  /* over whatever begins in that corner — the tab bar of a detail\n     view, the first box of a form */\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  /* the symbol is small; the padding is what a thumb hits */\n  margin: 0;\n  padding: 0.5rem;\n  color: var(--hs-text-muted);\n  line-height: 1;\n  cursor: pointer;\n}\n\n/* the box itself is gone from view; it still takes the click through\n   its label, the keyboard through Tab and the space bar, and the\n   screen reader through its name */\n.bookmark-toggle input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  max-width: none;\n  margin: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.bookmark-toggle:hover {\n  color: var(--hs-blue);\n}\n\n/* what a hidden box owes the keyboard: a ring where the eye is */\n.bookmark-toggle:has(input:focus-visible) {\n  border-radius: var(--hs-radius-control);\n  outline: 2px solid var(--hs-blue);\n  outline-offset: 1px;\n}\n\n/* set: visible as such from across the page, not only in the box */\n.bookmark-toggle:has(input:checked) {\n  color: var(--hs-blue);\n}\n\n/* person/contact reference widget: the searchable select plus, when\n   \"create new\" is chosen, the inline fields of that record indented\n   below it. Label left of the field, like the forms. */\n/* same grid as .master-data, so the field lines up with the values\n   shown above it in the same detail block */\n.entity-picker-field {\n  display: grid;\n  /* fixed, not max-content: the contact label is long enough to widen\n     the column and would push the field out of line with the values\n     shown above it */\n  grid-template-columns: 10rem minmax(0, 1fr);\n  align-items: start;\n  gap: 0.35rem 1.5rem;\n  max-width: 34rem;\n  margin: 0.4rem 0;\n  padding-left: 0.75rem;\n  /* the \"please check\" notice hangs off the field's right edge */\n  position: relative;\n}\n\n/* a proposed value's word of caution, right beside the field —\n   bi-question-circle in the CI's warm accent, its words in the tooltip\n   (\"please check this proposal\"): a symbol beside every proposed field\n   says the same thing once, where the spelled-out words would say it\n   three times in a row. Absolute, so its leaving does not shift the\n   form under the mouse */\n/* bi-exclamation-triangle — a bank account the bank directory disagrees with */\n.bank-account-issue {\n  --issue-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z'/%3E%3Cpath d='M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z'/%3E%3C/svg%3E\");\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  margin-left: 0.4em;\n  vertical-align: -0.125em;\n  background-color: var(--hs-orange);\n  -webkit-mask: var(--issue-icon) no-repeat center / contain;\n  mask: var(--issue-icon) no-repeat center / contain;\n}\n\n.picker-notice {\n  --notice-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16'/%3E%3Cpath d='M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94'/%3E%3C/svg%3E\");\n  position: absolute;\n  left: 100%;\n  top: 0.5rem;\n  display: inline-block;\n  width: 1.05rem;\n  height: 1.05rem;\n  margin-left: 0.75rem;\n  background-color: var(--hs-orange);\n  -webkit-mask: var(--notice-icon) no-repeat center / contain;\n  mask: var(--notice-icon) no-repeat center / contain;\n}\n\n/* a plain form field carrying the same notice: a wrapper around the\n   label anchors the note beside the field the way the picker fields\n   do — outside the label, whose text is the field's name and nothing\n   more. The width is the fields' own, so `left: 100%` is the same\n   edge the picker notices hang off. */\n.field-with-notice {\n  position: relative;\n  max-width: 34rem;\n}\n\n.field-with-notice > .picker-notice {\n  /* on the first line of the label in the wrapper, margin included */\n  top: 0.55rem;\n}\n\n/* pulled left by its own border and padding, like every bordered field\n   in the forms: the chosen name starts on the column line where the\n   plain values stand, not a border's width further in */\n.entity-picker-field > .search-select {\n  margin-left: calc(-0.6rem - 1px);\n}\n\n/* the plain fields sharing this layout — the relation form's type\n   select, the mailing list's list select — are pulled left the same\n   way, so their boxes stand in one line with the pickers below them;\n   the width grows by what the margin takes, keeping the right edge */\n.entity-picker-field > select,\n.entity-picker-field > input {\n  width: calc(100% + 0.6rem + 1px);\n  margin-left: calc(-0.6rem - 1px);\n}\n\n/* reads like the labels of the detail list it sits in */\n.entity-picker-label {\n  font-size: 0.85rem;\n  color: var(--hs-text-muted);\n  padding-top: 0.45rem;\n}\n\n.entity-picker > fieldset {\n  margin-left: 12.25rem;\n  max-width: 23.5rem;\n}\n\n/* ---------- searchable select ---------- */\n\n/* Same idea as the partner selector in the sidebar, but as a form\n   field: a native <select> can neither show the second line each\n   contact needs (its e-mail addresses) nor filter by substring. */\n/* the field and its tool side by side: the dropdown takes the width,\n   the pencil beside it only what it needs. The popup hangs out of the\n   flow (position: absolute below) and is therefore as wide as both. */\n.search-select {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: start;\n  gap: 0.35rem;\n}\n\n/* level with the first line of the choice, not with the middle of a\n   two-line entry */\n.search-select-edit {\n  margin-top: 0.15rem;\n}\n\n/* positioned for the sake of its arrow below: that one belongs to the\n   right edge of the field, not to the right edge of the control — and\n   the control reaches past the field wherever a pencil stands beside\n   it */\n.search-select-toggle {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0.4rem 1.8rem 0.4rem 0.6rem;\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-control);\n  background: #fff;\n  color: var(--hs-text);\n  font: inherit;\n  font-size: 0.95rem;\n  line-height: 1.3;\n  text-align: left;\n}\n\n/* the generic button hover fills with blue — not for a form field */\n.search-select-toggle:hover:not(:disabled) {\n  background: #fff;\n  color: var(--hs-text);\n  border-color: var(--hs-blue);\n}\n\n/* a choice that is none: the field keeps its shape, so the column\n   stays even, but it is subdued and carries no arrow — there is\n   nothing to unfold (the anchor in the partner form) */\n.search-select-toggle:disabled {\n  background: var(--hs-bg-subtle);\n  color: var(--hs-text-muted);\n  cursor: default;\n}\n\n.search-select-toggle::after {\n  content: '▾';\n  position: absolute;\n  right: 0.6rem;\n  top: 0.4rem;\n  color: var(--hs-blue);\n}\n\n.search-select-toggle:disabled::after {\n  content: none;\n}\n\n.search-select-placeholder {\n  color: var(--hs-text-muted);\n}\n\n/* caption/name on top, the e-mail addresses (or person type) below */\n.search-select-label {\n  display: block;\n}\n\n.search-select-hint {\n  display: block;\n  font-size: 0.8rem;\n  color: var(--hs-text-muted);\n  overflow-wrap: anywhere;\n}\n\n/* the hint line standing in for itself: what the Magic Search found\n   this entry by, where neither of its two lines shows it. Italic like\n   every other remark the lists make about themselves */\n.search-select-hint.is-match {\n  font-style: italic;\n}\n\n/* as wide as the field, not as the control: an out-of-flow child that\n   names a grid column hangs below that column, so the list keeps its\n   left and right edge even where a pencil stands beside the field */\n.search-select-popup {\n  position: absolute;\n  grid-column: 1 / 2;\n  z-index: 10;\n  left: 0;\n  right: 0;\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-control);\n  background: #fff;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.search-select-filter {\n  display: block;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding: 0.4rem 0.6rem;\n  border: 0;\n  border-bottom: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-control) var(--hs-radius-control) 0 0;\n  font: inherit;\n  font-size: 0.9rem;\n}\n\n.search-select-options {\n  margin: 0;\n  padding: 0.25rem 0;\n  list-style: none;\n  max-height: 40vh;\n  overflow-y: auto;\n}\n\n.search-select-option {\n  padding: 0.35rem 0.6rem;\n  cursor: pointer;\n}\n\n.search-select-option.is-active {\n  background: var(--hs-blue-pale);\n}\n\n.search-select-option[aria-selected='true'] .search-select-label {\n  font-weight: 600;\n  color: var(--hs-blue);\n}\n\n.search-select-empty {\n  padding: 0.35rem 0.6rem;\n  font-style: italic;\n  color: var(--hs-text-muted);\n}\n\n/* writing a new record is an action, not one of the choices — the rule\n   towards the list says which side of the line it stands on. It frames\n   the matches, so the top one is ruled off below and the bottom one\n   above; alone (nothing matched) it keeps the rule to the message */\n.search-select-create {\n  color: var(--hs-blue);\n}\n\n.search-select-create:first-child {\n  border-bottom: 1px solid var(--hs-border);\n}\n\n.search-select-create:last-child:not(:first-child) {\n  border-top: 1px solid var(--hs-border);\n}\n\n@media (max-width: 768px) {\n  .entity-picker-field {\n    grid-template-columns: 1fr;\n    gap: 0.15rem;\n  }\n\n  .entity-picker-label {\n    padding-top: 0;\n  }\n\n  .entity-picker > fieldset {\n    margin-left: 0;\n    max-width: none;\n  }\n\n  /* no room beside the field — the notice falls in below it */\n  .picker-notice {\n    position: static;\n    margin-left: 0;\n  }\n}\n\n/* ---------- date field with its calendar ---------- */\n\n/* bi-calendar3 — the knob that opens the calendar */\n.btn-calendar::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z'/%3E%3Cpath d='M6.5 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-9 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-9 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0'/%3E%3C/svg%3E\");\n}\n\n/* bi-chevron-left / bi-chevron-right — one month back and on */\n.btn-month-back::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3E%3C/svg%3E\");\n}\n\n.btn-month-on::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3E%3C/svg%3E\");\n}\n\n/*\n * A day is typed into the field and picked from the calendar behind\n * it. The knob sits inside the field, where the native date input puts\n * its own — a button beside it would make the field look like two\n * things, and the column it stands in is 10rem wide at most.\n */\n.date-field {\n  position: relative;\n  display: block;\n}\n\n/* room for the knob, so a typed day never runs under it */\n.date-field > input {\n  padding-right: 2rem;\n}\n\n.btn-calendar {\n  position: absolute;\n  top: 50%;\n  right: 0.15rem;\n  transform: translateY(-50%);\n  padding: 0.25rem;\n  border: 0;\n  background: none;\n  color: var(--hs-text-muted);\n  line-height: 1;\n  cursor: pointer;\n}\n\n.btn-calendar:hover,\n.btn-calendar[aria-expanded='true'] {\n  color: var(--hs-blue);\n  background: none;\n}\n\n.btn-calendar::before {\n  width: 1.1rem;\n  height: 1.1rem;\n  margin-right: 0;\n}\n\n/* The calendar hangs under the field, over whatever the form has\n   below it. It is as wide as seven days need and no wider: on a\n   smartphone the field spans the screen, and a calendar stretched to\n   it would be a grid of empty cells. */\n.day-picker {\n  position: absolute;\n  z-index: 10;\n  top: calc(100% + 0.25rem);\n  left: 0;\n  width: 17rem;\n  max-width: 100%;\n  padding: 0.5rem;\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-control);\n  background: #fff;\n  box-shadow: 0 4px 12px rgb(0 0 0 / 15%);\n}\n\n/* month, year and the two steps in one line: the year is a field\n   because a birthday is fifty years of clicking away otherwise */\n.day-picker-head {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin-bottom: 0.4rem;\n}\n\n.day-picker-head select {\n  flex: 1;\n  min-width: 0;\n  color: var(--hs-text);\n  font-size: 0.9rem;\n}\n\n/* four digits and a little air, and the month keeps the rest of the\n   line */\n.day-picker-year {\n  flex: none;\n  width: 4.5rem;\n  color: var(--hs-text);\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.day-picker-head button {\n  flex: none;\n  padding: 0.25rem 0.4rem;\n  border: 0;\n  background: none;\n  color: var(--hs-text-muted);\n  line-height: 1;\n  cursor: pointer;\n}\n\n.day-picker-head button:hover {\n  color: var(--hs-blue);\n  background: none;\n}\n\n.day-picker-head button::before {\n  width: 0.9rem;\n  height: 0.9rem;\n  margin-right: 0;\n}\n\n.day-picker-grid {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.day-picker-grid th {\n  padding: 0.15rem 0;\n  border: 0;\n  background: none;\n  color: var(--hs-text-muted);\n  font-size: 0.75rem;\n  font-weight: 400;\n  text-align: center;\n}\n\n.day-picker-grid td {\n  padding: 0;\n  border: 0;\n  text-align: center;\n}\n\n.day-picker-grid button {\n  width: 100%;\n  padding: 0.3rem 0;\n  border: 0;\n  border-radius: var(--hs-radius-control);\n  background: none;\n  color: var(--hs-text);\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.day-picker-grid button:hover {\n  background: var(--hs-blue-pale);\n  color: var(--hs-blue-dark);\n}\n\n/* today is a hint, the picked day is the answer — hence the ring for\n   the one and the filled field for the other */\n.day-picker-grid button.is-today {\n  box-shadow: inset 0 0 0 1px var(--hs-border);\n  font-weight: 600;\n}\n\n.day-picker-grid button.is-selected {\n  background: var(--hs-blue);\n  color: #fff;\n}\n\n/* fallback while a lazily loaded page chunk is being fetched */\n.page-loading {\n  padding: 1rem;\n  color: var(--hs-text-muted);\n}\n\n/* section heading with the token action buttons to its right */\n.page-head {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.page-head h1,\n.page-head h2 {\n  margin: 0;\n}\n\n.token-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n/* ---------- friendly API error box ---------- */\n\n.error-notice {\n  max-width: 40rem;\n  margin: 1rem 0;\n  padding: 0.75rem 1rem;\n  border: 1px solid color-mix(in srgb, var(--hs-danger) 30%, #fff);\n  border-left: 4px solid var(--hs-danger);\n  border-radius: var(--hs-radius-surface);\n  background: color-mix(in srgb, var(--hs-danger) 5%, #fff);\n}\n\n.error-notice-message {\n  margin: 0;\n  font-weight: 500;\n  color: var(--hs-text);\n}\n\n.error-notice-retry {\n  margin-top: 0.6rem;\n}\n\n/* inline error above the form actions: a compact danger box matching\n   the page-level .error-notice, never a raw technical string */\n.form-error {\n  max-width: 32rem;\n  margin: 0.75rem 0;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid color-mix(in srgb, var(--hs-danger) 30%, #fff);\n  border-left: 4px solid var(--hs-danger);\n  border-radius: var(--hs-radius-surface);\n  background: color-mix(in srgb, var(--hs-danger) 5%, #fff);\n  color: var(--hs-text);\n  font-weight: 500;\n}\n\n/* ---------- configuration page ---------- */\n\n.config-page section {\n  max-width: 40rem;\n  margin-bottom: 1.5rem;\n}\n\n.config-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n}\n\n/* undo the block/full-width styling generic form inputs get */\n.config-option input[type='checkbox'] {\n  display: inline-block;\n  width: auto;\n  max-width: none;\n  margin: 0;\n}\n\n/* a setting that is a choice rather than a switch: the label reads\n   like the ones beside it, the dropdown takes only the width its\n   longest option needs */\n.config-choice {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n}\n\n.config-choice select {\n  width: auto;\n  max-width: 22rem;\n  margin: 0;\n}\n\n.config-hint {\n  margin: 0.35rem 0 0.75rem;\n  font-size: 0.85rem;\n  color: var(--hs-text-muted);\n}\n\n.config-done {\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: var(--hs-blue-dark);\n}\n\n/* plain-text JWT popup */\n.token-dialog {\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-surface);\n  padding: 1rem 1.5rem;\n  max-width: min(40rem, 90vw);\n}\n\n.token-dialog::backdrop {\n  background: rgb(0 0 0 / 30%);\n}\n\n/* confirmation before an irreversible action; the confirming button\n   carries the destructive styling, cancel stays the quiet default */\n.confirm-dialog {\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-surface);\n  padding: 1rem 1.5rem;\n  max-width: min(30rem, 90vw);\n}\n\n.confirm-dialog::backdrop {\n  background: rgb(0 0 0 / 30%);\n}\n\n.confirm-dialog h2 {\n  margin-top: 0;\n}\n\n.confirm-dialog-confirm button:not(:disabled) {\n  border-color: var(--hs-danger);\n  background: #fff;\n  color: var(--hs-danger);\n}\n\n.confirm-dialog-confirm button:hover:not(:disabled) {\n  background: var(--hs-danger);\n  color: #fff;\n}\n\n/* popup for a failed API call (ErrorDialog): the friendly translated\n   headline up front, the technical cause behind a collapsible element */\n.error-dialog {\n  border: 1px solid var(--hs-border);\n  border-left: 4px solid var(--hs-danger);\n  border-radius: var(--hs-radius-surface);\n  padding: 1rem 1.5rem;\n  max-width: min(30rem, 90vw);\n}\n\n.error-dialog::backdrop {\n  background: rgb(0 0 0 / 30%);\n}\n\n.error-dialog h2 {\n  margin-top: 0;\n  color: var(--hs-danger);\n}\n\n.error-dialog-message {\n  margin: 0;\n  font-weight: 500;\n  color: var(--hs-text);\n}\n\n.error-dialog-details {\n  margin-top: 0.6rem;\n  font-size: 0.85rem;\n  color: var(--hs-text-muted);\n}\n\n.error-dialog-details summary {\n  cursor: pointer;\n}\n\n.error-dialog-details p {\n  margin: 0.3rem 0 0;\n  font-family: monospace;\n  overflow-wrap: anywhere;\n}\n\n/* the dialog a picker writes a new person or contact in: wider than a\n   confirmation, because it carries a whole form, and scrollable — a\n   contact with its addresses and phone numbers grows past a short\n   screen, and a dialog that cannot be scrolled hides its own save\n   button */\n.picker-dialog {\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-surface);\n  padding: 1rem 1.5rem;\n  width: min(42rem, 92vw);\n  max-height: 85vh;\n  overflow-y: auto;\n}\n\n.picker-dialog::backdrop {\n  background: rgb(0 0 0 / 30%);\n}\n\n.picker-dialog h2 {\n  margin-top: 0;\n}\n\n/* the news of a freshly loaded build: the width of a confirmation, but\n   it carries the dashboard card's list — so the same rules that hold\n   that card together apply inside it (see .overview-list) */\n.whats-new-dialog {\n  /* the strip of backdrop that stays visible above the dialog: enough\n     to see that the page is still there behind it, and never more of\n     the screen than a phone can spare */\n  --whats-new-gap: min(6dvh, 3rem);\n\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-surface);\n  padding: 1rem 1.5rem;\n  width: min(34rem, 92vw);\n  /* Hangs from the top edge rather than being centred between the\n     edges: a phone centres it in a viewport that is taller than what\n     it shows — the browser's own bars are counted in — and the\n     heading ended up above the visible area. Hanging from the top,\n     the dialog begins where the reading begins.\n     The height is measured in dvh for the same reason: vh counts the\n     bars in, dvh does not. The 85vh is for whoever has no dvh. */\n  margin-block: var(--whats-new-gap) auto;\n  max-height: 85vh;\n  max-height: calc(100dvh - 2 * var(--whats-new-gap));\n  overflow-y: auto;\n}\n\n.whats-new-dialog::backdrop {\n  background: rgb(0 0 0 / 30%);\n}\n\n.whats-new-dialog h2 {\n  margin-top: 0;\n}\n\n/* the heading takes the focus when the dialog opens, so that neither\n   the link at its foot takes it nor the phone scrolls down to that\n   link (see WhatsNewDialog.tsx). A heading is nothing to operate,\n   though, and a ring around it would only ask what it is for. */\n.whats-new-dialog h2:focus {\n  outline: none;\n}\n\n.whats-new-dialog-lead {\n  color: var(--hs-text-muted);\n}\n\n.token-dialog pre {\n  background: var(--hs-bg-subtle);\n  padding: 0.75rem 1rem;\n  border-radius: var(--hs-radius-surface);\n  overflow-x: auto;\n  font-size: 0.8rem;\n}\n\n/* ---------- master data definition list ---------- */\n\n/* a fixed label column, not max-content: a detail view often stacks\n   several of these lists (e.g. the subscription above its contact\n   data), and per-list sizing would indent their values differently.\n   Grows only if a label ever exceeds it, so nothing wraps. */\n.master-data {\n  display: grid;\n  grid-template-columns: minmax(10rem, max-content) minmax(0, 1fr);\n  gap: 0.35rem 1.5rem;\n  margin: 0.5rem 0;\n  /* the same indent the table cells above have, so the labels line up\n     with the content of the first data column */\n  padding-left: 0.75rem;\n}\n\n/* the uuid itself, in front of its copy button — whoever does not\n   want to see it turns the whole uuid display off in the settings */\n.detail-uuid {\n  font-family: monospace;\n  font-size: 0.85rem;\n  overflow-wrap: anywhere;\n}\n\n.master-data dt {\n  color: var(--hs-text-muted);\n  font-size: 0.85rem;\n  /* labels align with the top of their value, never centered */\n  align-self: start;\n}\n\n.master-data dd {\n  margin: 0;\n}\n\n/* ---------- access-rights grants page ---------- */\n\n/* the plain-language reading of the selected grant heads its details */\n.rights-sentence {\n  margin: 0.75rem 0 0.25rem;\n  padding-left: 0.75rem;\n  font-weight: 600;\n}\n\n/* the grant form joins the label-left convention of the other forms\n   (see the #…-form rules further down); the radio and checkbox labels\n   stay out — a choice reads left-to-right, not label/value columns */\n#grant-form fieldset > label:not(.rights-assumed) {\n  display: grid;\n  grid-template-columns: 10rem minmax(0, 1fr);\n  align-items: baseline;\n  gap: 0.35rem 1.5rem;\n  max-width: 34rem;\n  margin: 0.4rem 0;\n  padding-left: 0.75rem;\n  color: var(--hs-text-muted);\n  font-size: 0.85rem;\n  font-weight: 400;\n}\n\n#grant-form fieldset > label:not(.rights-assumed) input,\n#grant-form fieldset > label:not(.rights-assumed) select {\n  width: calc(100% + 0.6rem + 1px);\n  margin-left: calc(-0.6rem - 1px);\n  color: var(--hs-text);\n  font-size: 0.95rem;\n}\n\n/* the who-search results: plain rows, chosen with one click */\n.rights-subject-results {\n  list-style: none;\n  margin: 0.25rem 0 0;\n  padding-left: 0.75rem;\n  max-width: 34rem;\n}\n\n.rights-subject-results button {\n  width: 100%;\n  text-align: left;\n}\n\n#grant-form .rights-assumed {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  width: auto;\n}\n\n#grant-form .rights-assumed input {\n  width: auto;\n  margin: 0;\n}\n\n/* A dashboard card is a column of an 18rem masonry, not a page: the\n   10rem label column of a detail view eats most of it and leaves the\n   values a few characters wide. Here the labels take only what they\n   need, the gap shrinks with them, and the indent that lines a detail\n   list up with the table above it has nothing to line up with. */\n.overview-card .master-data {\n  grid-template-columns: minmax(0, max-content) minmax(0, 1fr);\n  gap: 0.35rem 0.75rem;\n  padding-left: 0;\n}\n\n/* hint values (details not visible / no data) step back visually */\n.master-data dd.muted,\np.muted {\n  color: var(--hs-text-muted);\n  font-style: italic;\n}\n\n/*\n * While the table's filters hide the selected row, its details below\n * stand as an outline: tabs, labels and headings keep their place,\n * only the values withdraw — a layout that holds still reads calmer\n * than a block that comes and goes. `visibility` keeps the room the\n * values took; the `inert` attribute on the same wrapper (set by the\n * pages, see CrudTable's onSelectionHiddenChange) keeps the outline\n * from being clicked or tabbed into. Checkboxes and buttons have no\n * blank state, so they grey out instead.\n */\n.details-withheld dd,\n.details-withheld td,\n.details-withheld p.muted,\n.details-withheld .table-pager {\n  visibility: hidden;\n}\n\n.details-withheld .form-actions,\n.details-withheld .table-tools,\n.details-withheld input[type='checkbox'] {\n  opacity: 0.4;\n}\n\n/* Where a detail block continues with data that belongs to another\n   record — the contact of a partner or of a mailing list — a rule\n   says so. Faint on purpose: it separates two parts of one block, so\n   it must not read as the end of the block. */\n.detail-divider {\n  border: none;\n  border-top: 1px solid var(--hs-border);\n  margin: 1.25rem 0 1rem;\n}\n\n/* ---------- tabs ---------- */\n\n.tab-bar {\n  border-bottom: 2px solid var(--hs-border);\n  margin-bottom: 1rem;\n}\n\n.tab-bar button {\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  border-radius: 0;\n  margin-bottom: -2px;\n  padding: 0.5rem 1rem;\n  color: var(--hs-text-muted);\n  font-weight: 500;\n}\n\n.tab-bar button:hover:not(:disabled) {\n  background: transparent;\n  color: var(--hs-blue);\n}\n\n.tab-bar button.active {\n  color: var(--hs-blue);\n  border-bottom-color: var(--hs-orange);\n  font-weight: 600;\n}\n\n/* ---------- tables ---------- */\n\n/* A table takes the width it is given. It used to stop at 60rem, and\n   on a wide screen that left a hand's breadth of white beside every\n   one of them while the columns beside it wrapped their contents —\n   the one thing on a page that can put the width to use, not using\n   it. What keeps it off the edge is the padding of the box it stands\n   in, the same the values above it keep. */\ntable {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 0.5rem 0 1rem;\n  font-size: 0.95rem;\n}\n\n/* 0.4rem, not the half line one would write down first: a good pixel\n   and a half off each side of every row, which is three off its height\n   and, over the seven rows a phone shows, most of an eighth row. Below\n   this the row stops being a comfortable target for a thumb. */\nth,\ntd {\n  text-align: left;\n  padding: 0.4rem 0.4rem;\n  border-bottom: 1px solid var(--hs-border);\n}\n\nthead th {\n  background: var(--hs-blue-pale);\n  color: var(--hs-blue-dark);\n  border-bottom: 2px solid var(--hs-blue);\n}\n\ntbody tr:hover {\n  background: var(--hs-bg-subtle);\n}\n\n/* CrudTable wrapper: at most ~5 rows visible, then a scrollbar;\n   the header stays sticky while the body scrolls */\n.crud-table {\n  max-height: 15.6rem;\n  overflow-y: auto;\n  /* wide tables scroll inside their box instead of widening the page\n     (matters on small screens) */\n  overflow-x: auto;\n  /* The gutter stands reserved whether the scrollbar is there or not.\n     A classic (non-overlay) scrollbar takes its width from the box the\n     columns are shared out over, and on a table sized right at the\n     edge that is an oscillator: bar appears, box narrows, columns are\n     reshared, the table fits, bar disappears, box widens, … — seen as\n     flickering scrollbars in browsers with classic bars. Overlay\n     scrollbars ignore this property, so nothing is lost there. */\n  scrollbar-gutter: stable;\n  margin: 0.5rem 0 1rem;\n}\n\n/* tables with a totals row (see tfoot below) get its height on top,\n   so as many data rows stay visible as in tables without one */\n.crud-table.has-footer {\n  max-height: 18.1rem;\n}\n\n/* A main table is not scrolled but paged: its page is as many rows as\n   the box holds, and the pager below carries the reader on. What hangs\n   over the lower edge is the row peeking in from the next page (see\n   `peeking` in CrudTable) — it is meant to be cut off, not to be\n   fetched with a scrollbar. Sideways it still scrolls: a wide table\n   would otherwise widen the whole page. */\n.crud-table.is-paged {\n  overflow-y: hidden;\n}\n\n/* A box that ends in the middle of a row — which it usually does: a\n   dragged splitter and the height left over for a full-height table\n   land on a row boundary only by accident. Cut hard, that half row\n   reads like the end of the list; faded, it says the same thing the\n   scrollbar says, in the place the eye is already looking.\n\n   The mask sits on the scrolling box, so it stays at its lower edge\n   while the rows move underneath. It is set only while something is\n   still below (`is-clipped`, see CrudTable): scrolled to the end, the\n   last row is whole and has to stay readable. */\n.crud-table.is-clipped {\n  --fade: linear-gradient(to bottom, #000 calc(100% - 1.75rem), transparent);\n\n  mask-image: var(--fade);\n  -webkit-mask-image: var(--fade);\n}\n\n/* Every row is one line tall, whatever stands in it.\n\n   A cell used to wrap into a second line and cut the rest off with an\n   ellipsis, so that one long address could not widen its column. That\n   kept the table narrow but made the rows of unequal height — and a\n   table whose rows are of unequal height cannot be dragged open\n   smoothly: every row uncovered changed the column widths, and every\n   changed width changed the heights (see CrudTable).\n\n   Now the widths are stated ahead of the layout, over the whole list\n   (see `askedWidths` in CrudTable), and nothing in a cell can push\n   them. What does not fit runs out at the right edge, where it fades\n   into nothing rather than being cut through the middle of a letter;\n   the whole value stands in the tooltip of the cell and in the\n   details below. */\n.crud-table tbody td:not(:last-child) {\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.crud-table tbody td.is-cut {\n  overflow: visible;\n  /* the text runs out under the next column and fades there, not at\n     the cell edge — what does not fit vanishes before it reaches the\n     edge, so the spacing saved by the narrower padding is real */\n  --cut: linear-gradient(to right, #000 calc(100% - 1rem), transparent);\n\n  mask-image: var(--cut);\n  -webkit-mask-image: var(--cut);\n}\n\n/* a message spanning the whole table is no data cell: it may use every\n   line it needs (and being the only cell of its row, it is a last\n   child and keeps its wrapping anyway) */\n.crud-table tbody td.filter-no-match {\n  white-space: normal;\n}\n\n/* the widths come from the colgroup alone (see CrudTable): a column\n   that measured itself against the rows on show would move whenever\n   the page turned or the splitter opened another row */\n.crud-table table {\n  margin: 0;\n  max-width: none;\n  table-layout: fixed;\n}\n\n/* empty pseudo rows below the data (see CrudTable): row look without\n   content or interaction */\n.crud-table tbody tr.filler-row {\n  pointer-events: none;\n}\n\n.crud-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  /* border-collapse does not keep borders sticky — draw it inset */\n  border-bottom: none;\n  box-shadow: inset 0 -2px 0 var(--hs-blue);\n  /* single-line headers: the filter row sticks at a fixed offset\n     below, a wrapped header line would break that geometry */\n  white-space: nowrap;\n}\n\n/* The heading gives way before the sort symbol does: where a column is\n   narrower than its own name, the name is cut off and the symbol keeps\n   its place — a column one cannot sort by is worse than a heading one\n   has to guess at. (The button column takes its width from\n   `--tools-col`, measured in CrudTable.) */\n.crud-table thead th .th-head {\n  display: flex;\n  align-items: baseline;\n  min-width: 0;\n}\n\n.crud-table thead th .th-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* The grip on the border between two column heads: drag it and the\n   width moves from the one column into the other, double-click sets\n   the pair back to what the table reckoned (see CrudTable).\n\n   Shown only while the pointer is over the header row — a line at\n   every border, standing there all the time, would be a fence across\n   the table for a thing one needs twice a year. It reaches beyond its\n   own line so it can be hit without aiming, and lies over the border\n   itself, half in each column. Where there is no pointer to show it\n   to, it stands there always (see the hover query below). */\n.crud-table thead th .col-grip {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: -4px;\n  width: 9px;\n  cursor: col-resize;\n  touch-action: none;\n  z-index: 2;\n}\n\n.crud-table thead th .col-grip::before {\n  content: '';\n  position: absolute;\n  top: 15%;\n  bottom: 15%;\n  left: 50%;\n  width: 2px;\n  transform: translateX(-50%);\n  background: var(--hs-blue);\n  opacity: 0;\n  transition: opacity 0.12s ease-in-out;\n}\n\n.crud-table thead tr:hover .col-grip::before {\n  opacity: 0.35;\n}\n\n.crud-table thead th .col-grip:hover::before,\n.crud-table thead th .col-grip:active::before,\n.crud-table thead th .col-grip:focus-visible::before {\n  opacity: 1;\n}\n\n.crud-table thead th .col-grip:focus-visible {\n  outline: none;\n}\n\n/*\n * Where a finger does the dragging, nothing can be shown on hover: a\n * finger is either down or away. So on a screen that can be touched\n * the lines stand there for good — the fence we spared the mouse,\n * because the alternative is a grip nobody can find — and the band to\n * grasp them by is as wide as a fingertip needs rather than as wide as\n * a pointer needs.\n *\n * Which matters most where one would least expect it: a phone asked\n * for the desktop view has the room of a laptop, hands the page a\n * thousand css pixels and shrinks them to the width of a hand. Nine of\n * those pixels are about a millimetre.\n *\n * That the screen can be touched is decided in CrudTable and said in\n * this class, not asked here as `hover` or `pointer` — those are the\n * very answers a browser passing for a desktop rewrites, and this is\n * the screen that needs it most (see TOUCHABLE).\n */\n.crud-table.is-touched thead th .col-grip {\n  right: -14px;\n  width: 28px;\n}\n\n.crud-table.is-touched thead th .col-grip::before {\n  opacity: 0.3;\n}\n\n/* every icon button of a table lives in the trailing column: the tools\n   in the header, the row actions below. One shared right-aligned flex\n   row with one gap keeps them lined up in a single column — and the\n   flex context neutralises the floats those buttons carry elsewhere.\n   Staying on one line also matters in the header: a wrapped second\n   line would break the fixed sticky offset of the filter row below\n   (see .filter-row). */\n.crud-table .table-tools,\n.detail-tools {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.35rem;\n  white-space: nowrap;\n}\n\n/* the detail block repeats the row's actions, floating in its top\n   right corner above whatever the details render. Right-aligned to\n   the same edge as the table above, so the icons line up with the\n   ones in the data rows. */\n.detail-section {\n  position: relative;\n}\n\n.detail-tools {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  /* the table cells carry this padding, so the icons of the details\n     line up with those of the rows above */\n  right: 0.75rem;\n}\n\n/* the value the detail block is about, set apart from the rest */\n.master-data dd.detail-headline {\n  font-weight: 600;\n  color: var(--hs-blue);\n}\n\n/* sort toggle behind the column name; fixed width so the column\n   widths stay stable when the sort column or direction changes */\n.crud-table th .th-sort {\n  padding: 0;\n  border: none;\n  background: none;\n  font: inherit;\n  font-size: 0.85em;\n  color: var(--hs-text-muted);\n  cursor: pointer;\n  display: inline-block;\n  width: 1.3em;\n  margin-left: 0.35em;\n  text-align: center;\n  /* never squeezed by a narrow column — see .th-head */\n  flex: none;\n}\n\n.crud-table th .th-sort:hover:not(:disabled) {\n  background: none;\n  color: var(--hs-blue);\n}\n\n.crud-table th .th-sort.active {\n  color: var(--hs-blue);\n}\n\n/* collapsible search row (Magic Search or per-column filters); sticks\n   right below the sticky header row (top = header cell height:\n   0.95rem text × 1.5 line height + 2 × 0.4rem padding). The offset\n   must match that height to the pixel — set too deep, a stripe of\n   whatever scrolls by shows between the header and the search row. */\n.crud-table .filter-row td {\n  position: sticky;\n  top: 2.225rem;\n  z-index: 1;\n  background: var(--hs-blue-pale);\n  padding: 0.2rem 0.75rem 0.45rem;\n}\n\n/* The Magic Search input is one cell across the data columns and\n   fills it — past the readable-width cap the forms put on inputs. It\n   ends where the button column begins: that strip belongs to the\n   buttons, and nothing else may lie under them. */\n.crud-table .filter-row td.magic-search input {\n  max-width: none;\n}\n\n/* A column of enum values offers them as a dropdown instead of a text\n   box; both sit in the same row, so both wear the same measurements.\n\n   What has to line up with the column below is the text inside the\n   box, not the box around it: left alone, the border and the box's own\n   padding pushed every filter about half a character to the right of\n   the values it filters, and the whole search row read as shifted. The\n   box therefore starts that much further left, reaching into the\n   cell's padding, which has room to spare. */\n.crud-table .filter-row input,\n.crud-table .filter-row select {\n  --filter-inset: calc(0.4rem + 1px);\n\n  width: calc(100% + var(--filter-inset));\n  margin-left: calc(-1 * var(--filter-inset));\n  font-size: 0.85rem;\n  padding: 0.2rem 0.4rem;\n}\n\n/* What a dropdown shows is the whole answer, so it must not be cut:\n   half of \"ausgeschlossen\" says nothing, where half a typed word in a\n   text box still does. The column widens to the longest value while\n   the search row is open and shrinks back when it closes. The arrow\n   needs its room on top of that, or it sits on the longest label. */\n.crud-table .filter-row select {\n  min-width: max-content;\n  /* the fixed height of a form select is measured for the form's\n     padding; here the row's own padding has to decide, or the\n     dropdown stands taller than the boxes beside it */\n  height: auto;\n  padding-right: 1.2rem;\n  background-position: right 0.4rem center;\n}\n\n.filter-no-match {\n  color: var(--hs-text-muted);\n  font-size: 0.85rem;\n}\n\n/* totals pseudo row (e.g. summed share counts/amounts) */\n.crud-table tfoot .totals-row td {\n  position: sticky;\n  bottom: 0;\n  background: #fff;\n  font-weight: 600;\n  /* border-collapse does not keep borders sticky — draw it inset */\n  border-top: none;\n  box-shadow: inset 0 2px 0 var(--hs-blue);\n  /* one line, like every other row: how tall this row stands is part\n     of how many rows fit into the box (see `tableChrome` in CrudTable) */\n  white-space: nowrap;\n}\n\n/* master-detail selection */\n.crud-table.selectable tbody tr {\n  cursor: pointer;\n}\n\n.crud-table.selectable tbody tr.selected,\n.crud-table.selectable tbody tr.selected:hover {\n  background: var(--hs-blue-pale);\n}\n\n/* the row under the keyboard says so — drawn inside its own edge, or\n   the scrolled pane would cut the mark off at the first and last row */\n.crud-table.selectable tbody tr:focus-visible {\n  outline: 2px solid var(--hs-blue);\n  outline-offset: -2px;\n}\n\n/* main tables (with a persisted split) own their vertical space; the\n   region wraps the scroll area plus the foot strip below it. The\n   scroll area's height comes from an inline style (ten-row default or\n   the stored split), so the region overrides the fixed CSS max-height.\n\n   No margin above: the page frame already keeps a hand's width there\n   (main and its inner box each add half a line), and every pixel above\n   the table is one the table does not get. */\n.crud-table-region {\n  margin: 0 0 1rem;\n}\n\n/* ---------- paging ---------- */\n\n/*\n * The way from page to page, under the table it belongs to. It reads\n * like the table's own furniture rather than like an action of the\n * page: two discreet arrows and, between them, which rows of how many\n * are on screen.\n */\n.table-pager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin: -0.25rem 0 0.5rem;\n  color: var(--hs-text-muted);\n  font-size: 0.85rem;\n}\n\n/*\n * Below a main table the pager shares its line with the drag handle\n * (see CrudTable): stacked, the two cost 37px of the 488 a phone has\n * for its content — more than half a data row for four pixels of grip.\n *\n * Laid out from the right, so the pager keeps the reading and tab\n * order it has in the markup while the handle takes the rest of the\n * width. `position: relative` is what lets the grip sit on the middle\n * of the table rather than on the middle of the leftover space.\n */\n.table-foot {\n  position: relative;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: stretch;\n  /* room above and below: on Android the table keeps a horizontal\n     scrollbar at its lower edge, and without this the button and the\n     grip sit right on it */\n  padding: 0.4rem 0;\n}\n\n.table-foot .table-pager {\n  margin: 0;\n}\n\n/* the strip runs right to left: the pager keeps the right end, these\n   stand between it and the grip */\n.table-foot-actions {\n  display: flex;\n  align-self: center;\n  gap: 0.5rem;\n  margin: 0 0.75rem;\n}\n\n.table-foot-actions label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4em;\n  white-space: nowrap;\n}\n\n.table-foot-actions input[type='checkbox'] {\n  width: auto;\n  margin: 0;\n}\n\n/* the named action of the list, at the left end of the strip. It is\n   what gives the strip its height — and thereby the grip of the handle\n   the distance from the table's edge that it was missing.\n\n   The float and the left margin are the header icon's, where it lines\n   up beside reload; down here the strip does the placing, and the\n   button starts on the table's own left edge. */\n.table-foot .btn-create {\n  float: none;\n  align-self: center;\n  margin: 0;\n}\n\n/* the written-out count and its short form; the stylesheet picks (see\n   the media query at the end of this section) */\n.table-pager-status .on-narrow {\n  display: none;\n}\n\n.table-pager button {\n  padding: 0.2rem 0.4rem;\n  border: 0;\n  background: none;\n  color: var(--hs-text-muted);\n  line-height: 1;\n  cursor: pointer;\n}\n\n.table-pager button:hover:not(:disabled) {\n  background: none;\n  color: var(--hs-blue);\n}\n\n.table-pager button:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n.table-pager button::before {\n  width: 0.9rem;\n  height: 0.9rem;\n  margin-right: 0;\n}\n\n/* how many rows a page holds: the number itself is the label, so the\n   button says its state the way the language switch does */\n.btn-rows {\n  min-width: 1.9rem;\n  padding: 0.15rem 0.35rem;\n  font-size: 0.8rem;\n  font-variant-numeric: tabular-nums;\n}\n\n/* bi-chevron-left / bi-chevron-right — a page back and on */\n.btn-page-back::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3E%3C/svg%3E\");\n}\n\n.btn-page-on::before {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3E%3C/svg%3E\");\n}\n\n/* where the line is narrow, the written-out count would reach across\n   the middle of the strip and under the grip of the handle */\n@media (max-width: 600px) {\n  .table-pager-status .on-wide {\n    display: none;\n  }\n\n  .table-pager-status .on-narrow {\n    display: inline;\n  }\n\n  /* the same strip, the same reason: the named action steps back to\n     its icon, which is what it is in the table header anyway. What it\n     adds stays in its tooltip and in its label for a screen reader. */\n  .table-foot .btn-create .on-wide {\n    display: none;\n  }\n\n  .table-foot .btn-create {\n    padding: 0.3rem 0.55rem;\n  }\n\n  .table-foot button.btn-create::before {\n    margin-right: 0;\n  }\n}\n\n.crud-table-region .crud-table {\n  margin: 0;\n}\n\n/* horizontal splitter between a main table and the details below:\n   drag to resize, double-click resets to the ten-row default. It takes\n   the width the pager beside it leaves, and at least the height of a\n   line — a wider target is easier to hit with a thumb than the four\n   pixels the grip itself is tall. */\n.crud-splitter {\n  flex: 1;\n  min-height: 12px;\n  cursor: row-resize;\n  touch-action: none;\n}\n\n/* the grip sits on the middle of the table, not on the middle of what\n   is left of the strip: the pager appears and vanishes with the number\n   of pages, and a grip that slid sideways with it would look broken */\n.crud-splitter::before {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 2.5rem;\n  height: 4px;\n  border-radius: 2px;\n  background: var(--hs-border);\n}\n\n.crud-splitter:hover::before,\n.crud-splitter:focus-visible::before {\n  background: var(--hs-blue);\n}\n\n.crud-splitter:focus-visible {\n  outline: none;\n}\n\ntd button {\n  padding: 0.2rem 0.7rem;\n  font-size: 0.85rem;\n}\n\n/* ---------- loading skeleton ---------- */\n\n/* shimmering placeholder bars while table rows load (TableSkeleton) */\n.skeleton-bar {\n  display: inline-block;\n  height: 0.9rem;\n  border-radius: 4px;\n  background: linear-gradient(\n    90deg,\n    var(--hs-border) 25%,\n    var(--hs-bg-subtle) 50%,\n    var(--hs-border) 75%\n  );\n  background-size: 200% 100%;\n  animation: skeleton-shimmer 1.2s linear infinite;\n}\n\n/* header bars shimmer in the header's blue palette */\n.skeleton-table thead .skeleton-bar {\n  background: linear-gradient(\n    90deg,\n    var(--hs-blue-pale) 25%,\n    #fff 50%,\n    var(--hs-blue-pale) 75%\n  );\n  background-size: 200% 100%;\n}\n\n@keyframes skeleton-shimmer {\n  from {\n    background-position: 200% 0;\n  }\n  to {\n    background-position: -200% 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .skeleton-bar {\n    animation: none;\n  }\n}\n\n/* contact/person/partner forms: labelled inputs (and, for persons, a\n   type select). Labels sit left of their field (compact, no wasted\n   space) and align with the top of the widget, never centered.\n\n   The column is the one `.master-data` and `.entity-picker-field` use,\n   down to the gap and the indent: a form mixes plain fields with\n   pickers (the debitor form has four of them), and two label columns a\n   good centimetre apart make every second field look misplaced. */\n#bank-account-form label,\n#booking-item-cancel-form label,\n#booking-item-create-form label,\n#booking-item-resources-form label,\n#contact-form label,\n#hosting-asset-form label,\n#debitor-form label,\n#membership-form label,\n#partner-form label,\n#person-form label,\n.picker-dialog label {\n  display: grid;\n  grid-template-columns: 10rem minmax(0, 1fr);\n  /* the label sits on the line the field writes on: it is a bare text\n     node in the first cell, so there is nothing to pad it into place\n     with — the baseline does it, and does it for every field height */\n  align-items: baseline;\n  gap: 0.35rem 1.5rem;\n  max-width: 34rem;\n  margin: 0.4rem 0;\n  padding-left: 0.75rem;\n  /* and the label reads like one: the same muted, smaller word the\n     detail lists (`.master-data dt`) and the pickers\n     (`.entity-picker-label`) put in that column. A form box whose\n     labels stand darker and larger than those of the box above it —\n     the partner form had exactly that, its \"Details\" beside its\n     \"Kontakt\" — looks like a different kind of thing rather than the\n     next section of the same form. */\n  color: var(--hs-text-muted);\n  font-size: 0.85rem;\n  font-weight: 400;\n}\n\n/* The value is not the label: what is typed keeps the reading size and\n   the full colour of text.\n\n   The calendar hanging under a date field is exempt: its month and its\n   year are fields too, but they are the popup's own furniture and have\n   to keep the widths it gives them — a rule named after the form wins\n   over any of the calendar's, so the calendar has to be named here. */\n#bank-account-form label input:not(.day-picker *),\n#booking-item-cancel-form label input:not(.day-picker *),\n#booking-item-create-form label input:not(.day-picker *),\n#booking-item-create-form label select:not(.day-picker *),\n#booking-item-resources-form label input:not(.day-picker *),\n#booking-item-resources-form label select:not(.day-picker *),\n#hosting-asset-form label input:not(.day-picker *),\n#hosting-asset-form label select:not(.day-picker *),\n#contact-form label input:not(.day-picker *),\n#debitor-form label input:not(.day-picker *),\n#membership-form label input:not(.day-picker *),\n#membership-form label select:not(.day-picker *),\n#partner-form label input:not(.day-picker *),\n#person-form label input:not(.day-picker *),\n#person-form label select:not(.day-picker *),\n.picker-dialog label input:not(.day-picker *),\n.picker-dialog label select:not(.day-picker *) {\n  /* The box is furniture, the text is the value: the field is pulled\n     left by its own border and padding, so what is typed stands on the\n     column line where the plain values of the same detail block stand.\n     The right edge stays put — the width grows by what the margin\n     takes. */\n  width: calc(100% + 0.6rem + 1px);\n  margin-left: calc(-0.6rem - 1px);\n  color: var(--hs-text);\n  font-size: 0.95rem;\n}\n\n/* A field as wide as what goes into it: two digits, three letters, a\n   country code. Stretched across the whole column they promise room\n   that neither the input nor the backend has. */\n#booking-item-create-form label input.short-field,\n#booking-item-resources-form label input.short-field,\n#hosting-asset-form label input.short-field,\n#debitor-form label input.short-field {\n  width: 6rem;\n}\n\n/* Said explicitly because Firefox on Linux writes number inputs\n   right-aligned, GTK spin-button style: these are values in a form\n   column and stand left like every other value */\n#booking-item-create-form label input[type='number'],\n#booking-item-resources-form label input[type='number'] {\n  text-align: left;\n}\n\n/* A checkbox is a value like any other: its name stands in the label\n   column, the box itself at the left edge of the value column, where\n   every other widget starts writing. Only the stretching has to be\n   taken back — a checkbox spread over the whole column would put the\n   clickable square somewhere in the middle of nowhere. */\n#booking-item-create-form label.checkbox-label input,\n#booking-item-resources-form label.checkbox-label input,\n#hosting-asset-form label.checkbox-label input,\n#debitor-form label.checkbox-label input,\n#membership-form label.checkbox-label input,\n#bank-account-form label.checkbox-label input,\n.bank-account-fields label.checkbox-label input {\n  width: auto;\n  max-width: none;\n  justify-self: start;\n  align-self: center;\n  margin: 0;\n}\n\n.entries-editor {\n  width: 100%;\n  max-width: 32rem;\n  margin-bottom: 0.5rem;\n}\n\n.entries-editor td input {\n  width: 100%;\n}\n\ntd input[type='checkbox'] {\n  accent-color: var(--hs-blue);\n  width: 1rem;\n  height: 1rem;\n}\n\n/* ---------- forms ---------- */\n\nfieldset {\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-surface);\n  background: #fff;\n  padding: 1rem 1.25rem;\n  margin: 0 0 1.25rem;\n  max-width: 40rem;\n}\n\nlegend {\n  color: var(--hs-blue);\n  font-weight: 600;\n  padding: 0 0.5rem;\n}\n\nlabel {\n  display: block;\n  margin: 0.5rem 0;\n  font-weight: 500;\n}\n\ninput,\ntextarea,\nselect {\n  display: block;\n  width: 100%;\n  max-width: 30rem;\n  margin-top: 0.25rem;\n  padding: 0.45rem 0.6rem;\n  font: inherit;\n  font-size: 0.95rem;\n  border: 1px solid var(--hs-border);\n  border-radius: var(--hs-radius-control);\n}\n\n/* A native dropdown wears the same arrow as the two built ones (the\n   partner selector and the searchable select): a blue triangle at the\n   right edge with room around it. The browser's own arrow differs per\n   platform and stood tight against the longest option, so the app\n   showed three kinds of dropdown that looked like three widgets. The\n   padding on the right is what keeps the text off the arrow — it is\n   drawn inside the box, not beside it. */\n/* the box itself matches the text inputs: white, and a height that\n   lines up with an input's padding+line-height rather than the taller\n   native control */\nselect {\n  appearance: none;\n  height: calc(1.5em + 0.9rem + 2px);\n  padding-right: 1.6rem;\n  background: #fff\n    url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'%3E%3Cpath fill='%23005094' d='M0 0h10L5 6z'/%3E%3C/svg%3E\")\n    no-repeat right 0.6rem center;\n  /* sized and placed to sit where the ▾ of the built dropdowns sits */\n  background-size: 0.45rem;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n  border-color: var(--hs-blue);\n  box-shadow: 0 0 0 3px var(--hs-blue-pale);\n}\n\n/* A read-only field is a fact, not an offer: without box and field\n   background nothing invites typing — the value stands like it would\n   in a detail list, selectable but visibly hard-wired. The border only\n   turns transparent so the text keeps standing where the editable\n   fields write. */\ninput[readonly] {\n  border-color: transparent;\n  background: transparent;\n  cursor: default;\n}\n\n/* focus stays visible for the keyboard, but without the blue border\n   that says \"type here\" */\ninput[readonly]:focus {\n  border-color: transparent;\n  box-shadow: 0 0 0 3px var(--hs-blue-pale);\n}\n\n/* ---------- footer ---------- */\n\n/* no top margin: the body background would show through the gap as a\n   second gray band above the footer */\nfooter {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.5rem 1rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--hs-border);\n  color: var(--hs-text-muted);\n  font-size: 0.85rem;\n}\n\n/* the frontend build and the one the backend reports, side by side.\n   Wraps for the same reason the links do — two commits with two\n   timestamps are more than a phone is wide. */\n.footer-builds {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.2rem 1rem;\n}\n\n/* the backend build and the button that asks for it again stay one\n   piece, so the button never wraps away from the line it refreshes */\n.build-backend {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  white-space: nowrap;\n}\n\n/* bi-arrow-clockwise, the same glyph the tables reload with — but\n   quieter: borderless and in the muted text colour of the footer,\n   which is no place for a button that asks to be pressed */\n.btn-version-refresh {\n  padding: 0;\n  width: 1rem;\n  height: 1rem;\n  border: 0;\n  background: none;\n  color: inherit;\n  font-size: 0.8rem;\n  vertical-align: -0.1em;\n}\n\n.btn-version-refresh::before {\n  content: '';\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  background-color: currentColor;\n  -webkit-mask: var(--btn-icon) no-repeat center / contain;\n  mask: var(--btn-icon) no-repeat center / contain;\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z'/%3E%3Cpath d='M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z'/%3E%3C/svg%3E\");\n}\n\n.btn-version-refresh:hover:not(:disabled) {\n  color: var(--hs-blue);\n}\n\n/* while the answer is on its way the glyph turns, and it dims: the\n   only feedback a footer has room for */\n.btn-version-refresh:disabled {\n  opacity: 0.5;\n  animation: version-refresh-spin 1s linear infinite;\n}\n\n@keyframes version-refresh-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* wraps rather than pushes: three labels plus the wordmark are wider\n   than a phone, and a footer that overflows scrolls the whole page\n   sideways */\n.footer-links {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.4rem 1rem;\n}\n\n.footer-links a {\n  color: var(--hs-text-muted);\n}\n\n.footer-links a:hover {\n  color: var(--hs-blue);\n}\n\n/* www.hostsharing.net closes the row of footer links with its logo\n   linking home — flame and wordmark, in the one flat grey it uses down\n   there rather than the orange and blue of the topbar. The artwork\n   draws in currentColor (see HostsharingLogo.tsx), so the colour is\n   set here and the height is all the SVG needs to know. */\n.footer-logo {\n  display: flex;\n  color: var(--hs-text-muted);\n}\n\n.footer-logo svg {\n  height: 1.15rem;\n  width: auto;\n}\n\n/* the logo is the link, so hovering it may not recolour text that is\n   not there — it brightens into the brand orange instead */\n.footer-logo:hover {\n  color: var(--hs-orange);\n}\n\n/* --- the way back up ---------------------------------------------- */\n\n/* www.hostsharing.net parks a button in the lower right corner once\n   the page has been scrolled a screen or so. It is an outline like\n   every other button here rather than the filled one the site uses,\n   and the shadow is what lifts it off the content it floats over. */\n.btn-back-to-top {\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z'/%3E%3C/svg%3E\");\n\n  position: fixed;\n  right: 20px;\n  /* the same gap below as beside, and both to the edge of the window\n     rather than to the end of the content: the button used to step up\n     for the footer, which parked it in the middle of the page — where\n     whatever else the corner holds is. On the footer it covers a line\n     of small print that is a scroll away from being read again. The\n     inset is what a phone keeps for itself below the page, the home\n     bar of an iPhone; the browser's own bar sits outside the page and\n     needs nothing here. */\n  bottom: calc(20px + env(safe-area-inset-bottom, 0px));\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  padding: 0;\n  box-shadow: 0 2px 6px rgb(0 0 0 / 20%);\n}\n\n.btn-back-to-top::before {\n  content: '';\n  width: 1.1rem;\n  height: 1.1rem;\n  background-color: currentcolor;\n  -webkit-mask: var(--btn-icon) no-repeat center / contain;\n  mask: var(--btn-icon) no-repeat center / contain;\n}\n\n/* --- a newer release on the server -------------------------------- */\n\n/* A bar below the topbar, not a modal: it must be possible to ignore\n   it and keep working — reloading throws away unsaved input. */\n.update-notice {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem 1rem;\n  margin: 0 1.5rem;\n  padding: 0.6rem 0.9rem;\n  border: 1px solid var(--hs-blue);\n  border-radius: var(--hs-radius-surface);\n  background: #eef4fb;\n  font-size: 0.9rem;\n}\n\n.update-notice-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.update-notice-later {\n  background: none;\n  border-color: var(--hs-border);\n  color: var(--hs-text-muted);\n}\n\n.update-notice-reload {\n  background: var(--hs-blue);\n  border-color: var(--hs-blue);\n  color: #fff;\n}\n\n/* bi-box-seam — the marker that keeps a dismissed hint reachable */\n.btn-update {\n  margin-left: 0.4rem;\n  padding: 0;\n  width: 1.1rem;\n  height: 1.1rem;\n  border: 0;\n  background: none;\n  color: var(--hs-blue);\n  font-size: 0.7rem;\n  vertical-align: -0.15em;\n}\n\n.btn-update::before {\n  content: '';\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  background-color: currentColor;\n  -webkit-mask: var(--btn-icon) no-repeat center / contain;\n  mask: var(--btn-icon) no-repeat center / contain;\n  --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.75.75 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25z'/%3E%3C/svg%3E\");\n}\n\n.btn-update:hover {\n  color: var(--hs-orange);\n}\n\n/* --- overview dashboard ------------------------------------------- */\n\n/* masonry-style via CSS multi-column: cards flow one after another\n   down each column, so differing card heights leave no row gaps */\n.overview-grid {\n  columns: 18rem;\n  column-gap: 1rem;\n}\n\n/* drag-and-drop wrapper around each card; carries the column-flow\n   properties so card and handle move as one piece */\n.overview-card-slot {\n  position: relative;\n  break-inside: avoid;\n  margin-bottom: 1rem;\n}\n\n.overview-card-slot.dragging {\n  opacity: 0.5;\n}\n\n/* where the card would land. A mouse has a cursor to say so, a finger\n   has nothing — and the finger is on the handle, not on the target */\n.overview-card-slot.drop-target {\n  outline: 2px dashed var(--hs-blue);\n  outline-offset: 3px;\n}\n\n.overview-card-slot .drag-handle {\n  position: absolute;\n  top: 0.8rem;\n  right: 1rem;\n  cursor: grab;\n  color: var(--hs-text-muted);\n  user-select: none;\n  /* the handle belongs to the drag, not to the scroll: without this a\n     finger starting here scrolls the page and the card stays put */\n  touch-action: none;\n}\n\n/* a finger covers what it drags, so the target has to be reachable\n   without precision — the handle is the one thing that may not move\n   under it, and a bigger hit area is what makes that comfortable */\n.overview-card-slot .drag-handle::after {\n  content: '';\n  position: absolute;\n  inset: -0.6rem;\n}\n\n.overview-card-slot .drag-handle:hover {\n  color: var(--hs-blue);\n}\n\n/* no frame: the white against the grey around it is the border */\n.overview-card {\n  background: #fff;\n  border-radius: var(--hs-radius-surface);\n  padding: 1rem 1.25rem;\n}\n\n/* www.hostsharing.net lifts a single section out of the stack of white\n   blocks by setting it in the primary blue with white on top of it\n   (`bg-primary text-white`) — that is how its teasers are drawn. Here\n   it marks the card that says what changed: on a dashboard of numbers\n   it is the one thing worth reading before them. It works because it\n   stays the only blue block on the page. */\n.overview-card-accent {\n  background: var(--hs-blue);\n  color: #fff;\n}\n\n.overview-card-accent h2 {\n  color: #fff;\n}\n\n/* the dates keep a step behind the entries they belong to, the way\n   they do on white — a plain white would flatten the two together */\n.overview-card-accent .overview-muted {\n  color: color-mix(in srgb, #fff 72%, var(--hs-blue));\n}\n\n/* A card is a teaser, not a viewport: the entries that do not fit are\n   left off rather than put behind a scrollbar, which on a dashboard\n   card nobody goes looking for. The card shows the newest few and ends\n   in the link to the page that carries them all, the way the site\n   closes its teasers with \"Mehr erfahren\" — named here after what\n   waits behind it: the older news. */\n/* a news entry shows three lines and no more until asked — the card\n   and the greeting dialog share this through WhatsNewList */\n.overview-clamped {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  overflow: hidden;\n}\n\n/* an entry with something to unfold is its own switch: the \"…\" at the\n   cut is drawn by the browser and answers no click, and that is where\n   a reader aims */\n.is-clamp-toggle {\n  cursor: pointer;\n}\n\n/* the offer to unfold, reading like a link rather than a button: it\n   belongs to the text it stands under, not to the card's chrome */\n.overview-clamp-toggle {\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--hs-blue);\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.overview-clamp-toggle:hover {\n  text-decoration: underline;\n}\n\n.overview-more {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0.75rem 0 0;\n  font-size: 0.9rem;\n  /* the way out of the teaser sits where reading ends, not where it\n     begins. On the card the link stands there alone; in the dialog the\n     close button shares the line and takes the left end of it, so that\n     the two ways out of the window read as one row rather than as two\n     offers below one another. */\n  justify-content: flex-end;\n}\n\n.overview-more > button {\n  margin-right: auto;\n}\n\n/* a finger leaves focus behind where a mouse does not: after the tap\n   the link keeps the ring the keyboard needs, and on a phone it reads\n   as a box drawn around the text for no reason. The ring is worth\n   keeping for whoever arrives by Tab, so it is asked for by name. */\n.overview-more a:focus {\n  outline: none;\n}\n\n.overview-more a:focus-visible {\n  outline: 2px solid currentcolor;\n  outline-offset: 2px;\n}\n\n.overview-more a {\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* the link sits on the blue of the accent card, where the blue it\n   wears on white would be unreadable */\n.overview-card-accent .overview-more a {\n  color: #fff;\n}\n\n/* the grey handle would disappear into the blue */\n.overview-card-slot:has(.overview-card-accent) .drag-handle {\n  color: color-mix(in srgb, #fff 72%, var(--hs-blue));\n}\n\n.overview-card-slot:has(.overview-card-accent) .drag-handle:hover {\n  color: #fff;\n}\n\n/* the title of a card names it rather than opening a page, so it takes\n   the weight of a `card-title` on the site instead of the lighter one\n   the section headings carry */\n.overview-card h2 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 0.75rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n}\n\n.overview-card h3 {\n  margin: 0.75rem 0 0.25rem;\n  font-size: 0.95rem;\n}\n\n/* What the card is about, opening its body over the full width: a\n   partner name has no room left beside a label column here, and it is\n   the one value that must not be squeezed. Not a heading — the card\n   already carries one, and this is data. */\n.overview-card .overview-headline {\n  margin: 0 0 0.6rem;\n  font-weight: 600;\n}\n\n/* marks cards rendered from hardwired example data */\n.example-badge {\n  background: var(--hs-blue-pale);\n  color: var(--hs-blue-dark);\n  border-radius: 999px;\n  padding: 0.1rem 0.6rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  cursor: help;\n}\n\n.invoices-notice {\n  margin: 0 0 0.5rem;\n}\n\n.overview-booking-items {\n  margin: 0 0 0.5rem;\n  color: var(--hs-text-muted);\n  font-size: 0.85rem;\n}\n\n.overview-hint {\n  margin: 0.75rem 0 0;\n  color: var(--hs-text-muted);\n  font-size: 0.85rem;\n}\n\n.resource-row {\n  display: grid;\n  grid-template-columns: 4rem 1fr auto;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0.25rem 0;\n  font-size: 0.85rem;\n}\n\n.resource-bar {\n  display: block;\n  height: 0.5rem;\n  border-radius: 999px;\n  background: var(--hs-bg-subtle);\n  border: 1px solid var(--hs-border);\n  overflow: hidden;\n}\n\n.resource-bar-fill {\n  display: block;\n  height: 100%;\n  background: var(--hs-blue);\n}\n\n.resource-value {\n  color: var(--hs-text-muted);\n  white-space: nowrap;\n}\n\n.overview-links {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.overview-links li {\n  margin: 0.35rem 0;\n}\n\n/* a bookmark row: which area it leads into, the record, and what one\n   can do to the row — pushed to the right edge so the rows read as a\n   list of links and not as a list of buttons */\n.bookmark-row {\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n}\n\n/* The area is marked with the icon the sidebar marks its entry with,\n   rather than written out: the word said the same thing in every row\n   and took the room the record needs. The glyph comes from the very\n   rule the menu uses (see the nav-* icons above), so the two cannot\n   drift apart — only smaller here, and without the entry around it. */\n.bookmark-area {\n  flex: none;\n  color: var(--hs-text-muted);\n  font-size: 0.8rem;\n  /* the row spaces its parts; the gap the icons keep to their label in\n     the menu would come on top of it */\n  line-height: 1;\n}\n\n.bookmark-area::before {\n  margin-right: 0;\n}\n\n/* the name takes what the row has left, so a long one wraps inside its\n   own box instead of pushing the mark behind it around */\n.bookmark-name {\n  flex: 1;\n  min-width: 0;\n}\n\n/* What one can do to the row, at its right edge and in one group: the\n   uuid to the clipboard and the row off the list. Both are the plain\n   icon buttons of the tables and the detail views — the copy raised\n   and frameless beside the name made the list restless, and it is no\n   less an action than its neighbour. The group holds its place whether\n   or not the uuids are switched on. */\n.bookmark-actions {\n  flex: none;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin-left: auto;\n  /* beside the first line of the name, not in the middle of a name\n     that wrapped over four of them */\n  align-self: flex-start;\n}\n\n/* www.hostsharing.net puts a chevron behind every link that leads on\n   (`bi-chevron-right` after \"Mehr erfahren\"), which is what tells a\n   link out of a card apart from a word merely printed in blue. It goes\n   on the card titles and the link lists, both of which leave the\n   dashboard for a page of their own — not on the sidebar or the\n   footer, where every entry is a link anyway and a row of chevrons\n   would only be noise. The mark is masked rather than painted so it\n   takes the colour of its link, the orange on hover included. */\n.overview-card h2 a::after,\n.overview-links a::after,\n.overview-more a::after {\n  --chevron: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E\");\n\n  content: '';\n  display: inline-block;\n  width: 0.65em;\n  height: 0.65em;\n  margin-left: 0.35em;\n  vertical-align: -0.02em;\n  background-color: currentcolor;\n  -webkit-mask: var(--chevron) center / contain no-repeat;\n  mask: var(--chevron) center / contain no-repeat;\n}\n\n.overview-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-size: 0.9rem;\n}\n\n.overview-list li {\n  margin: 0.4rem 0;\n}\n\n.overview-muted {\n  color: var(--hs-text-muted);\n  font-size: 0.85rem;\n}\n\n.notice-meta {\n  display: block;\n}\n\n/* the page behind the card, one group per day: the heading belongs to\n   the entries below it, so the air goes between the groups */\n.whats-new-day + .whats-new-day {\n  margin-top: 1.5rem;\n}\n\n.whats-new-day h2 {\n  margin: 0 0 0.4rem;\n  font-size: 1.05rem;\n}\n\n/* the notice priority colors its kind label (Wartung/Termin/Info) */\n.notice-kind {\n  font-weight: 600;\n}\n\n.notice-high .notice-kind {\n  color: var(--hs-danger);\n}\n\n.notice-medium .notice-kind {\n  color: var(--hs-orange);\n}\n\n.domain-row {\n  display: flex;\n  align-items: baseline;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n}\n\n.status-dot {\n  display: inline-block;\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 50%;\n  align-self: center;\n}\n\n.status-ok {\n  background: var(--hs-blue);\n}\n\n.status-expiring {\n  background: var(--hs-orange);\n}\n\n/* --- small screens (phones) ---------------------------------------- */\n\n@media (max-width: 768px) {\n  /* anchor for the sidebar overlay below */\n  .app-shell {\n    position: relative;\n  }\n\n  /* the opened sidebar overlays the content instead of squeezing it;\n     collapsed it stays the narrow in-flow rail */\n  .app-sidebar.is-open {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 20;\n    overflow-y: auto;\n    box-shadow: 4px 0 12px rgba(0, 0, 0, 0.15);\n  }\n\n  /* collapsed there is no rail at all — just a hamburger button\n     floating left of the page title */\n  .app-sidebar:not(.is-open) {\n    position: absolute;\n    top: 0.3rem;\n    left: 0.25rem;\n    width: auto;\n    padding: 0;\n    border-right: none;\n    background: none;\n  }\n\n  /* and therefore no room for the icon rail either: a column of icons\n     below that button would float over the content it covers */\n  .app-sidebar .nav-rail {\n    display: none;\n  }\n\n  /* bi-list replaces the » glyph (hidden via font-size).\n\n     Collapsed, this button floats over the page instead of sitting in\n     the menu, so it stays a bare icon in both states. Two reasons, and\n     both bit us: on a touch device :hover sticks after a tap, so a\n     filled background lingered long after the menu had folded away —\n     and since the generic `button:hover` fills with the very blue the\n     icon was painted in (equal specificity, but it comes later in this\n     file, so it wins over `.app-sidebar button:hover`), the icon\n     vanished into its own background: a blue rounded square. */\n  .app-sidebar:not(.is-open) > button,\n  .app-sidebar:not(.is-open) > button:hover {\n    font-size: 0;\n    padding: 0.5rem;\n    background: none;\n    color: var(--hs-blue);\n  }\n\n  .app-sidebar:not(.is-open) > button:hover {\n    color: var(--hs-blue-dark);\n  }\n\n  .app-sidebar:not(.is-open) > button::before {\n    content: '';\n    display: block;\n    width: 1.4rem;\n    height: 1.4rem;\n    /* like every other masked icon: follow the button's own colour\n       rather than hardwiring one that a background may match */\n    background-color: currentColor;\n    -webkit-mask: var(--btn-icon) no-repeat center / contain;\n    mask: var(--btn-icon) no-repeat center / contain;\n    --btn-icon: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z'/%3E%3C/svg%3E\");\n  }\n\n  /* topbar: logo icon only, wrap instead of overflowing */\n  #root > nav {\n    flex-wrap: wrap;\n    padding: 0.5rem 0.75rem;\n  }\n\n  #root > nav::before {\n    content: 'HSAdmin';\n  }\n\n  /* the topbar links shrink to icons (labels hidden via font-size,\n     so they keep their accessible names); separators disappear */\n  .topbar-sep {\n    display: none;\n  }\n\n  /* the width toggle has nothing to offer here: a phone screen is\n     narrower than the readable width anyway, so both of its settings\n     look the same — while the button itself took the room that made\n     the topbar wrap into a second line */\n  .width-toggle {\n    display: none;\n  }\n\n  #root > nav a.topbar-link {\n    font-size: 0;\n    padding: 0.25rem;\n  }\n\n  /* the label is gone, so the icon becomes the whole link: bigger,\n     and without the gap that used to hold the label */\n  #root > nav a.topbar-link::before {\n    display: block;\n    width: 1.3rem;\n    height: 1.3rem;\n    margin-right: 0;\n  }\n\n  /* The named buttons of a page give up their word the same way: on a\n     screen this narrow the symbol is what there is room for, and a row\n     of three spelt-out actions is what pushed the page wider than the\n     window. The label stays in the markup, so it is still what the\n     button is read out as — only its size goes.\n     Dialogs keep their words: a question that has to be answered may\n     not be answered by two symbols. */\n  .app-content .form-actions button:not(dialog *) {\n    font-size: 0;\n    padding: 0.45rem 0.55rem;\n  }\n\n  /* The icon carries the button now, so it is sized in its own right\n     rather than in an em of a font that is no longer there — an em\n     would be nothing at all. The content area is named in front so\n     that this outweighs the rules which give a single kind of button\n     its icon size (`button[type='submit'][form]`, two attributes and\n     an element, counts for more than a class and two elements). */\n  .app-content .form-actions button:not(dialog *)::before {\n    width: 1.05rem;\n    height: 1.05rem;\n    margin-right: 0;\n  }\n\n  /* one cycle button instead of a button per language — every tap\n     advances to the next language */\n  .language-switcher .language-choice {\n    display: none;\n  }\n\n  .language-switcher .language-cycle {\n    display: inline-block;\n  }\n\n  /* On a smartphone the window is the frame, so the border around the\n     content goes — both halves of it. The grey gutter keeps only the\n     strip above and below, enough that the white block does not grow\n     into the topbar and the footer; the block itself gives up the\n     inset it holds its content in. What is left of a screen that\n     narrow is needed by the tables, and every part that has to keep\n     its distance carries one of its own (a notice its frame, a card\n     its padding, a table its cells). */\n  .app-content > main {\n    padding: 0.5rem 0;\n  }\n\n  /* The block keeps one narrow inset, the same on every page: without\n     it the content sits on the glass and reads as cramped, and a table\n     that begins at the very edge looks unfinished rather than wide.\n     Twelve pixels are enough to see it is a page and little enough to\n     leave the width to the content. */\n  .app-content > main > * {\n    padding: 0.5rem 0.75rem;\n  }\n\n  /* the left padding makes room for the floating menu button */\n  .app-content > header {\n    padding: 0.5rem 0.75rem 0.5rem 3rem;\n  }\n\n  #root > div:not(.app-shell):not(.update-notice) {\n    padding: 0.5rem 0.75rem;\n  }\n\n  .update-notice {\n    margin: 0 0.75rem;\n  }\n\n  footer {\n    padding: 0.75rem;\n  }\n\n  /* stack labels above their values/inputs instead of beside them */\n  .master-data {\n    grid-template-columns: 1fr;\n    gap: 0 0;\n  }\n\n  .master-data dd {\n    margin-bottom: 0.35rem;\n  }\n\n  #bank-account-form label,\n  #booking-item-cancel-form label,\n  #booking-item-create-form label,\n  #booking-item-resources-form label,\n  #contact-form label,\n  #hosting-asset-form label,\n  #debitor-form label,\n  #membership-form label,\n  #partner-form label,\n  #person-form label,\n  .picker-dialog label {\n    grid-template-columns: 1fr;\n    gap: 0.15rem;\n  }\n\n  /* a day is picked with a thumb here: the cells are as tall as they\n     are wide, which is what the finger needs and what the calendar has\n     room for */\n  .day-picker-grid button {\n    padding: 0.55rem 0;\n  }\n}\n\n.startup-error {\n  max-width: 36rem;\n  margin: 4rem auto;\n  padding: 1.5rem;\n  border: 1px solid color-mix(in srgb, var(--hs-danger) 30%, #fff);\n  border-left: 4px solid var(--hs-danger);\n  border-radius: var(--hs-radius-surface);\n  background: color-mix(in srgb, var(--hs-danger) 5%, #fff);\n}\n\n.startup-error-cause {\n  margin: 1rem 0 0;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--hs-radius-surface);\n  background: color-mix(in srgb, var(--hs-text) 6%, #fff);\n  font-size: 0.85rem;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.bank-account-issue:first-child {\n  margin: 0 0.4em 0 0;\n}\n\n/* the status and the button that changes it, apart enough to read as two */\n.vat-id-verification {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 1.25rem;\n}\n\n.bank-directory-runs {\n  margin: 0.25rem 0 1rem;\n  padding-left: 1.25rem;\n}\n\n/* a checkbox whose text is too long for the label column: box and\n   text share the value column, the label column stays empty */\n.bank-account-fields label.checkbox-text-after > span:last-child {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* the bank of the IBAN typed, under the field in the value column:\n   the label's indent, label column and gap */\n.bank-account-fields .bank-of-iban {\n  max-width: 34rem;\n  margin: -0.2rem 0 0.4rem calc(0.75rem + 10rem + 1.5rem);\n  color: var(--hs-text-muted);\n  font-size: 0.85rem;\n}\n\n.bank-account-fields .bank-of-iban:empty {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
